<template>
  <div id="Meeting">
    <Navbar :booking="items" :setorders="orders" />
    
    <!--  -->
    <!-- <input class="chat-menu hidden" id="offchat-menu" type="checkbox" />
    <div class="sticky-button" id="sticky-button">
      <label for="offchat-menu">
        <svg class="chat-icon" viewBox="0 0 24 24">
          <path
            d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2M12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15C10.56 20.15 9.11 19.76 7.85 19L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 15 3.8 13.47 3.8 11.91C3.81 7.37 7.5 3.67 12.05 3.67M8.53 7.33C8.37 7.33 8.1 7.39 7.87 7.64C7.65 7.89 7 8.5 7 9.71C7 10.93 7.89 12.1 8 12.27C8.14 12.44 9.76 14.94 12.25 16C12.84 16.27 13.3 16.42 13.66 16.53C14.25 16.72 14.79 16.69 15.22 16.63C15.7 16.56 16.68 16.03 16.89 15.45C17.1 14.87 17.1 14.38 17.04 14.27C16.97 14.17 16.81 14.11 16.56 14C16.31 13.86 15.09 13.26 14.87 13.18C14.64 13.1 14.5 13.06 14.31 13.3C14.15 13.55 13.67 14.11 13.53 14.27C13.38 14.44 13.24 14.46 13 14.34C12.74 14.21 11.94 13.95 11 13.11C10.26 12.45 9.77 11.64 9.62 11.39C9.5 11.15 9.61 11 9.73 10.89C9.84 10.78 10 10.6 10.1 10.45C10.23 10.31 10.27 10.2 10.35 10.04C10.43 9.87 10.39 9.73 10.33 9.61C10.27 9.5 9.77 8.26 9.56 7.77C9.36 7.29 9.16 7.35 9 7.34C8.86 7.34 8.7 7.33 8.53 7.33Z"
          />
        </svg>
        <svg class="close-icon" viewBox="0 0 512 512">
          <path
            d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
          />
        </svg>
      </label>
    </div>
    <div class="sticky-chat">
      <div class="chat-content">
        <div class="chat-header">
          <svg viewBox="0 0 32 32">
            <path
              d="M24,22a1,1,0,0,1-.64-.23L18.84,18H17A8,8,0,0,1,17,2h6a8,8,0,0,1,2,15.74V21a1,1,0,0,1-.58.91A1,1,0,0,1,24,22ZM17,4a6,6,0,0,0,0,12h2.2a1,1,0,0,1,.64.23L23,18.86V16.92a1,1,0,0,1,.86-1A6,6,0,0,0,23,4Z"
            />
            <rect height="2" width="2" x="19" y="9"></rect>
            <rect height="2" width="2" x="14" y="9"></rect>
            <rect height="2" width="2" x="24" y="9"></rect>
            <path
              d="M8,30a1,1,0,0,1-.42-.09A1,1,0,0,1,7,29V25.74a8,8,0,0,1-1.28-15,1,1,0,1,1,.82,1.82,6,6,0,0,0,1.6,11.4,1,1,0,0,1,.86,1v1.94l3.16-2.63A1,1,0,0,1,12.8,24H15a5.94,5.94,0,0,0,4.29-1.82,1,1,0,0,1,1.44,1.4A8,8,0,0,1,15,26H13.16L8.64,29.77A1,1,0,0,1,8,30Z"
            />
          </svg>
          <div class="title">
            Silakan chat dengan tim kami
            <span>Admin akan merespon dalam beberapa menit</span>
          </div>
        </div>
        <div class="chat-text">
          <span>Halo, ada yang bisa kami bantu?</span>
          <span class="typing">
            <svg viewBox="0 0 512 512">
              <circle cx="256" cy="256" r="48"></circle>
              <circle cx="416" cy="256" r="48"></circle>
              <circle cx="96" cy="256" r="48"></circle>
            </svg>
          </span>
        </div>
      </div>
      <a
        class="chat-button"
        href="https://api.whatsapp.com/send?phone=6281285528669"
        rel="nofollow noreferrer"
        target="_blank"
      >
        <span>Ketik pesan</span>
        <svg viewBox="0 0 32 32">
          <path
            d="M19.47,31a2,2,0,0,1-1.8-1.09l-4-7.57a1,1,0,0,1,1.77-.93l4,7.57L29,3.06,3,12.49l9.8,5.26,8.32-8.32a1,1,0,0,1,1.42,1.42l-8.85,8.84a1,1,0,0,1-1.17.18L2.09,14.33a2,2,0,0,1,.25-3.72L28.25,1.13a2,2,0,0,1,2.62,2.62L21.39,29.66A2,2,0,0,1,19.61,31Z"
          />
        </svg>
      </a>
    </div> -->

    <!-- end -->
    <!-- <div class="loykrathong-triangle-line-left">
          <div class="green"> </div>
          <div class="orange"></div>
          <div class="purple"> </div>
          
          <div class="dark-blue"></div>
          <div class="red"></div>
          <div class="sky-blue"></div>
          <div class="green"> </div>
          <div class="dark-blue"></div>
          <div class="yellow"></div>
          <div class="orange"></div>
          <div class="purple"> </div>
          <div class="red"></div>
          <div class="green-baby"></div>
          <div class="sky-blue"></div>
    </div> -->
    <div class="space"></div>

    <div class="container-fluid">
      <div class="calendar-list">
        <div class="card card-order-list card-margin shadow-sm border-light">
          <div class="card-body">
            <div class="container">
              <div class="">
                <h4 class="">
                  {{ choosedDay2.dateFormat | moment }}
                </h4>
              </div>
              <!-- rgb(238, 33, 119) -->
              <!-- rgb(150, 0, 0, .1) -->
              <vue-horizontal-calendar
                choosedDate:dateTime
                v-on:change="dateChange2"
                lang="en"
                choosedItemColor="
                rgb(255,95,45)"
                todayItemColor="rgb(150, 0, 0, .1)"
                :minDate="dateTime"
              ></vue-horizontal-calendar>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>

    <!-- แก้ไขเปลี่ยนโชว์ปุ่ม พร้อมอัพเดทสภถานะว่า มีการจองแล้ง Disable button -->
    <b-container class="bv-example-row">
      <!-- <br /> -->

      <!-- <b-card no-body class="border-0" >
        <b-tabs pills card content-class="mt-3" class="shadow">
          <b-tab title="ห้องศึกษากลุ่มย่อย" active
            >
          
          </b-tab>
          <b-tab title="ห้องสตูดิโอ"
            ><b-card-text>Tab contents 2</b-card-text></b-tab
          >
          <b-tab title="ห้องบันทึกเสียง"
            ><b-card-text>Tab contents 2</b-card-text></b-tab
          >
        </b-tabs>
      </b-card> -->
      <!-- content-class="mt-3"
        justified -->
      <b-tabs :title-item-class="'tab-title-class'">
        <b-tab title="ห้องศึกษากลุ่มย่อย">
          <!-- Main -->
          <span v-if="!status_show">
            <b-row>
              <div class="container">
                <br />
                <div class="card-columns">
                  <div
                    class="card-room"
                    v-for="(item, index) in status_room"
                    :key="index"
                  >
                    <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ MAIN +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
                    <!-- ================================================ Teacher ==================================== -->

                    <span v-if="!isShowstaff">
                      <!-- <span v-if="item.room_id == 1 || item.room_id == 2"> -->
                      <div class="card-input">
                        <!-- v-if="item.status === 0 && item.freetimes.length !== 0" -->
                        <div
                          class="card card-order-list card-margin border-0 shadow-lg"
                          v-if="
                            item.room_id === 1 ||
                            item.room_id === 2 ||
                            item.room_id === 3 ||
                            item.room_id === 4 ||
                            item.room_id === 5 ||
                            item.room_id === 6 ||
                            item.room_id === 7
                          "
                        >
                          <div class="card-body">
                            <div class="row">
                              <div class="col-md-2 text-left">
                                <h6>{{ item.room_name }}</h6>

                                <img
                                  v-if="item.room_id === 1"
                                  src="../../assets/meetingrooms/2A.jpeg"
                                  alt=""
                                  class="zoom"
                                />

                                <img
                                  v-if="item.room_id === 2"
                                  src="../../assets/meetingrooms/2B.jpeg"
                                  alt=""
                                  class="zoom"
                                />
                                <img
                                  v-if="item.room_id === 3"
                                  src="../../assets/meetingrooms/3A.jpeg"
                                  alt=""
                                  class="zoom"
                                />
                                <img
                                  v-if="item.room_id === 4"
                                  src="../../assets/meetingrooms/3B.jpeg"
                                  alt=""
                                  class="zoom"
                                />
                                <img
                                  v-if="item.room_id === 5"
                                  src="../../assets/meetingrooms/4A.jpeg"
                                  alt=""
                                  class="zoom"
                                />
                                <img
                                  v-if="item.room_id === 6"
                                  src="../../assets/meetingrooms/4B.jpeg"
                                  alt=""
                                  class="zoom"
                                />
                                <img
                                  v-if="item.room_id === 7"
                                  src="../../assets/meetingrooms/5C.jpeg"
                                  alt=""
                                  class="zoom"
                                />

                                <!--  -->
                              </div>

                              <div class="col-md-10 text-left">
                                <br />
                                <span class="text-secondary">
                                  **เลือกช่วงเวลาเพื่อจอง
                                  <div class="space"></div>
                                </span>
                                <div class="time-column">
                                  <span
                                    v-if="
                                      item.status === 1 ||
                                      (item.status === 0 &&
                                        item.freetimes.length === 0)
                                    "
                                  >
                                    <b-button
                                      pill
                                      variant="outline-secondary"
                                      disabled
                                      class="b-between"
                                    >
                                      08:30-12:00
                                    </b-button>

                                    <b-button
                                      pill
                                      variant="outline-secondary"
                                      disabled
                                      class="b-between"
                                    >
                                      13:00-16:00
                                    </b-button>
                                  </span>

                                  <span
                                    v-for="(prod, j) of item.freetimes"
                                    :key="j"
                                  >
                                    <b-button
                                      v-if="
                                        item.freetimes.length === 1 &&
                                        item.status === 0 &&
                                        prod.time_begin === '13:00'
                                      "
                                      pill
                                      variant="outline-secondary"
                                      disabled
                                      class="b-between"
                                    >
                                      08:30-12:00
                                    </b-button>

                                    <b-button
                                      pill
                                      v-if="
                                        prod.time_begin !== '08:30' ||
                                        prod.time_end !== '16:30'
                                      "
                                      variant="outline-pink"
                                      v-b-modal="
                                        'modal-meetingAnother' +
                                        item.room_id +
                                        prod.time_id
                                      "
                                      class="b-between"
                                      @click="getUsefor(item.room_id)"
                                    >
                                      {{ prod.time_begin }}-{{ prod.time_end }}
                                    </b-button>
                                    <span
                                      v-for="(timechkuser, iu) in historyall"
                                      :key="iu"
                                    >
                                      <b-button
                                        pill
                                        v-if="
                                          timechkuser.room_id ===
                                            item.room_id &&
                                          timechkuser.time_begin === '13:00' &&
                                          timechkuser.time_begin !==
                                            prod.time_begin &&
                                          item.freetimes.length === 1
                                        "
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        13:00-16:30
                                      </b-button>
                                    </span>

                                    <b-modal
                                      :hide-footer="true"
                                      centered
                                      size="lg"
                                      :id="
                                        'modal-meetingAnother' +
                                        item.room_id +
                                        prod.time_id
                                      "
                                      header-border-variant="white"
                                      class="border-bottom-0"
                                      v-if="chkbookingroom"
                                    >
                                      <template #modal-title>
                                        <div
                                          class="card card-order-list card-margin shadow border-light"
                                        >
                                          <div class="card-body">
                                            <i class="fa-solid fa-bookmark"></i>
                                            ห้อง {{ item.room_name }} เวลาจอง
                                            {{ prod.time_begin }} -
                                            {{ prod.time_end }}
                                          </div>
                                        </div>
                                      </template>

                                      <div
                                        class="card card-order-list card-margin shadow border-light"
                                      >
                                        <div class="card-body">
                                          <form
                                            class="form-group"
                                            @submit.prevent="
                                              bookingAnother(
                                                item.room_id,
                                                prod.time_begin,
                                                prod.time_end,
                                                prod.time_id,
                                                'modal-meetingAnother' +
                                                  item.room_id +
                                                  prod.time_id
                                              )
                                            "
                                          >
                                            <p style="color: blue">
                                              *หมายเหตุ :
                                              กรุณาเลือกวัตุประสงค์การใช้งาน
                                            </p>

                                            <b-form-select
                                              v-model="selected"
                                              :options="options"
                                              class="mb-3"
                                              value-field="usefor_id"
                                              text-field="usefor_name"
                                              disabled-field="notEnabled"
                                            >
                                              <template #first>
                                                <b-form-select-option
                                                  :value="null"
                                                  disabled
                                                  >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                >
                                              </template>
                                            </b-form-select>
                                            <span
                                              style="
                                                color: red;
                                                font-weight: bold;
                                              "
                                              v-if="
                                                error != '' || error === null
                                              "
                                            >
                                              ERROR : {{ error }}
                                              <br />
                                              <br />
                                            </span>
                                            <input
                                              type="text"
                                              class="form-control input-style"
                                              placeholder="กรอกวัตถุประสงค์"
                                              v-model="input_another"
                                              v-if="
                                                selected === 7 ||
                                                selected === 13 ||
                                                selected === 16
                                              "
                                            />
                                            <!-- :disabled="!isComplete" -->
                                            <button
                                              :disabled="!isCompleteTeach"
                                              type="submit"
                                              class="btn btn-purple deep-purple btn-block badge-pill"
                                              data-dismiss="modal"
                                              @click="showModal = false"
                                            >
                                              ยืนยัน
                                            </button>
                                          </form>
                                        </div>
                                      </div>
                                    </b-modal>

                                    <b-modal
                                      :hide-footer="true"
                                      :hide-header="true"
                                      centered
                                      size="lg"
                                      :id="
                                        'modal-meetingAnother' +
                                        item.room_id +
                                        prod.time_id
                                      "
                                      header-border-variant="white"
                                      class="border-bottom-0"
                                      v-if="!chkbookingroom"
                                    >
                                      <div
                                        class="card-body justify-content-center card-block p-3 text-center text-danger"
                                      >
                                        <h5>
                                          <i
                                            class="fa-solid fa-circle-exclamation"
                                          ></i>
                                          {{ msgbookingroom }}
                                        </h5>
                                      </div>
                                    </b-modal>
                                  </span>
                                </div>

                                <br />
                                <span
                                  style="color: gray"
                                  v-if="
                                    item.room_id === 1 ||
                                    item.room_id === 2 ||
                                    item.room_id === 3 ||
                                    item.room_id === 4 ||
                                    item.room_id === 5 ||
                                    item.room_id === 6
                                  "
                                >
                                  <!-- &nbsp;
                                  อุปกรณ์ : รีโมทแอร์ รีโมทจอมอนิเตอร์
                                  แปรงลบกระดาน ปากกาไวท์บอร์ด -->
                                  <b-button
                                    pill
                                    variant="outline-primary"
                                    class="b-between"
                                    v-if="!showAcc[index]"
                                    @click="showAccessoriesMore(index)"
                                    size="sm"
                                  >
                                    อุปกรณ์
                                  </b-button>
                                  <b-button
                                    pill
                                    variant="outline-danger"
                                    class="b-between"
                                    v-if="showAcc[index]"
                                    @click="showAccessoriesLess(index)"
                                    size="sm"
                                  >
                                    ปิด
                                  </b-button>
                                  <br />
                                </span>
                                <span
                                  style="color: gray"
                                  v-if="item.room_id === 7"
                                >
                                  <!-- อุปกรณ์ -->
                                  <b-button
                                    pill
                                    variant="outline-primary"
                                    class="b-between"
                                    v-if="!showAcc[index]"
                                    @click="showAccessoriesMore(index)"
                                    size="sm"
                                  >
                                    อุปกรณ์
                                  </b-button>
                                  <b-button
                                    pill
                                    variant="outline-danger"
                                    class="b-between"
                                    v-if="showAcc[index]"
                                    @click="showAccessoriesLess(index)"
                                    size="sm"
                                  >
                                    ปิด
                                  </b-button>
                                  <br />

                                  <!-- End -->
                                </span>
                              </div>
                            </div>
                            <!-- 2A -->
                            <span style="color: gray" v-if="item.room_id === 1">
                              <!-- &nbsp;อุปกรณ์ : รีโมทแอร์ รีโมทจอมอนิเตอร์
                                แปรงลบกระดาน ปากกาไวท์บอร์ด -->
                              <br />
                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                  <!-- 2 -->

                                  <!-- 3 -->

                                  <!-- 4 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-wb.png"
                                            alt=""
                                            width="36"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ปากกาไวท์บอร์ด </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!--  -->
                                  <!-- 5 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>&nbsp;&nbsp; HDMI </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 6 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/img/acc-bwb.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ไวท์บอร์ด [whiteboard] </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/meetingrooms/tv.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> จอมอนิเตอร์ </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->

                                  <!-- end -->
                                </div>
                              </span>
                            </span>
                            <!-- END -->
                            <!-- 2B -->

                            <span style="color: gray" v-if="item.room_id === 2">
                              <!-- &nbsp;อุปกรณ์ : -->
                              <!-- อุปกรณ์ -->

                              <br />

                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                  <!-- 2 -->

                                  <!-- 3 -->

                                  <!-- 4 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-wb.png"
                                            alt=""
                                            width="36"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ปากกาไวท์บอร์ด </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!--  -->
                                  <!-- 5 -->

                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/img/acc-bwb.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ไวท์บอร์ด [whiteboard] </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/meetingrooms/tv.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> จอมอนิเตอร์ </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->

                                  <!-- end -->
                                </div>
                              </span>
                              <!-- End -->
                            </span>

                            <!-- END -->

                            <!-- 3A -->
                            <span style="color: gray" v-if="item.room_id === 3">
                              <!-- &nbsp;อุปกรณ์ : -->
                              <!-- อุปกรณ์ -->

                              <br />

                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                  <!-- 2 -->

                                  <!-- 3 -->

                                  <!-- 4 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-wb.png"
                                            alt=""
                                            width="36"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ปากกาไวท์บอร์ด </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!--  -->
                                  <!-- 5 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>&nbsp;&nbsp; HDMI </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 6 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/img/acc-bwb.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ไวท์บอร์ด [whiteboard] </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/meetingrooms/tv.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> จอมอนิเตอร์ </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->

                                  <!-- end -->
                                </div>
                              </span>
                              <!-- End -->
                            </span>

                            <!-- END -->

                            <!-- 3B -->
                            <span style="color: gray" v-if="item.room_id === 4">
                              <!-- &nbsp;อุปกรณ์ : -->
                              <!-- อุปกรณ์ -->

                              <br />

                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                  <!-- 2 -->

                                  <!-- 3 -->

                                  <!-- 4 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-wb.png"
                                            alt=""
                                            width="36"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ปากกาไวท์บอร์ด </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!--  -->
                                  <!-- 5 -->
                                  <!-- <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              HDMI 
                                            </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div> -->
                                  <!-- end -->
                                  <!-- 6 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/img/acc-bwb.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ไวท์บอร์ด [whiteboard] </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/meetingrooms/tv.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> จอมอนิเตอร์ </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->

                                  <!-- end -->
                                  <!-- 8 -->

                                  <!-- end -->
                                </div>
                              </span>
                              <!-- End -->
                            </span>

                            <!-- END -->

                            <!-- 4A -->
                            <span style="color: gray" v-if="item.room_id === 5">
                              <!-- &nbsp;อุปกรณ์ : -->
                              <!-- อุปกรณ์ -->

                              <br />

                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                  <!-- 2 -->

                                  <!-- 3 -->

                                  <!-- 4 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-wb.png"
                                            alt=""
                                            width="36"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ปากกาไวท์บอร์ด </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!--  -->
                                  <!-- 5 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> &nbsp;&nbsp;HDMI </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 6 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/img/acc-bwb.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ไวท์บอร์ด [whiteboard] </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/meetingrooms/tv.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> จอมอนิเตอร์ </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->

                                  <!-- end -->
                                </div>
                              </span>
                              <!-- End -->
                            </span>

                            <!-- END -->

                            <!-- 4B -->
                            <span style="color: gray" v-if="item.room_id === 6">
                              <!-- &nbsp;อุปกรณ์ : -->
                              <!-- อุปกรณ์ -->

                              <br />

                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                  <!-- 2 -->

                                  <!-- 3 -->

                                  <!-- 4 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-wb.png"
                                            alt=""
                                            width="36"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ปากกาไวท์บอร์ด </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!--  -->
                                  <!-- 5 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> &nbsp;&nbsp;HDMI </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 6 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/img/acc-bwb.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;ไวท์บอร์ด [whiteboard]
                                          </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/meetingrooms/tv.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> จอมอนิเตอร์ </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->

                                  <!-- end -->
                                </div>
                              </span>
                              <!-- End -->
                            </span>

                            <!-- END -->

                            <!-- 5A -->

                            <span style="color: gray" v-if="item.room_id === 7">
                              <!-- &nbsp;อุปกรณ์ : -->
                              <!-- อุปกรณ์ -->

                              <br />

                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-bwb.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ไวท์บอร์ด [whiteboard] </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 2 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-pro.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> โปรเจคเตอร์ [projector] </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 3 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-mic.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp; ไมค์โครโฟน [microphone]
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                </div>
                              </span>
                              <!-- End -->
                            </span>
                            <!-- END -->
                          </div>
                          <!-- <hr /> -->
                        </div>
                      </div>
                      <!-- </span> -->
                    </span>
                    <!-- ================================================ End Teacher ================================ -->

                    <!-- ================================================ Student  ====================================-->
                    <span v-if="isShowstaff">
                      <div class="card-input">
                        <div
                          class="card card-order-list card-margin border-0 shadow-sm"
                          v-if="
                            item.room_id === 1 ||
                            item.room_id === 2 ||
                            item.room_id === 3 ||
                            item.room_id === 4 ||
                            item.room_id === 5 ||
                            item.room_id === 6 ||
                            item.room_id === 7
                          "
                        >
                          <div class="card-body">
                            <div class="row">
                              <div class="col-md-2 text-left">
                                <h6>{{ item.room_name }}</h6>

                                <!-- meeting -->
                                <img
                                  v-if="item.room_id === 1"
                                  src="../../assets/meetingrooms/2A.jpeg"
                                  alt=""
                                  class="zoom"
                                />

                                <img
                                  v-if="item.room_id === 2"
                                  src="../../assets/meetingrooms/2B.jpeg"
                                  alt=""
                                  class="zoom"
                                />
                                <img
                                  v-if="item.room_id === 3"
                                  src="../../assets/meetingrooms/3A.jpeg"
                                  alt=""
                                  class="zoom"
                                />
                                <img
                                  v-if="item.room_id === 4"
                                  src="../../assets/meetingrooms/3B.jpeg"
                                  alt=""
                                  class="zoom"
                                />
                                <img
                                  v-if="item.room_id === 5"
                                  src="../../assets/meetingrooms/4A.jpeg"
                                  alt=""
                                  class="zoom"
                                />
                                <img
                                  v-if="item.room_id === 6"
                                  src="../../assets/meetingrooms/4B.jpeg"
                                  alt=""
                                  class="zoom"
                                />
                                <img
                                  v-if="item.room_id === 7"
                                  src="../../assets/meetingrooms/5C.jpeg"
                                  alt=""
                                  class="zoom"
                                />
                                <!-- end -->
                              </div>

                              <div class="col-md-10 text-left">
                                <br />
                                <span class="text-secondary">
                                  **เลือกช่วงเวลาเพื่อจอง
                                  <div class="space"></div>
                                </span>
                                <div class="time-column">
                                  <span
                                    v-if="
                                      item.status === 1 ||
                                      (item.status === 0 &&
                                        item.freetimes.length === 0)
                                    "
                                  >
                                    <b-button
                                      pill
                                      variant="outline-secondary"
                                      disabled
                                      class="b-between"
                                    >
                                      08:30-12:00
                                    </b-button>

                                    <b-button
                                      pill
                                      variant="outline-secondary"
                                      disabled
                                      class="b-between"
                                    >
                                      13:00-16:00
                                    </b-button>
                                  </span>
                                  <span
                                    v-for="(prod, j) of item.freetimes"
                                    :key="j"
                                  >
                                    <span v-if="!user">
                                      <b-button
                                        v-if="
                                          item.freetimes.length === 1 &&
                                          item.status === 0 &&
                                          prod.time_begin === '13:00'
                                        "
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>
                                      <b-button
                                        v-if="
                                          item.freetimes.length === 1 &&
                                          item.status === 0 &&
                                          prod.time_begin === '16:30'
                                        "
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        13:00-16:30
                                      </b-button>

                                      <b-button
                                        pill
                                        v-if="
                                          prod.time_begin !== '08:30' ||
                                          prod.time_end !== '16:30'
                                        "
                                        variant="outline-pink"
                                        v-b-modal="
                                          'modal-meetingMain' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        class="b-between"
                                        @click="getUsefor(item.room_id)"
                                      >
                                        {{ prod.time_begin }}-{{
                                          prod.time_end
                                        }}
                                      </b-button>

                                      <span
                                        v-for="(timechkuse, iue) in historyall"
                                        :key="iue"
                                      >
                                        <b-button
                                          pill
                                          v-if="
                                            timechkuse.room_id ===
                                              item.room_id &&
                                            timechkuse.time_begin === '13:00' &&
                                            timechkuse.time_begin !==
                                              prod.time_begin &&
                                            item.freetimes.length === 1
                                          "
                                          variant="outline-secondary"
                                          disabled
                                          class="b-between"
                                        >
                                          13:00-16:30
                                        </b-button>
                                      </span>
                                    </span>

                                    <!-- if user :login  -->
                                    <span v-if="user">
                                      <b-button
                                        v-if="
                                          item.freetimes.length === 1 &&
                                          item.status === 0 &&
                                          prod.time_begin === '13:00'
                                        "
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>

                                      <b-button
                                        pill
                                        v-if="
                                          prod.time_begin !== '08:30' ||
                                          (prod.time_end !== '16:30' &&
                                            item.freetimes.length !== 0)
                                        "
                                        variant="outline-pink"
                                        class="b-between"
                                        href="/login"
                                      >
                                        {{ prod.time_begin }}-{{
                                          prod.time_end
                                        }}
                                      </b-button>

                                      <span
                                        v-for="(timechkuser, iu) in historyall"
                                        :key="iu"
                                      >
                                        <b-button
                                          pill
                                          v-if="
                                            timechkuser.room_id ===
                                              item.room_id &&
                                            timechkuser.time_begin ===
                                              '13:00' &&
                                            timechkuser.time_begin !==
                                              prod.time_begin &&
                                            item.freetimes.length === 1
                                          "
                                          variant="outline-secondary"
                                          disabled
                                          class="b-between"
                                        >
                                          13:00-16:30
                                        </b-button>
                                      </span>
                                    </span>

                                    <b-modal
                                      :hide-footer="true"
                                      v-if="chkbookingroom"
                                      centered
                                      size="lg"
                                      :id="
                                        'modal-meetingMain' +
                                        item.room_id +
                                        prod.time_id
                                      "
                                      header-border-variant="white"
                                      class="border-bottom-0"
                                    >
                                      <template #modal-title>
                                        <div
                                          class="card card-order-list card-margin shadow-sm border-light card-time-title"
                                        >
                                          <div class="card-body">
                                            <i class="fa-solid fa-bookmark"></i>
                                            ห้อง {{ item.room_name }} เวลาจอง
                                            {{ prod.time_begin }} -
                                            {{ prod.time_end }}
                                          </div>
                                        </div>
                                      </template>
                                      <div
                                        class="card card-order-list card-margin shadow-sm border-light card-time-body"
                                      >
                                        <div class="card-body">
                                          <form
                                            class="form-group"
                                            @submit.prevent="
                                              booking(
                                                item.room_id,
                                                prod.time_begin,
                                                prod.time_end,
                                                prod.time_id,
                                                'modal-meetingMain' +
                                                  item.room_id +
                                                  prod.time_id
                                              )
                                            "
                                            v-if="
                                              (auth.isLibraryStaff === 1 &&
                                                item.floor !== 6) ||
                                              auth.isLibraryStaff !== 1
                                            "
                                          >
                                            <b-form-select
                                              v-model="selected"
                                              :options="options"
                                              class="mb-3 input-style"
                                              value-field="usefor_id"
                                              text-field="usefor_name"
                                              disabled-field="notEnabled"
                                            >
                                              <template #first>
                                                <b-form-select-option
                                                  :value="null"
                                                  disabled
                                                  >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                >
                                              </template>
                                            </b-form-select>
                                            <input
                                              type="text"
                                              class="form-control input-style"
                                              placeholder="กรอกวัตถุประสงค์"
                                              v-model="input_another"
                                              v-if="
                                                selected === 7 ||
                                                selected === 13 ||
                                                selected === 16
                                              "
                                            />
                                            <p style="color: red">
                                              **หมายเหตุ : กรอกรหัสนักศึกษา
                                              {{ item.min_person }} คนขึ้นไป
                                            </p>
                                            <span
                                              style="color: red"
                                              v-if="
                                                error != '' || error === null
                                              "
                                            >
                                              **{{ error }}
                                            </span>
                                            <!-- <div class="space"></div> -->

                                            <b-row>
                                              <b-col
                                                cols="6"
                                                v-for="(
                                                  stdr, index
                                                ) in input_stdcode"
                                                :key="index"
                                              >
                                                <input
                                                  class="form-control input-style"
                                                  placeholder="กรอกรหัสนักศึกษา"
                                                  maxlength="11"
                                                  v-model="values[index]"
                                                />
                                              </b-col>
                                            </b-row>

                                            <button
                                              :disabled="!isComplete"
                                              type="submit"
                                              class="btn btn-purple deep-purple btn-block badge-pill"
                                              data-dismiss="modal"
                                              @click="showModal = false"
                                            >
                                              ยืนยัน
                                            </button>
                                          </form>

                                          <form
                                            class="form-group"
                                            @submit.prevent="
                                              bookingAnother(
                                                item.room_id,
                                                prod.time_begin,
                                                prod.time_end,
                                                prod.time_id,
                                                'modal-meetingMain' +
                                                  item.room_id +
                                                  prod.time_id
                                              )
                                            "
                                            v-if="
                                              auth.isLibraryStaff === 1 &&
                                              item.floor === 6
                                            "
                                          >
                                            <!-- Teacher -->
                                            <span>
                                              <b-button
                                                variant="outline-primary"
                                              >
                                                สำหรับอาจารย์
                                              </b-button>
                                            </span>
                                            <span
                                              style="
                                                color: red;
                                                font-weight: bold;
                                              "
                                              v-if="
                                                error != '' || error === null
                                              "
                                            >
                                              ERROR : {{ error }}
                                              <br />
                                              <br />
                                            </span>
                                            <b-row>
                                              <b-col cols="6">
                                                <input
                                                  class="form-control input-style"
                                                  placeholder="เบอร์โทรศัพท์"
                                                  maxlength="10"
                                                  v-model="
                                                    input_room_Teacher_phone
                                                  "
                                                />
                                              </b-col>
                                              <b-col cols="6">
                                                <input
                                                  class="form-control input-style"
                                                  placeholder="ชื่อ - นามสกุล"
                                                  v-model="
                                                    input_room_Teacher_name
                                                  "
                                                  autocomplete
                                                />
                                              </b-col>
                                              <!-- this.optionsfac -->
                                              <b-col cols="6">
                                                <b-form-select
                                                  v-model="selectedfac"
                                                  :options="optionsfac"
                                                  class="mb-3 input-style"
                                                  value-field="fac_code"
                                                  text-field="fac_name"
                                                  disabled-field="notEnabled"
                                                  @change="get_branch()"
                                                >
                                                  <!-- Teacher -->

                                                  <template #first>
                                                    <b-form-select-option
                                                      :value="null"
                                                      disabled
                                                      >เลือกคณะ</b-form-select-option
                                                    >
                                                  </template>
                                                </b-form-select>
                                              </b-col>
                                              <b-col cols="6">
                                                <b-form-select
                                                  v-model="selectedbranch"
                                                  :options="optionsbranch"
                                                  class="mb-3 input-style"
                                                  value-field="branch_code"
                                                  text-field="branch_name"
                                                  disabled-field="notEnabled"
                                                >
                                                  <!-- Teacher -->

                                                  <template #first>
                                                    <b-form-select-option
                                                      :value="null"
                                                      disabled
                                                      >เลือกสาขา</b-form-select-option
                                                    >
                                                  </template>
                                                </b-form-select>
                                              </b-col>
                                              <b-col cols="6">
                                                <input
                                                  class="form-control input-style"
                                                  placeholder="อีเมล"
                                                  maxlength=""
                                                  v-model="
                                                    input_room_Teacher_email
                                                  "
                                                  type="email"
                                                />
                                              </b-col>
                                              <b-col cols="6">
                                                <b-form-select
                                                  v-model="selected"
                                                  :options="options"
                                                  class="mb-3 input-style"
                                                  value-field="usefor_id"
                                                  text-field="usefor_name"
                                                  disabled-field="notEnabled"
                                                >
                                                  <!-- Teacher -->

                                                  <template #first>
                                                    <b-form-select-option
                                                      :value="null"
                                                      disabled
                                                      >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                    >
                                                  </template>
                                                </b-form-select>
                                                <input
                                                  type="text"
                                                  class="form-control input-style"
                                                  placeholder="กรอกวัตถุประสงค์"
                                                  v-model="input_another"
                                                  v-if="
                                                    selected === 7 ||
                                                    selected === 13 ||
                                                    selected === 16
                                                  "
                                                />
                                              </b-col>
                                            </b-row>

                                            <!-- :disabled="!isComplete" -->
                                            <button
                                              v-if="
                                                auth.isLibraryStaff === 1 &&
                                                item.floor === 6
                                              "
                                              :disabled="!isCompleteAnothor"
                                              type="submit"
                                              class="btn btn-purple deep-purple btn-block badge-pill"
                                              data-dismiss="modal"
                                              @click="showModal = false"
                                            >
                                              ยืนยัน
                                            </button>
                                          </form>
                                        </div>
                                      </div>
                                    </b-modal>

                                    <b-modal
                                      :hide-footer="true"
                                      :hide-header="true"
                                      centered
                                      size="lg"
                                      :id="
                                        'modal-meetingMain' +
                                        item.room_id +
                                        prod.time_id
                                      "
                                      header-border-variant="white"
                                      class="border-bottom-0"
                                      v-if="!chkbookingroom"
                                    >
                                      <div
                                        class="card-body justify-content-center card-block p-3 text-center text-danger"
                                      >
                                        <h5>
                                          <i
                                            class="fa-solid fa-circle-exclamation"
                                          ></i>
                                          {{ msgbookingroom }}
                                        </h5>
                                      </div>
                                    </b-modal>
                                  </span>
                                </div>
                                <br />

                                <span style="color: gray">
                                  <b-button
                                    pill
                                    variant="outline-primary"
                                    class="b-between"
                                    v-if="!showAcc[index]"
                                    @click="showAccessoriesMore(index)"
                                    size="sm"
                                  >
                                    อุปกรณ์
                                  </b-button>
                                  <b-button
                                    pill
                                    variant="outline-danger"
                                    class="b-between"
                                    v-if="showAcc[index]"
                                    @click="showAccessoriesLess(index)"
                                    size="sm"
                                  >
                                    ปิด
                                  </b-button>
                                  <br />

                                  <!-- End -->
                                </span>
                              </div>
                            </div>
                            <!-- 2A -->
                            <span style="color: gray" v-if="item.room_id === 1">
                              <!-- &nbsp;อุปกรณ์ : รีโมทแอร์ รีโมทจอมอนิเตอร์
                                แปรงลบกระดาน ปากกาไวท์บอร์ด -->
                              <br />
                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                  <!-- 2 -->

                                  <!-- 3 -->

                                  <!-- 4 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-wb.png"
                                            alt=""
                                            width="36"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ปากกาไวท์บอร์ด </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!--  -->
                                  <!-- 5 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> &nbsp;&nbsp;HDMI </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 6 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/img/acc-bwb.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ไวท์บอร์ด [whiteboard] </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/meetingrooms/tv.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> จอมอนิเตอร์ </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->

                                  <!-- end -->
                                </div>
                              </span>
                            </span>
                            <!-- END -->
                            <!-- 2B -->

                            <span style="color: gray" v-if="item.room_id === 2">
                              <!-- &nbsp;อุปกรณ์ : -->
                              <!-- อุปกรณ์ -->

                              <br />

                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-wb.png"
                                            alt=""
                                            width="36"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ปากกาไวท์บอร์ด </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>

                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/img/acc-bwb.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ไวท์บอร์ด [whiteboard] </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/meetingrooms/tv.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> จอมอนิเตอร์ </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->

                                  <!-- end -->
                                </div>
                              </span>
                              <!-- End -->
                            </span>

                            <!-- END -->

                            <!-- 3A -->
                            <span style="color: gray" v-if="item.room_id === 3">
                              <!-- &nbsp;อุปกรณ์ : -->
                              <!-- อุปกรณ์ -->

                              <br />

                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                  <!-- 2 -->

                                  <!-- 3 -->

                                  <!-- 4 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-wb.png"
                                            alt=""
                                            width="36"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ปากกาไวท์บอร์ด </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!--  -->
                                  <!-- 5 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>&nbsp;&nbsp;HDMI </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 6 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/img/acc-bwb.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ไวท์บอร์ด [whiteboard] </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/meetingrooms/tv.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> จอมอนิเตอร์ </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->

                                  <!-- end -->
                                </div>
                              </span>
                              <!-- End -->
                            </span>

                            <!-- END -->

                            <!-- 3B -->
                            <span style="color: gray" v-if="item.room_id === 4">
                              <!-- &nbsp;อุปกรณ์ : -->
                              <!-- อุปกรณ์ -->

                              <br />

                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                  <!-- 2 -->

                                  <!-- 3 -->

                                  <!-- 4 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-wb.png"
                                            alt=""
                                            width="36"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ปากกาไวท์บอร์ด </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>

                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/img/acc-bwb.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ไวท์บอร์ด [whiteboard] </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/meetingrooms/tv.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> จอมอนิเตอร์ </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->

                                  <!-- end -->
                                  <!-- 8 -->

                                  <!-- end -->
                                </div>
                              </span>
                              <!-- End -->
                            </span>

                            <!-- END -->

                            <!-- 4A -->
                            <span style="color: gray" v-if="item.room_id === 5">
                              <!-- &nbsp;อุปกรณ์ : -->
                              <!-- อุปกรณ์ -->

                              <br />

                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                  <!-- 2 -->

                                  <!-- 3 -->

                                  <!-- 4 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-wb.png"
                                            alt=""
                                            width="36"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ปากกาไวท์บอร์ด </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!--  -->
                                  <!-- 5 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> &nbsp;&nbsp;HDMI </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 6 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/img/acc-bwb.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ไวท์บอร์ด [whiteboard] </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/meetingrooms/tv.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> จอมอนิเตอร์ </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->

                                  <!-- end -->
                                </div>
                              </span>
                              <!-- End -->
                            </span>

                            <!-- END -->

                            <!-- 4B -->
                            <span style="color: gray" v-if="item.room_id === 6">
                              <!-- &nbsp;อุปกรณ์ : -->
                              <!-- อุปกรณ์ -->

                              <br />

                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                  <!-- 2 -->

                                  <!-- 3 -->

                                  <!-- 4 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-wb.png"
                                            alt=""
                                            width="36"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ปากกาไวท์บอร์ด </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!--  -->
                                  <!-- 5 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> &nbsp;&nbsp;HDMI </span>

                                          <br />
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 6 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/img/acc-bwb.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ไวท์บอร์ด [whiteboard] </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="../../assets/meetingrooms/tv.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> จอมอนิเตอร์ </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- end -->
                                  <!-- 7 -->

                                  <!-- end -->
                                </div>
                              </span>
                              <!-- End -->
                            </span>

                            <!-- END -->

                            <!-- 5A -->

                            <span style="color: gray" v-if="item.room_id === 7">
                              <br />
                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-bwb.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> ไวท์บอร์ด [whiteboard] </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 2 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-pro.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> โปรเจคเตอร์ [projector] </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 3 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/img/acc-mic.png"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp; ไมค์โครโฟน [microphone]
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                </div>
                              </span>
                              <!-- End -->
                            </span>
                            <!-- END -->
                          </div>
                          <!-- <hr /> -->
                          <!-- v-if="item.status === 0" -->
                        </div>

                        <div></div>
                      </div>
                    </span>
                    <!-- ================================================ End student ================================ -->
                    <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ END MAIN ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
                  </div>
                </div>
              </div>
            </b-row>
          </span>
          <!-- 2 Culums -->
          <span v-if="status_show">
            <!-- ###################################################### 2 Culums #################################################################  -->
            <br />
            <b-row>
              <div class="col-md-4 text-left">
                <div class="card-columns">
                  <!-- <div class="card card-order-list card-margin shadow border-light">
              <div class="card-body rounded-card"> -->

                  <div class="card-room">
                    <div class="card-myroom">
                      <div
                        class="card card-order-list card-margin border-0 shadow-lg"
                      >
                        <div class="card-body card-body-size">
                          <h5 class="text-center">ห้องที่จอง</h5>
                        </div>
                      </div>

                      <!-- returned -->
                      <span v-for="(std, inx) in history" :key="inx">
                        <input
                          class="chat-menu hidden"
                          id="offchat-menu"
                          type="checkbox"
                        />
                        <div class="sticky-button" id="sticky-button">
                          <label for="offchat-menu">
                            <!-- <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-journal-code chat-icon"
                              viewBox="-2 -2 20 17"
                              
                            >
                              <path
                                fill-rule="evenodd"
                                d="M8.646 5.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L10.293 8 8.646 6.354a.5.5 0 0 1 0-.708zm-1.292 0a.5.5 0 0 0-.708 0l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L5.707 8l1.647-1.646a.5.5 0 0 0 0-.708z"
                              />
                              <path
                                d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                              />
                              <path
                                d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                              />
                            </svg> -->

                            <svg class="chat-icon" viewBox="-2 -3 24 24">
                              <path
                                d="M17.896,12.706v-0.005v-0.003L15.855,2.507c-0.046-0.24-0.255-0.413-0.5-0.413H4.899c-0.24,0-0.447,0.166-0.498,0.4L2.106,12.696c-0.008,0.035-0.013,0.071-0.013,0.107v4.593c0,0.28,0.229,0.51,0.51,0.51h14.792c0.28,0,0.51-0.229,0.51-0.51v-4.593C17.906,12.77,17.904,12.737,17.896,12.706 M5.31,3.114h9.625l1.842,9.179h-4.481c-0.28,0-0.51,0.229-0.51,0.511c0,0.703-1.081,1.546-1.785,1.546c-0.704,0-1.785-0.843-1.785-1.546c0-0.281-0.229-0.511-0.51-0.511H3.239L5.31,3.114zM16.886,16.886H3.114v-3.572H7.25c0.235,1.021,1.658,2.032,2.75,2.032c1.092,0,2.515-1.012,2.749-2.032h4.137V16.886z"
                              ></path>
                              <!-- <path
                                d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.62C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2M12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.72 20.28 11.92C20.28 16.46 16.58 20.15 12.04 20.15C10.56 20.15 9.11 19.76 7.85 19L7.55 18.83L4.43 19.65L5.26 16.61L5.06 16.29C4.24 15 3.8 13.47 3.8 11.91C3.81 7.37 7.5 3.67 12.05 3.67M8.53 7.33C8.37 7.33 8.1 7.39 7.87 7.64C7.65 7.89 7 8.5 7 9.71C7 10.93 7.89 12.1 8 12.27C8.14 12.44 9.76 14.94 12.25 16C12.84 16.27 13.3 16.42 13.66 16.53C14.25 16.72 14.79 16.69 15.22 16.63C15.7 16.56 16.68 16.03 16.89 15.45C17.1 14.87 17.1 14.38 17.04 14.27C16.97 14.17 16.81 14.11 16.56 14C16.31 13.86 15.09 13.26 14.87 13.18C14.64 13.1 14.5 13.06 14.31 13.3C14.15 13.55 13.67 14.11 13.53 14.27C13.38 14.44 13.24 14.46 13 14.34C12.74 14.21 11.94 13.95 11 13.11C10.26 12.45 9.77 11.64 9.62 11.39C9.5 11.15 9.61 11 9.73 10.89C9.84 10.78 10 10.6 10.1 10.45C10.23 10.31 10.27 10.2 10.35 10.04C10.43 9.87 10.39 9.73 10.33 9.61C10.27 9.5 9.77 8.26 9.56 7.77C9.36 7.29 9.16 7.35 9 7.34C8.86 7.34 8.7 7.33 8.53 7.33Z"
                              /> -->
                            </svg>
                            <svg class="close-icon" viewBox="0 0 512 512">
                              <path
                                d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
                              />
                            </svg>
                          </label>
                        </div>
                        <div class="sticky-chat">
                          <div class="chat-content">
                            <div class="chat-header">
                              <!-- 32 32 -->
                              <svg viewBox="0 0 20 20">
                                <!-- <path
                                  d="M9.719,17.073l-6.562-6.51c-0.27-0.268-0.504-0.567-0.696-0.888C1.385,7.89,1.67,5.613,3.155,4.14c0.864-0.856,2.012-1.329,3.233-1.329c1.924,0,3.115,1.12,3.612,1.752c0.499-0.634,1.689-1.752,3.612-1.752c1.221,0,2.369,0.472,3.233,1.329c1.484,1.473,1.771,3.75,0.693,5.537c-0.19,0.32-0.425,0.618-0.695,0.887l-6.562,6.51C10.125,17.229,9.875,17.229,9.719,17.073 M6.388,3.61C5.379,3.61,4.431,4,3.717,4.707C2.495,5.92,2.259,7.794,3.145,9.265c0.158,0.265,0.351,0.51,0.574,0.731L10,16.228l6.281-6.232c0.224-0.221,0.416-0.466,0.573-0.729c0.887-1.472,0.651-3.346-0.571-4.56C15.57,4,14.621,3.61,13.612,3.61c-1.43,0-2.639,0.786-3.268,1.863c-0.154,0.264-0.536,0.264-0.69,0C9.029,4.397,7.82,3.61,6.388,3.61"
                                ></path> -->
                                <path
                                  d="M14.467,1.771H5.533c-0.258,0-0.47,0.211-0.47,0.47v15.516c0,0.414,0.504,0.634,0.802,0.331L10,13.955l4.136,4.133c0.241,0.241,0.802,0.169,0.802-0.331V2.241C14.938,1.982,14.726,1.771,14.467,1.771 M13.997,16.621l-3.665-3.662c-0.186-0.186-0.479-0.186-0.664,0l-3.666,3.662V2.711h7.994V16.621z"
                                ></path>
                                <!-- <path
                                  d="M24,22a1,1,0,0,1-.64-.23L18.84,18H17A8,8,0,0,1,17,2h6a8,8,0,0,1,2,15.74V21a1,1,0,0,1-.58.91A1,1,0,0,1,24,22ZM17,4a6,6,0,0,0,0,12h2.2a1,1,0,0,1,.64.23L23,18.86V16.92a1,1,0,0,1,.86-1A6,6,0,0,0,23,4Z"
                                />
                                <rect height="2" width="2" x="19" y="9"></rect>
                                <rect height="2" width="2" x="14" y="9"></rect>
                                <rect height="2" width="2" x="24" y="9"></rect>
                                <path
                                  d="M8,30a1,1,0,0,1-.42-.09A1,1,0,0,1,7,29V25.74a8,8,0,0,1-1.28-15,1,1,0,1,1,.82,1.82,6,6,0,0,0,1.6,11.4,1,1,0,0,1,.86,1v1.94l3.16-2.63A1,1,0,0,1,12.8,24H15a5.94,5.94,0,0,0,4.29-1.82,1,1,0,0,1,1.44,1.4A8,8,0,0,1,15,26H13.16L8.64,29.77A1,1,0,0,1,8,30Z"
                                /> -->
                              </svg>
                              <div class="title">
                                <h4>รายการจองของคุณ</h4>
                                <span></span>
                              </div>
                            </div>
                            <!--  ++++++++++-->
                            <span
                              v-if="
                                std.room_id === 1 ||
                                std.room_id === 2 ||
                                std.room_id === 3 ||
                                std.room_id === 4 ||
                                std.room_id === 5 ||
                                std.room_id === 6 ||
                                std.room_id === 7
                              "
                            >
                              <div class="chat-text">
                                <span
                                  class="text-success"
                                  v-if="std.trans_status === 'booked'"
                                >
                                  <b>สถานะ : รอยืนยัน</b>
                                </span>
                                <span
                                  class="text-danger"
                                  v-if="
                                    std.trans_status === 'inlocker' &&
                                    std.locker_number !== ''
                                  "
                                >
                                  <b
                                    >รับกุญแจที่ล็อกเกอร์ :
                                    {{ std.locker_number }}</b
                                  >
                                </span>
                                <span
                                  class="text-success"
                                  v-if="std.trans_status === 'borrowed'"
                                >
                                  <b>สถานะ : กำลังใช้งาน</b>
                                </span>
                              </div>
                              <div class="chat-text">
                                <span>
                                  <b> ผู้จอง : </b>{{ auth.std_name }} <br />
                                  <b>ห้อง :</b> <b>{{ std.room_name }}</b>
                                  <br />
                                  <b>เวลา :</b> {{ std.time_begin }} -
                                  {{ std.time_end }} <br />
                                  วันจองที่จอง :
                                  {{ std.meeting_date | moment }} <br />

                                  <div class="" v-if="!readMore[inx]">
                                    <div
                                      style="color: hotpink"
                                      class=""
                                      v-if="!readMore[inx]"
                                      @click="showMore(inx)"
                                    >
                                      <i class="fas fa-ellipsis-v"></i>
                                      เพิ่มเติม
                                    </div>
                                  </div>
                                  <section class="" v-if="readMore[inx]">
                                    <b>สมาชิก :</b>
                                    <section
                                      v-for="(pro, k) of std.students"
                                      :key="k"
                                    >
                                      {{ pro.std_name }},
                                    </section>
                                    <div
                                      style="color: hotpink"
                                      v-if="readMore[inx]"
                                      @click="showLess(inx)"
                                    >
                                      [ย่อ]
                                    </div>
                                  </section>
                                </span>
                              </div>
                            </span>
                            <span
                              v-if="
                                std.room_id === 8 ||
                                std.room_id === 9 ||
                                std.room_id === 10
                              "
                            >
                              <div class="chat-text">
                                <span
                                  class="text-danger"
                                  v-if="std.trans_status === 'booked'"
                                >
                                  <b>Scan qrcode เพื่อยืนยันการใช้งาน </b>
                                </span>

                                <span
                                  class="text-info"
                                  v-if="std.trans_status === 'confirmed'"
                                >
                                  <b>ยืนยันการจองเรียบร้อย</b>
                                </span>

                                <span
                                  class="text-success"
                                  v-if="std.trans_status === 'approved'"
                                >
                                  <b>อนุมัติการจอง</b>
                                </span>

                                <span
                                  class="text-primary"
                                  v-if="std.trans_status === 'endofuse'"
                                >
                                  <b>เสร็จสิ้น</b>
                                </span>
                              </div>
                            </span>

                            <!--  -->
                            <!-- <div class="chat-text">
                          
                         
                              <span class="typing">
                                <svg viewBox="0 0 512 512">
                                  <circle cx="256" cy="256" r="48"></circle>
                                  <circle cx="416" cy="256" r="48"></circle>
                                  <circle cx="96" cy="256" r="48"></circle>
                                </svg>
                              </span>
                            </div> -->
                          </div>
                          <!-- <a
                            class="chat-button"
                            href="https://api.whatsapp.com/send?phone=6281285528669"
                            rel="nofollow noreferrer"
                            target="_blank"
                          >
                            <span>Ketik pesan</span>
                            <svg viewBox="0 0 32 32">
                              <path
                                d="M19.47,31a2,2,0,0,1-1.8-1.09l-4-7.57a1,1,0,0,1,1.77-.93l4,7.57L29,3.06,3,12.49l9.8,5.26,8.32-8.32a1,1,0,0,1,1.42,1.42l-8.85,8.84a1,1,0,0,1-1.17.18L2.09,14.33a2,2,0,0,1,.25-3.72L28.25,1.13a2,2,0,0,1,2.62,2.62L21.39,29.66A2,2,0,0,1,19.61,31Z"
                              />
                            </svg>
                          </a> -->
                        </div>
                        <div
                          class="card card-order-list card-margin border-0 shadow"
                        >
                          <!-- v-if="std.trans_status !== 'returned'" -->
                          <div class="card-body">
                            <span
                              v-if="
                                std.room_id === 1 ||
                                std.room_id === 2 ||
                                std.room_id === 3 ||
                                std.room_id === 4 ||
                                std.room_id === 5 ||
                                std.room_id === 6 ||
                                std.room_id === 7
                              "
                            >
                              <span
                                class="text-success"
                                v-if="std.trans_status === 'booked'"
                              >
                                <b>สถานะ : รอยืนยัน</b>
                              </span>
                              <span
                                class="text-danger"
                                v-if="
                                  std.trans_status === 'inlocker' &&
                                  std.locker_number !== ''
                                "
                              >
                                <b
                                  >รับกุญแจที่ล็อกเกอร์ :
                                  {{ std.locker_number }}</b
                                >
                              </span>
                              <span
                                class="text-success"
                                v-if="std.trans_status === 'borrowed'"
                              >
                                <b>สถานะ : กำลังใช้งาน</b>
                              </span>
                              <br />
                            </span>

                            <!-- approved -->
                            <span
                              v-if="
                                std.room_id === 8 ||
                                std.room_id === 9 ||
                                std.room_id === 10
                              "
                            >
                              <span
                                class="text-danger"
                                v-if="std.trans_status === 'booked'"
                              >
                                <b>Scan qrcode เพื่อยืนยันการใช้งาน </b>
                              </span>

                              <span
                                class="text-info"
                                v-if="std.trans_status === 'confirmed'"
                              >
                                <b>ยืนยันการจองเรียบร้อย</b>
                              </span>

                              <span
                                class="text-success"
                                v-if="std.trans_status === 'approved'"
                              >
                                <b>อนุมัติการจอง</b>
                              </span>

                              <span
                                class="text-primary"
                                v-if="std.trans_status === 'endofuse'"
                              >
                                <b>เสร็จสิ้น</b>
                              </span>
                              <br />
                            </span>

                            <span> ผู้จอง : {{ auth.std_name }} </span> <br />
                            <span>
                              ห้อง : <b>{{ std.room_name }}</b></span
                            >
                            <br />
                            <span>
                              เวลา : {{ std.time_begin }} -
                              {{ std.time_end }}</span
                            >
                            <br />
                            <span>
                              วันจอง : {{ std.meeting_date | moment }}</span
                            >
                            <br />

                            <span class="" v-if="!readMore[inx]">
                              <span
                                style="color: hotpink; font-size: 14px"
                                class=""
                                v-if="!readMore[inx]"
                                @click="showMore(inx)"
                              >
                                <i class="fas fa-ellipsis-v"></i>
                                เพิ่มเติม
                              </span>
                            </span>
                            <span class="" v-if="readMore[inx]">
                              สมาชิก :
                              <span v-for="(pro, k) of std.students" :key="k">
                                {{ pro.std_name }},
                              </span>
                              <span
                                style="color: hotpink"
                                v-if="readMore[inx]"
                                @click="showLess(inx)"
                              >
                                [ย่อ]
                              </span>
                            </span>
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-8 text-left">
                <div class="card-columns">
                  <div
                    class="card-room"
                    v-for="(item, index) in status_room"
                    :key="index"
                  >
                    <!-- {{  item.freetimes.length}} -->
                    <!-- =============================================== Teacher Anothor Success Layout ================================== -->
                    <!-- แก้ไขเปลี่ยนโชว์ปุ่ม พร้อมอัพเดทสภถานะว่า มีการจองแล้ง Disable button -->
                    <span v-if="!isShowstaff">
                      <span>
                        <div
                          class="card-input"
                          v-if="
                            item.status === 0 && item.freetimes.length !== 0
                          "
                        >
                          <div
                            class="card card-order-list card-margin border-0 shadow"
                            v-if="
                              item.room_id === 1 ||
                              item.room_id === 2 ||
                              item.room_id === 3 ||
                              item.room_id === 4 ||
                              item.room_id === 5 ||
                              item.room_id === 6 ||
                              item.room_id === 7
                            "
                          >
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-3 text-left">
                                  <h6>{{ item.room_name }}</h6>

                                  <!-- meeting  -->
                                  <img
                                    v-if="item.room_id === 1"
                                    src="../../assets/meetingrooms/2A.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                  <img
                                    v-if="item.room_id === 2"
                                    src="../../assets/meetingrooms/2B.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                  <img
                                    v-if="item.room_id === 3"
                                    src="../../assets/meetingrooms/3A.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                  <img
                                    v-if="item.room_id === 4"
                                    src="../../assets/meetingrooms/3B.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                  <img
                                    v-if="item.room_id === 5"
                                    src="../../assets/meetingrooms/4A.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                  <img
                                    v-if="item.room_id === 6"
                                    src="../../assets/meetingrooms/4B.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                  <img
                                    v-if="item.room_id === 7"
                                    src="../../assets/meetingrooms/5C.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                </div>

                                <div class="col-md-9 text-left">
                                  <br />
                                  <div class="time-column">
                                    <span
                                      v-if="
                                        item.status === 1 ||
                                        (item.status === 0 &&
                                          item.freetimes.length === 0)
                                      "
                                    >
                                      <b-button
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>

                                      <b-button
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        13:00-16:00
                                      </b-button>
                                    </span>

                                    <span
                                      v-for="(prod, j) of item.freetimes"
                                      :key="j"
                                    >
                                      <b-button
                                        v-if="
                                          item.freetimes.length === 1 &&
                                          item.status === 0 &&
                                          prod.time_begin === '13:00'
                                        "
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>

                                      <b-button
                                        pill
                                        v-if="
                                          prod.time_begin !== '08:30' ||
                                          prod.time_end !== '16:30'
                                        "
                                        variant="outline-pink"
                                        v-b-modal="
                                          'modal-meeting2culumnTeacher' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        class="b-between"
                                        @click="getUsefor(item.room_id)"
                                      >
                                        {{ prod.time_begin }}-{{
                                          prod.time_end
                                        }}
                                      </b-button>
                                      <span
                                        v-for="(timechkuser, iu) in historyall"
                                        :key="iu"
                                      >
                                        <b-button
                                          pill
                                          v-if="
                                            timechkuser.room_id ===
                                              item.room_id &&
                                            timechkuser.time_begin ===
                                              '13:00' &&
                                            timechkuser.time_begin !==
                                              prod.time_begin &&
                                            item.freetimes.length === 1
                                          "
                                          variant="outline-secondary"
                                          disabled
                                          class="b-between"
                                        >
                                          13:00-16:30
                                        </b-button>
                                      </span>

                                      <b-modal
                                        :hide-footer="true"
                                        centered
                                        size="lg"
                                        :id="
                                          'modal-meeting2culumnTeacher' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        header-border-variant="white"
                                        class="border-bottom-0"
                                        v-if="chkbookingroom"
                                      >
                                        <template #modal-title>
                                          <div
                                            class="card card-order-list card-margin shadow border-light"
                                          >
                                            <div class="card-body">
                                              <i
                                                class="fa-solid fa-bookmark"
                                              ></i>
                                              ห้อง {{ item.room_name }} เวลาจอง
                                              {{ prod.time_begin }} -
                                              {{ prod.time_end }}
                                            </div>
                                          </div>
                                        </template>

                                        <div
                                          class="card card-order-list card-margin shadow border-light"
                                        >
                                          <div class="card-body">
                                            <form
                                              class="form-group"
                                              @submit.prevent="
                                                bookingAnother(
                                                  item.room_id,
                                                  prod.time_begin,
                                                  prod.time_end,
                                                  prod.time_id,
                                                  'modal-meeting2culumnTeacher' +
                                                    item.room_id +
                                                    prod.time_id
                                                )
                                              "
                                            >
                                              <p style="color: blue">
                                                *หมายเหตุ :
                                                กรุณาเลือกวัตุประสงค์การใช้งาน
                                              </p>

                                              <b-form-select
                                                v-model="selected"
                                                :options="options"
                                                class="mb-3"
                                                value-field="usefor_id"
                                                text-field="usefor_name"
                                                disabled-field="notEnabled"
                                              >
                                                <template #first>
                                                  <b-form-select-option
                                                    :value="null"
                                                    disabled
                                                    >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                  >
                                                </template>
                                              </b-form-select>
                                              <span
                                                style="
                                                  color: red;
                                                  font-weight: bold;
                                                "
                                                v-if="
                                                  error != '' || error === null
                                                "
                                              >
                                                ERROR : {{ error }}
                                                <br />
                                                <br />
                                              </span>
                                              <input
                                                type="text"
                                                class="form-control input-style"
                                                placeholder="กรอกวัตถุประสงค์"
                                                v-model="input_another"
                                                v-if="
                                                  selected === 7 ||
                                                  selected === 13 ||
                                                  selected === 16
                                                "
                                              />

                                              <button
                                                :disabled="!isCompleteTeach"
                                                type="submit"
                                                class="btn btn-purple deep-purple btn-block badge-pill"
                                                data-dismiss="modal"
                                                @click="showModal = false"
                                              >
                                                ยืนยัน
                                              </button>
                                            </form>
                                          </div>
                                        </div>
                                      </b-modal>

                                      <b-modal
                                        :hide-footer="true"
                                        :hide-header="true"
                                        centered
                                        size="lg"
                                        :id="
                                          'modal-meeting2culumnTeacher' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        header-border-variant="white"
                                        class="border-bottom-0"
                                        v-if="!chkbookingroom"
                                      >
                                        <div
                                          class="card-body justify-content-center card-block p-3 text-center text-danger"
                                        >
                                          <h5>
                                            <i
                                              class="fa-solid fa-circle-exclamation"
                                            ></i>
                                            {{ msgbookingroom }}
                                          </h5>
                                        </div>
                                      </b-modal>
                                    </span>
                                  </div>
                                  <br />
                                  <span
                                    style="color: gray"
                                    v-if="
                                      item.room_id === 1 ||
                                      item.room_id === 2 ||
                                      item.room_id === 3 ||
                                      item.room_id === 4 ||
                                      item.room_id === 5 ||
                                      item.room_id === 6
                                    "
                                  >
                                    <b-button
                                      pill
                                      variant="outline-primary"
                                      class="b-between"
                                      v-if="!showAcc[index]"
                                      @click="showAccessoriesMore(index)"
                                      size="sm"
                                    >
                                      อุปกรณ์
                                    </b-button>
                                    <b-button
                                      pill
                                      variant="outline-danger"
                                      class="b-between"
                                      v-if="showAcc[index]"
                                      @click="showAccessoriesLess(index)"
                                      size="sm"
                                    >
                                      ปิด
                                    </b-button>
                                    <br />
                                  </span>
                                  <span
                                    style="color: gray"
                                    v-if="item.room_id === 7"
                                  >
                                    <!-- &nbsp;อุปกรณ์ : -->
                                    <!-- อุปกรณ์ -->
                                    <b-button
                                      pill
                                      variant="outline-primary"
                                      class="b-between"
                                      v-if="!showAcc[index]"
                                      @click="showAccessoriesMore(index)"
                                      size="sm"
                                    >
                                      อุปกรณ์
                                    </b-button>
                                    <b-button
                                      pill
                                      variant="outline-danger"
                                      class="b-between"
                                      v-if="showAcc[index]"
                                      @click="showAccessoriesLess(index)"
                                      size="sm"
                                    >
                                      ปิด
                                    </b-button>
                                    <br />

                                    <!-- End -->
                                  </span>
                                </div>
                              </div>
                              <!-- 2A -->
                              <span
                                style="color: gray"
                                v-if="item.room_id === 1"
                              >
                                <!-- &nbsp;อุปกรณ์ : รีโมทแอร์ รีโมทจอมอนิเตอร์
                                แปรงลบกระดาน ปากกาไวท์บอร์ด -->
                                <br />
                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                    <!-- 2 -->

                                    <!-- 3 -->

                                    <!-- 4 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-wb.png"
                                              alt=""
                                              width="36"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> ปากกาไวท์บอร์ด </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!--  -->
                                    <!-- 5 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>&nbsp;&nbsp; HDMI </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 6 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/img/acc-bwb.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              ไวท์บอร์ด [whiteboard]
                                            </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/meetingrooms/tv.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> จอมอนิเตอร์ </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->

                                    <!-- end -->
                                  </div>
                                </span>
                              </span>
                              <!-- END -->
                              <!-- 2B -->

                              <span
                                style="color: gray"
                                v-if="item.room_id === 2"
                              >
                                <!-- &nbsp;อุปกรณ์ : -->
                                <!-- อุปกรณ์ -->

                                <br />

                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                    <!-- 2 -->

                                    <!-- 3 -->

                                    <!-- 4 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-wb.png"
                                              alt=""
                                              width="36"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> ปากกาไวท์บอร์ด </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!--  -->
                                    <!-- 5 -->

                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/img/acc-bwb.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              ไวท์บอร์ด [whiteboard]
                                            </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/meetingrooms/tv.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> จอมอนิเตอร์ </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->

                                    <!-- end -->
                                  </div>
                                </span>
                                <!-- End -->
                              </span>

                              <!-- END -->

                              <!-- 3A -->
                              <span
                                style="color: gray"
                                v-if="item.room_id === 3"
                              >
                                <!-- &nbsp;อุปกรณ์ : -->
                                <!-- อุปกรณ์ -->

                                <br />

                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                    <!-- 2 -->

                                    <!-- 3 -->

                                    <!-- 4 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-wb.png"
                                              alt=""
                                              width="36"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> ปากกาไวท์บอร์ด </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!--  -->
                                    <!-- 5 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>&nbsp;&nbsp; HDMI </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 6 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/img/acc-bwb.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              ไวท์บอร์ด [whiteboard]
                                            </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/meetingrooms/tv.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> จอมอนิเตอร์ </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->

                                    <!-- end -->
                                  </div>
                                </span>
                                <!-- End -->
                              </span>

                              <!-- END -->

                              <!-- 3B -->
                              <span
                                style="color: gray"
                                v-if="item.room_id === 4"
                              >
                                <!-- &nbsp;อุปกรณ์ : -->
                                <!-- อุปกรณ์ -->

                                <br />

                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                    <!-- 2 -->

                                    <!-- 3 -->

                                    <!-- 4 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-wb.png"
                                              alt=""
                                              width="36"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> ปากกาไวท์บอร์ด </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!--  -->
                                    <!-- 5 -->
                                    <!-- <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              HDMI 
                                            </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div> -->
                                    <!-- end -->
                                    <!-- 6 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/img/acc-bwb.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              ไวท์บอร์ด [whiteboard]
                                            </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/meetingrooms/tv.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> จอมอนิเตอร์ </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->

                                    <!-- end -->
                                    <!-- 8 -->

                                    <!-- end -->
                                  </div>
                                </span>
                                <!-- End -->
                              </span>

                              <!-- END -->

                              <!-- 4A -->
                              <span
                                style="color: gray"
                                v-if="item.room_id === 5"
                              >
                                <!-- &nbsp;อุปกรณ์ : -->
                                <!-- อุปกรณ์ -->

                                <br />

                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                    <!-- 2 -->

                                    <!-- 3 -->

                                    <!-- 4 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-wb.png"
                                              alt=""
                                              width="36"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> ปากกาไวท์บอร์ด </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!--  -->
                                    <!-- 5 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> &nbsp;&nbsp;HDMI </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 6 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/img/acc-bwb.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              ไวท์บอร์ด [whiteboard]
                                            </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/meetingrooms/tv.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> จอมอนิเตอร์ </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->

                                    <!-- end -->
                                  </div>
                                </span>
                                <!-- End -->
                              </span>

                              <!-- END -->

                              <!-- 4B -->
                              <span
                                style="color: gray"
                                v-if="item.room_id === 6"
                              >
                                <!-- &nbsp;อุปกรณ์ : -->
                                <!-- อุปกรณ์ -->

                                <br />

                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                    <!-- 2 -->

                                    <!-- 3 -->

                                    <!-- 4 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-wb.png"
                                              alt=""
                                              width="36"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> ปากกาไวท์บอร์ด </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!--  -->
                                    <!-- 5 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> &nbsp;&nbsp;HDMI </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 6 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/img/acc-bwb.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;ไวท์บอร์ด [whiteboard]
                                            </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/meetingrooms/tv.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> จอมอนิเตอร์ </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->

                                    <!-- end -->
                                  </div>
                                </span>
                                <!-- End -->
                              </span>

                              <!-- END -->

                              <!-- 5A -->

                              <span
                                style="color: gray"
                                v-if="item.room_id === 7"
                              >
                                <!-- &nbsp;อุปกรณ์ : -->
                                <!-- อุปกรณ์ -->

                                <br />

                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-bwb.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              ไวท์บอร์ด [whiteboard]
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 2 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-pro.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              โปรเจคเตอร์ [projector]
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 3 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-mic.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp; ไมค์โครโฟน
                                              [microphone]
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                  </div>
                                </span>
                                <!-- End -->
                              </span>
                              <!-- END -->
                            </div>
                            <!-- <hr v-if="item.status === 0" /> -->
                          </div>
                        </div>
                      </span>
                    </span>
                    <!-- =============================================== End AnothorSuccess Layout ================================== -->

                    <!-- =============================================== 2 culumn Main Success Layout ================================== -->
                    <span v-if="isShowstaff">
                      <div class="card-input">
                        <!-- v-if="item.status === 0 " -->
                        <!-- && item.freetimes.length !== 0 -->
                        <!-- <div class="card card-order-list card-margin border-0"> -->

                        <div class="card-input">
                          <div
                            class="card card-order-list card-margin border-0 shadow"
                            v-if="
                              item.room_id === 1 ||
                              item.room_id === 2 ||
                              item.room_id === 3 ||
                              item.room_id === 4 ||
                              item.room_id === 5 ||
                              item.room_id === 6 ||
                              item.room_id === 7
                            "
                          >
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-3 text-left">
                                  <h6>{{ item.room_name }}</h6>

                                  <!-- meeting  -->
                                  <img
                                    v-if="item.room_id === 1"
                                    src="../../assets/meetingrooms/2A.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                  <img
                                    v-if="item.room_id === 2"
                                    src="../../assets/meetingrooms/2B.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                  <img
                                    v-if="item.room_id === 3"
                                    src="../../assets/meetingrooms/3A.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                  <img
                                    v-if="item.room_id === 4"
                                    src="../../assets/meetingrooms/3B.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                  <img
                                    v-if="item.room_id === 5"
                                    src="../../assets/meetingrooms/4A.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                  <img
                                    v-if="item.room_id === 6"
                                    src="../../assets/meetingrooms/4B.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                  <img
                                    v-if="item.room_id === 7"
                                    src="../../assets/meetingrooms/5C.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                </div>

                                <div class="col-md-9 text-left">
                                  <br />
                                  <span class="text-secondary">
                                    **เลือกช่วงเวลาเพื่อจอง
                                    <div class="space"></div>
                                  </span>

                                  <div class="time-column">
                                    <span
                                      v-if="
                                        item.status === 1 ||
                                        (item.status === 0 &&
                                          item.freetimes.length === 0)
                                      "
                                    >
                                      <b-button
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>

                                      <b-button
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        13:00-16:00
                                      </b-button>
                                    </span>
                                    <span
                                      v-for="(prod, j) of item.freetimes"
                                      :key="j"
                                    >
                                      <b-button
                                        v-if="
                                          item.freetimes.length === 1 &&
                                          item.status === 0 &&
                                          prod.time_begin === '13:00'
                                        "
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>

                                      <b-button
                                        pill
                                        v-if="
                                          prod.time_begin !== '08:30' ||
                                          (prod.time_end !== '16:30' &&
                                            item.status === 0)
                                        "
                                        variant="outline-pink"
                                        v-b-modal="
                                          'modal-meeting2culumnMain' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        class="b-between"
                                        @click="getUsefor(item.room_id)"
                                      >
                                        {{ prod.time_begin }}-{{
                                          prod.time_end
                                        }}
                                      </b-button>

                                      <span
                                        v-for="(timechk, i) in history"
                                        :key="i"
                                      >
                                        <b-button
                                          pill
                                          v-if="
                                            timechk.room_id === item.room_id &&
                                            timechk.time_begin === '13:00' &&
                                            timechk.time_begin !==
                                              prod.time_begin &&
                                            item.freetimes.length === 1
                                          "
                                          variant="outline-secondary"
                                          disabled
                                          class="b-between"
                                        >
                                          13:00-16:30
                                        </b-button>
                                      </span>

                                      <b-modal
                                        :hide-footer="true"
                                        centered
                                        size="lg"
                                        :id="
                                          'modal-meeting2culumnMain' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        header-border-variant="white"
                                        class="border-bottom-0"
                                        v-if="chkbookingroom"
                                      >
                                        <template #modal-title>
                                          <div
                                            class="card card-order-list card-margin shadow border-light"
                                          >
                                            <div class="card-body">
                                              <i
                                                class="fa-solid fa-bookmark"
                                              ></i>
                                              ห้อง {{ item.room_name }} เวลาจอง
                                              {{ prod.time_begin }} -
                                              {{ prod.time_end }}
                                            </div>
                                          </div>
                                        </template>
                                        <div
                                          class="card card-order-list card-margin shadow border-light"
                                        >
                                          <div class="card-body">
                                            <form
                                              class="form-group"
                                              @submit.prevent="
                                                booking(
                                                  item.room_id,
                                                  prod.time_begin,
                                                  prod.time_end,
                                                  prod.time_id,
                                                  'modal-meeting2culumnMain' +
                                                    item.room_id +
                                                    prod.time_id
                                                )
                                              "
                                              v-if="
                                                (auth.isLibraryStaff === 1 &&
                                                  item.floor !== 6) ||
                                                auth.isLibraryStaff !== 1
                                              "
                                            >
                                              <b-form-select
                                                v-model="selected"
                                                :options="options"
                                                class="mb-3"
                                                value-field="usefor_id"
                                                text-field="usefor_name"
                                                disabled-field="notEnabled"
                                              >
                                                <template #first>
                                                  <b-form-select-option
                                                    :value="null"
                                                    disabled
                                                    >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                  >
                                                </template>
                                              </b-form-select>
                                              <input
                                                type="text"
                                                class="form-control input-style"
                                                placeholder="กรอกวัตถุประสงค์"
                                                v-model="input_another"
                                                v-if="
                                                  selected === 7 ||
                                                  selected === 13 ||
                                                  selected === 16
                                                "
                                              />
                                              <p style="color: red">
                                                **หมายเหตุ : กรอกรหัสนักศึกษา
                                                {{ item.min_person }}
                                                คนขึ้นไป
                                              </p>
                                              <span
                                                style="color: red"
                                                v-if="
                                                  error != '' || error === null
                                                "
                                              >
                                                **{{ error }}
                                              </span>
                                              <div class="space"></div>
                                              <b-row>
                                                <b-col
                                                  cols="6"
                                                  v-for="(
                                                    stdr, index
                                                  ) in input_stdcode"
                                                  :key="index"
                                                >
                                                  <input
                                                    class="form-control input-style"
                                                    placeholder="กรอกรหัสนักศึกษา"
                                                    maxlength="11"
                                                    v-model="values[index]"
                                                  />
                                                </b-col>
                                              </b-row>

                                              <!-- :disabled="!isComplete" -->

                                              <button
                                                :disabled="!isComplete"
                                                type="submit"
                                                class="btn btn-purple deep-purple btn-block badge-pill"
                                                data-dismiss="modal"
                                                @click="showModal = false"
                                              >
                                                ยืนยัน
                                              </button>
                                            </form>

                                            <!-- Teacher -->

                                            <form
                                              class="form-group"
                                              @submit.prevent="
                                                bookingAnother(
                                                  item.room_id,
                                                  prod.time_begin,
                                                  prod.time_end,
                                                  prod.time_id,
                                                  'modal-meeting2culumnMain' +
                                                    item.room_id +
                                                    prod.time_id
                                                )
                                              "
                                              v-if="
                                                auth.isLibraryStaff === 1 &&
                                                item.floor === 6
                                              "
                                            >
                                              <!-- Teacher -->
                                              <span>
                                                <b-button
                                                  variant="outline-primary"
                                                >
                                                  สำหรับอาจารย์
                                                </b-button>
                                              </span>
                                              <span
                                                style="
                                                  color: red;
                                                  font-weight: bold;
                                                "
                                                v-if="
                                                  error != '' || error === null
                                                "
                                              >
                                                ERROR : {{ error }}
                                                <br />
                                                <br />
                                              </span>
                                              <b-row
                                                v-if="
                                                  auth.isLibraryStaff === 1 &&
                                                  item.floor === 6
                                                "
                                              >
                                                <b-col cols="6">
                                                  <input
                                                    class="form-control input-style"
                                                    placeholder="เบอร์โทรศัพท์"
                                                    maxlength=""
                                                    v-model="
                                                      input_room_Teacher.phone
                                                    "
                                                  />
                                                </b-col>
                                                <b-col cols="6">
                                                  <input
                                                    class="form-control input-style"
                                                    placeholder="ชื่อ - นามสกุล"
                                                    maxlength=""
                                                    v-model="
                                                      input_room_Teacher.name
                                                    "
                                                  />
                                                </b-col>

                                                <b-col cols="6">
                                                  <b-form-select
                                                    v-model="selectedfac"
                                                    :options="optionsfac"
                                                    class="mb-3 input-style"
                                                    value-field="fac_code"
                                                    text-field="fac_name"
                                                    disabled-field="notEnabled"
                                                    @change="get_branch()"
                                                  >
                                                    <!-- Teacher -->

                                                    <template #first>
                                                      <b-form-select-option
                                                        :value="null"
                                                        disabled
                                                        >เลือกคณะ</b-form-select-option
                                                      >
                                                    </template>
                                                  </b-form-select>
                                                </b-col>
                                                <b-col cols="6">
                                                  <b-form-select
                                                    v-model="selectedbranch"
                                                    :options="optionsbranch"
                                                    class="mb-3 input-style"
                                                    value-field="branch_code"
                                                    text-field="branch_name"
                                                    disabled-field="notEnabled"
                                                  >
                                                    <!-- Teacher -->

                                                    <template #first>
                                                      <b-form-select-option
                                                        :value="null"
                                                        disabled
                                                        >เลือกสาขา</b-form-select-option
                                                      >
                                                    </template>
                                                  </b-form-select>
                                                </b-col>
                                                <b-col cols="6">
                                                  <input
                                                    class="form-control input-style"
                                                    placeholder="อีเมล"
                                                    maxlength=""
                                                    v-model="
                                                      input_room_Teacher_email
                                                    "
                                                    type="email"
                                                  />
                                                </b-col>

                                                <b-col cols="6">
                                                  <b-form-select
                                                    v-model="selected"
                                                    :options="options"
                                                    class="mb-3"
                                                    value-field="usefor_id"
                                                    text-field="usefor_name"
                                                    disabled-field="notEnabled"
                                                  >
                                                    <template #first>
                                                      <b-form-select-option
                                                        :value="null"
                                                        disabled
                                                        >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                      >
                                                    </template>
                                                  </b-form-select>

                                                  <input
                                                    type="text"
                                                    class="form-control input-style"
                                                    placeholder="กรอกวัตถุประสงค์"
                                                    v-model="input_another"
                                                    v-if="
                                                      selected === 7 ||
                                                      selected === 13 ||
                                                      selected === 16
                                                    "
                                                  />
                                                </b-col>
                                              </b-row>

                                              <!-- :disabled="!isComplete" -->
                                              <button
                                                v-if="
                                                  auth.isLibraryStaff === 1 &&
                                                  item.floor === 6
                                                "
                                                :disabled="!isCompleteAnothor"
                                                type="submit"
                                                class="btn btn-purple deep-purple btn-block badge-pill"
                                                data-dismiss="modal"
                                                @click="showModal = false"
                                              >
                                                ยืนยัน
                                              </button>
                                            </form>
                                          </div>
                                        </div>
                                      </b-modal>

                                      <b-modal
                                        :hide-footer="true"
                                        :hide-header="true"
                                        centered
                                        size="lg"
                                        :id="
                                          'modal-meeting2culumnMain' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        header-border-variant="white"
                                        class="border-bottom-0"
                                        v-if="!chkbookingroom"
                                      >
                                        <div
                                          class="card-body justify-content-center card-block p-3 text-center text-danger"
                                        >
                                          <h5>
                                            <i
                                              class="fa-solid fa-circle-exclamation"
                                            ></i>

                                            {{ msgbookingroom }}
                                          </h5>
                                        </div>
                                      </b-modal>
                                    </span>
                                  </div>
                                  <br />
                                  <span
                                    style="color: gray"
                                    v-if="
                                      item.room_id === 1 ||
                                      item.room_id === 2 ||
                                      item.room_id === 3 ||
                                      item.room_id === 4 ||
                                      item.room_id === 5 ||
                                      item.room_id === 6
                                    "
                                  >
                                    <!-- &nbsp;อุปกรณ์ : รีโมทแอร์ รีโมทจอมอนิเตอร์
                                แปรงลบกระดาน ปากกาไวท์บอร์ด -->
                                    <b-button
                                      pill
                                      variant="outline-primary"
                                      class="b-between"
                                      v-if="!showAcc[index]"
                                      @click="showAccessoriesMore(index)"
                                      size="sm"
                                    >
                                      อุปกรณ์
                                    </b-button>
                                    <b-button
                                      pill
                                      variant="outline-danger"
                                      class="b-between"
                                      v-if="showAcc[index]"
                                      @click="showAccessoriesLess(index)"
                                      size="sm"
                                    >
                                      ปิด
                                    </b-button>
                                    <br />
                                  </span>
                                  <span
                                    style="color: gray"
                                    v-if="item.room_id === 7"
                                  >
                                    <!-- &nbsp;อุปกรณ์ : -->
                                    <!-- อุปกรณ์ -->
                                    <b-button
                                      pill
                                      variant="outline-primary"
                                      class="b-between"
                                      v-if="!showAcc[index]"
                                      @click="showAccessoriesMore(index)"
                                      size="sm"
                                    >
                                      อุปกรณ์
                                    </b-button>
                                    <b-button
                                      pill
                                      variant="outline-danger"
                                      class="b-between"
                                      v-if="showAcc[index]"
                                      @click="showAccessoriesLess(index)"
                                      size="sm"
                                    >
                                      ปิด
                                    </b-button>
                                    <br />

                                    <!-- End -->
                                  </span>
                                </div>
                              </div>

                              <!-- 2A -->
                              <span
                                style="color: gray"
                                v-if="item.room_id === 1"
                              >
                                <!-- &nbsp;อุปกรณ์ : รีโมทแอร์ รีโมทจอมอนิเตอร์
                                แปรงลบกระดาน ปากกาไวท์บอร์ด -->
                                <br />
                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                    <!-- 2 -->

                                    <!-- 3 -->

                                    <!-- 4 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-wb.png"
                                              alt=""
                                              width="36"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> ปากกาไวท์บอร์ด </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!--  -->
                                    <!-- 5 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>&nbsp;&nbsp; HDMI </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 6 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/img/acc-bwb.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              ไวท์บอร์ด [whiteboard]
                                            </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/meetingrooms/tv.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> จอมอนิเตอร์ </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->

                                    <!-- end -->
                                  </div>
                                </span>
                              </span>
                              <!-- END -->
                              <!-- 2B -->

                              <span
                                style="color: gray"
                                v-if="item.room_id === 2"
                              >
                                <!-- &nbsp;อุปกรณ์ : -->
                                <!-- อุปกรณ์ -->

                                <br />

                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                    <!-- 2 -->

                                    <!-- 3 -->

                                    <!-- 4 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-wb.png"
                                              alt=""
                                              width="36"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> ปากกาไวท์บอร์ด </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!--  -->

                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/img/acc-bwb.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              ไวท์บอร์ด [whiteboard]
                                            </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/meetingrooms/tv.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> จอมอนิเตอร์ </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->

                                    <!-- end -->
                                  </div>
                                </span>
                                <!-- End -->
                              </span>

                              <!-- END -->

                              <!-- 3A -->
                              <span
                                style="color: gray"
                                v-if="item.room_id === 3"
                              >
                                <!-- &nbsp;อุปกรณ์ : -->
                                <!-- อุปกรณ์ -->

                                <br />

                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                    <!-- 2 -->

                                    <!-- 3 -->

                                    <!-- 4 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-wb.png"
                                              alt=""
                                              width="36"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> ปากกาไวท์บอร์ด </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!--  -->
                                    <!-- 5 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>&nbsp;&nbsp; HDMI </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 6 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/img/acc-bwb.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              ไวท์บอร์ด [whiteboard]
                                            </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/meetingrooms/tv.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> จอมอนิเตอร์ </span>
                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->

                                    <!-- end -->
                                  </div>
                                </span>
                                <!-- End -->
                              </span>

                              <!-- END -->

                              <!-- 3B -->
                              <span
                                style="color: gray"
                                v-if="item.room_id === 4"
                              >
                                <!-- &nbsp;อุปกรณ์ : -->
                                <!-- อุปกรณ์ -->

                                <br />

                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                    <!-- 2 -->

                                    <!-- 3 -->

                                    <!-- 4 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-wb.png"
                                              alt=""
                                              width="36"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> ปากกาไวท์บอร์ด </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!--  -->
                                    <!-- 5 -->
                                    <!-- <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              HDMI 
                                            </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div> -->
                                    <!-- end -->
                                    <!-- 6 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/img/acc-bwb.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              ไวท์บอร์ด [whiteboard]
                                            </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/meetingrooms/tv.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> จอมอนิเตอร์ </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->

                                    <!-- end -->
                                    <!-- 8 -->

                                    <!-- end -->
                                  </div>
                                </span>
                                <!-- End -->
                              </span>

                              <!-- END -->

                              <!-- 4A -->
                              <span
                                style="color: gray"
                                v-if="item.room_id === 5"
                              >
                                <!-- &nbsp;อุปกรณ์ : -->
                                <!-- อุปกรณ์ -->

                                <br />

                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                    <!-- 2 -->

                                    <!-- 3 -->

                                    <!-- 4 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-wb.png"
                                              alt=""
                                              width="36"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> ปากกาไวท์บอร์ด </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!--  -->
                                    <!-- 5 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> &nbsp;&nbsp;HDMI </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 6 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/img/acc-bwb.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              ไวท์บอร์ด [whiteboard]
                                            </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/meetingrooms/tv.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> จอมอนิเตอร์ </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->

                                    <!-- end -->
                                  </div>
                                </span>
                                <!-- End -->
                              </span>

                              <!-- END -->

                              <!-- 4B -->
                              <span
                                style="color: gray"
                                v-if="item.room_id === 6"
                              >
                                <!-- &nbsp;อุปกรณ์ : -->
                                <!-- อุปกรณ์ -->

                                <br />

                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->

                                    <!-- 2 -->

                                    <!-- 3 -->

                                    <!-- 4 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-wb.png"
                                              alt=""
                                              width="36"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> ปากกาไวท์บอร์ด </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!--  -->
                                    <!-- 5 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/ac4BHDMI.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> &nbsp;&nbsp;HDMI </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 6 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/img/acc-bwb.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              ไวท์บอร์ด [whiteboard]
                                            </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="../../assets/meetingrooms/tv.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> จอมอนิเตอร์ </span>

                                            <br />
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- end -->
                                    <!-- 7 -->

                                    <!-- end -->
                                  </div>
                                </span>
                                <!-- End -->
                              </span>

                              <!-- END -->

                              <!-- 5A -->

                              <span
                                style="color: gray"
                                v-if="item.room_id === 7"
                              >
                                <!-- &nbsp;อุปกรณ์ : -->
                                <!-- อุปกรณ์ -->

                                <br />

                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-bwb.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp; ไวท์บอร์ด
                                              [whiteboard]
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 2 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-pro.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp; โปรเจคเตอร์
                                              [projector]
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 3 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/img/acc-mic.png"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;ไมค์โครโฟน
                                              [microphone]
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                  </div>
                                </span>
                                <!-- End -->
                              </span>
                              <!-- END -->
                            </div>

                            <!-- <hr /> -->
                            <!-- </div> -->
                          </div>
                        </div>
                        <div>
                          <!-- <b-button v-b-modal.modal-1>Launch demo modal</b-button> -->
                        </div>
                      </div>
                    </span>

                    <!-- =============================================== End Main Success Layout ================================== -->
                  </div>

                  <!-- </div>
            </div> -->
                </div>
              </div>
            </b-row>
            <!-- ######################################################  END  2 Culums ########################################################### -->
          </span>
        </b-tab>
        <b-tab title="ห้องสตูดิโอ">
          <!-- Main -->
          <span v-if="!status_show">
            <b-row>
              <div class="container">
                <br />
                <div class="card-columns">
                  <div
                    class="card-room"
                    v-for="(item, index) in status_room"
                    :key="index"
                  >
                    <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ MAIN ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
                    <!-- ================================================ Teacher ==================================== -->
                    <span v-if="!isShowstaff">
                      <!-- <span v-if="item.room_id == 1 || item.room_id == 2"> -->
                      <div class="card-input">
                        <!-- v-if="item.status === 0 && item.freetimes.length !== 0" -->
                        <div
                          class="card card-order-list card-margin border-0 shadow-lg"
                          v-if="item.room_id === 8 || item.room_id === 9"
                        >
                          <div class="card-body">
                            <div class="row">
                              <div class="col-md-2 text-left">
                                <h6>{{ item.room_name }}</h6>
                                <img
                                  v-if="item.room_id === 8"
                                  src="../../assets/meetingrooms/stu1.jpeg"
                                  alt=""
                                  class="zoom"
                                />
                                <img
                                  v-if="item.room_id === 9"
                                  src="../../assets/meetingrooms/stu2.jpeg"
                                  alt=""
                                  class="zoom"
                                />
                              </div>

                              <div class="col-md-10 text-left">
                                <br />
                                <span class="text-secondary">
                                  **เลือกช่วงเวลาเพื่อจอง
                                  <div class="space"></div>
                                </span>
                                <div class="time-column">
                                  <span
                                    v-if="
                                      item.status === 1 ||
                                      (item.status === 0 &&
                                        item.freetimes.length === 0)
                                    "
                                  >
                                    <b-button
                                      pill
                                      variant="outline-secondary"
                                      disabled
                                      class="b-between"
                                    >
                                      08:30-12:00
                                    </b-button>

                                    <b-button
                                      pill
                                      variant="outline-secondary"
                                      disabled
                                      class="b-between"
                                    >
                                      13:00-16:00
                                    </b-button>
                                  </span>

                                  <span
                                    v-for="(prod, j) of item.freetimes"
                                    :key="j"
                                  >
                                    <b-button
                                      v-if="
                                        item.freetimes.length === 1 &&
                                        item.status === 0 &&
                                        prod.time_begin === '13:00'
                                      "
                                      pill
                                      variant="outline-secondary"
                                      disabled
                                      class="b-between"
                                    >
                                      08:30-12:00
                                    </b-button>

                                    <b-button
                                      pill
                                      v-if="
                                        prod.time_begin !== '08:30' ||
                                        prod.time_end !== '16:30'
                                      "
                                      variant="outline-pink"
                                      v-b-modal="
                                        'modal-meetingAnother' +
                                        item.room_id +
                                        prod.time_id
                                      "
                                      class="b-between"
                                      @click="getUsefor(item.room_id)"
                                    >
                                      {{ prod.time_begin }}-{{ prod.time_end }}
                                    </b-button>
                                    <span
                                      v-for="(timechkuser, iu) in historyall"
                                      :key="iu"
                                    >
                                      <b-button
                                        pill
                                        v-if="
                                          timechkuser.room_id ===
                                            item.room_id &&
                                          timechkuser.time_begin === '13:00' &&
                                          timechkuser.time_begin !==
                                            prod.time_begin &&
                                          item.freetimes.length === 1
                                        "
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        13:00-16:30
                                      </b-button>
                                    </span>

                                    <b-modal
                                      :hide-footer="true"
                                      centered
                                      size="lg"
                                      :id="
                                        'modal-meetingAnother' +
                                        item.room_id +
                                        prod.time_id
                                      "
                                      header-border-variant="white"
                                      class="border-bottom-0"
                                      v-if="chkbookingroom"
                                    >
                                      <template #modal-title>
                                        <div
                                          class="card card-order-list card-margin shadow border-light"
                                        >
                                          <div class="card-body">
                                            <i class="fa-solid fa-bookmark"></i>
                                            ห้อง {{ item.room_name }} เวลาจอง
                                            {{ prod.time_begin }} -
                                            {{ prod.time_end }}
                                          </div>
                                        </div>
                                      </template>

                                      <div
                                        class="card card-order-list card-margin shadow border-light"
                                      >
                                        <div class="card-body">
                                          <form
                                            class="form-group"
                                            @submit.prevent="
                                              bookingAnother(
                                                item.room_id,
                                                prod.time_begin,
                                                prod.time_end,
                                                prod.time_id,
                                                'modal-meetingAnother' +
                                                  item.room_id +
                                                  prod.time_id
                                              )
                                            "
                                          >
                                            <p style="color: blue">
                                              *หมายเหตุ :
                                              กรุณาเลือกวัตุประสงค์การใช้งาน
                                            </p>

                                            <b-form-select
                                              v-model="selected"
                                              :options="options"
                                              class="mb-3"
                                              value-field="usefor_id"
                                              text-field="usefor_name"
                                              disabled-field="notEnabled"
                                            >
                                              <template #first>
                                                <b-form-select-option
                                                  :value="null"
                                                  disabled
                                                  >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                >
                                              </template>
                                            </b-form-select>
                                            <span
                                              style="
                                                color: red;
                                                font-weight: bold;
                                              "
                                              v-if="
                                                error != '' || error === null
                                              "
                                            >
                                              ERROR : {{ error }}
                                              <br />
                                              <br />
                                            </span>
                                            <input
                                              type="text"
                                              class="form-control input-style"
                                              placeholder="กรอกวัตถุประสงค์"
                                              v-model="input_another"
                                              v-if="
                                                selected === 7 ||
                                                selected === 13 ||
                                                selected === 16
                                              "
                                            />

                                            <!-- :disabled="!isComplete" -->
                                            <button
                                              :disabled="!isCompleteTeach"
                                              type="submit"
                                              class="btn btn-purple deep-purple btn-block badge-pill"
                                              data-dismiss="modal"
                                              @click="showModal = false"
                                            >
                                              ยืนยัน
                                            </button>
                                          </form>
                                        </div>
                                      </div>
                                    </b-modal>

                                    <b-modal
                                      :hide-footer="true"
                                      :hide-header="true"
                                      centered
                                      size="lg"
                                      :id="
                                        'modal-meetingAnother' +
                                        item.room_id +
                                        prod.time_id
                                      "
                                      header-border-variant="white"
                                      class="border-bottom-0"
                                      v-if="!chkbookingroom"
                                    >
                                      <div
                                        class="card-body justify-content-center card-block p-3 text-center text-danger"
                                      >
                                        <h5>
                                          <i
                                            class="fa-solid fa-circle-exclamation"
                                          ></i>
                                          {{ msgbookingroom }}
                                        </h5>
                                      </div>
                                    </b-modal>
                                  </span>
                                </div>

                                <br />

                                <span
                                  style="color: gray"
                                  v-if="item.room_id === 8"
                                >
                                  <b-button
                                    pill
                                    variant="outline-primary"
                                    class="b-between"
                                    v-if="!showAcc[index]"
                                    @click="showAccessoriesMore(index)"
                                    size="sm"
                                  >
                                    อุปกรณ์
                                  </b-button>
                                  <b-button
                                    pill
                                    variant="outline-danger"
                                    class="b-between"
                                    v-if="showAcc[index]"
                                    @click="showAccessoriesLess(index)"
                                    size="sm"
                                  >
                                    ปิด
                                  </b-button>
                                  <br />
                                </span>

                                <span
                                  style="color: gray"
                                  v-if="item.room_id === 9"
                                >
                                  <b-button
                                    pill
                                    variant="outline-primary"
                                    class="b-between"
                                    v-if="!showAcc[index]"
                                    @click="showAccessoriesMore(index)"
                                    size="sm"
                                  >
                                    อุปกรณ์
                                  </b-button>
                                  <b-button
                                    pill
                                    variant="outline-danger"
                                    class="b-between"
                                    v-if="showAcc[index]"
                                    @click="showAccessoriesLess(index)"
                                    size="sm"
                                  >
                                    ปิด
                                  </b-button>
                                  <br />
                                </span>
                              </div>
                            </div>

                            <span style="color: gray" v-if="item.room_id === 8">
                              <br />
                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/comstu1.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 2 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/moniterstu1.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> &nbsp;&nbsp;จอแสดงผล </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 3 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/camerastu1.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;กล้องบันทึกภาพวิดีโอ
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 4 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/saramonic.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;ไมค์ไร้สาย saramonic
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 5 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/switcherstu1.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;เครื่อง Switcher ภาพ
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 6 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/mixerstu1.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;เครื่องมิกซ์เสียง
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </span>

                            <span style="color: gray" v-if="item.room_id === 9">
                              <br />
                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/comstu2.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 2 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/imac.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> &nbsp;&nbsp; IMAC </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 3 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/moniterstu2.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> &nbsp;&nbsp;จอแสดงผล </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 4 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/camerastu1.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;กล้องบันทึกภาพวิดีโอ
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 5 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/camerastu1.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp; ไมค์ไร้สาย saramonic
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 6 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/mixerstu2.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp; เครื่องมิกซ์เสียง
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 7 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/camerastu1.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp; เครื่อง Switcher
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 8 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/viesonicpc.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp; เครื่อง Viesonic pc
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </span>
                          </div>
                          <!-- <hr /> -->
                        </div>
                      </div>
                      <!-- </span> -->
                    </span>
                    <!-- ================================================ End Teacher ================================ -->

                    <!-- ================================================ Student  ====================================-->
                    <span v-if="isShowstaff">
                      <div class="card-input">
                        <div
                          class="card card-order-list card-margin border-0 shadow-sm"
                          v-if="item.room_id === 8 || item.room_id === 9"
                        >
                          <div class="card-body">
                            <div class="row">
                              <div class="col-md-2 text-left">
                                <h6>{{ item.room_name }}</h6>

                                <img
                                  v-if="item.room_id === 8"
                                  src="../../assets/meetingrooms/stu1.jpeg"
                                  alt=""
                                  class="zoom"
                                />

                                <img
                                  v-if="item.room_id === 9"
                                  src="../../assets/meetingrooms/stu2.jpeg"
                                  alt=""
                                  class="zoom"
                                />
                              </div>

                              <div class="col-md-10 text-left">
                                <br />
                                <span class="text-secondary">
                                  **เลือกช่วงเวลาเพื่อจอง
                                  <div class="space"></div>
                                </span>
                                <div class="time-column">
                                  <span
                                    v-if="
                                      item.status === 1 ||
                                      (item.status === 0 &&
                                        item.freetimes.length === 0)
                                    "
                                  >
                                    <b-button
                                      pill
                                      variant="outline-secondary"
                                      disabled
                                      class="b-between"
                                    >
                                      08:30-12:00
                                    </b-button>

                                    <b-button
                                      pill
                                      variant="outline-secondary"
                                      disabled
                                      class="b-between"
                                    >
                                      13:00-16:00
                                    </b-button>
                                  </span>
                                  <span
                                    v-for="(prod, j) of item.freetimes"
                                    :key="j"
                                  >
                                    <span v-if="!user">
                                      <b-button
                                        v-if="
                                          item.freetimes.length === 1 &&
                                          item.status === 0 &&
                                          prod.time_begin === '13:00'
                                        "
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>
                                      <b-button
                                        v-if="
                                          item.freetimes.length === 1 &&
                                          item.status === 0 &&
                                          prod.time_begin === '16:30'
                                        "
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        13:00-16:30
                                      </b-button>

                                      <b-button
                                        pill
                                        v-if="
                                          prod.time_begin !== '08:30' ||
                                          prod.time_end !== '16:30'
                                        "
                                        variant="outline-pink"
                                        v-b-modal="
                                          'modal-meetingMain' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        class="b-between"
                                        @click="getUsefor(item.room_id)"
                                      >
                                        {{ prod.time_begin }}-{{
                                          prod.time_end
                                        }}
                                      </b-button>

                                      <span
                                        v-for="(timechkuse, iue) in historyall"
                                        :key="iue"
                                      >
                                        <b-button
                                          pill
                                          v-if="
                                            timechkuse.room_id ===
                                              item.room_id &&
                                            timechkuse.time_begin === '13:00' &&
                                            timechkuse.time_begin !==
                                              prod.time_begin &&
                                            item.freetimes.length === 1
                                          "
                                          variant="outline-secondary"
                                          disabled
                                          class="b-between"
                                        >
                                          13:00-16:30
                                        </b-button>
                                      </span>
                                    </span>

                                    <!-- if user :login  -->
                                    <span v-if="user">
                                      <b-button
                                        v-if="
                                          item.freetimes.length === 1 &&
                                          item.status === 0 &&
                                          prod.time_begin === '13:00'
                                        "
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>

                                      <b-button
                                        pill
                                        v-if="
                                          prod.time_begin !== '08:30' ||
                                          (prod.time_end !== '16:30' &&
                                            item.freetimes.length !== 0)
                                        "
                                        variant="outline-pink"
                                        class="b-between"
                                        href="/login"
                                      >
                                        {{ prod.time_begin }}-{{
                                          prod.time_end
                                        }}
                                      </b-button>

                                      <span
                                        v-for="(timechkuser, iu) in historyall"
                                        :key="iu"
                                      >
                                        <b-button
                                          pill
                                          v-if="
                                            timechkuser.room_id ===
                                              item.room_id &&
                                            timechkuser.time_begin ===
                                              '13:00' &&
                                            timechkuser.time_begin !==
                                              prod.time_begin &&
                                            item.freetimes.length === 1
                                          "
                                          variant="outline-secondary"
                                          disabled
                                          class="b-between"
                                        >
                                          13:00-16:30
                                        </b-button>
                                      </span>
                                    </span>

                                    <b-modal
                                      :hide-footer="true"
                                      v-if="chkbookingroom"
                                      centered
                                      size="lg"
                                      :id="
                                        'modal-meetingMain' +
                                        item.room_id +
                                        prod.time_id
                                      "
                                      header-border-variant="white"
                                      class="border-bottom-0"
                                    >
                                      <template #modal-title>
                                        <div
                                          class="card card-order-list card-margin shadow-sm border-light card-time-title"
                                        >
                                          <div class="card-body">
                                            <i class="fa-solid fa-bookmark"></i>
                                            ห้อง {{ item.room_name }} เวลาจอง
                                            {{ prod.time_begin }} -
                                            {{ prod.time_end }}
                                          </div>
                                        </div>
                                      </template>
                                      <div
                                        class="card card-order-list card-margin shadow-sm border-light card-time-body"
                                      >
                                        <div class="card-body">
                                          <form
                                            class="form-group"
                                            @submit.prevent="
                                              booking(
                                                item.room_id,
                                                prod.time_begin,
                                                prod.time_end,
                                                prod.time_id,
                                                'modal-meetingMain' +
                                                  item.room_id +
                                                  prod.time_id
                                              )
                                            "
                                            v-if="
                                              (auth.isLibraryStaff === 1 &&
                                                item.floor !== 6) ||
                                              auth.isLibraryStaff !== 1
                                            "
                                          >
                                            <b-form-select
                                              v-model="selected"
                                              :options="options"
                                              class="mb-3 input-style"
                                              value-field="usefor_id"
                                              text-field="usefor_name"
                                              disabled-field="notEnabled"
                                            >
                                              <template #first>
                                                <b-form-select-option
                                                  :value="null"
                                                  disabled
                                                  >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                >
                                              </template>
                                            </b-form-select>
                                            <input
                                              type="text"
                                              class="form-control input-style"
                                              placeholder="กรอกวัตถุประสงค์"
                                              v-model="input_another"
                                              v-if="
                                                selected === 7 ||
                                                selected === 13 ||
                                                selected === 16
                                              "
                                            />
                                            <p style="color: red">
                                              **หมายเหตุ : กรอกรหัสนักศึกษา
                                              {{ item.min_person }} คนขึ้นไป
                                            </p>
                                            <span
                                              style="color: red"
                                              v-if="
                                                error != '' || error === null
                                              "
                                            >
                                              **{{ error }}
                                            </span>
                                            <!-- <div class="space"></div> -->

                                            <b-row>
                                              <b-col
                                                cols="6"
                                                v-for="(
                                                  stdr, index
                                                ) in input_stdcode"
                                                :key="index"
                                              >
                                                <input
                                                  class="form-control input-style"
                                                  placeholder="กรอกรหัสนักศึกษา"
                                                  maxlength="11"
                                                  v-model="values[index]"
                                                />
                                              </b-col>
                                            </b-row>

                                            <button
                                              :disabled="!isComplete"
                                              type="submit"
                                              class="btn btn-purple deep-purple btn-block badge-pill"
                                              data-dismiss="modal"
                                              @click="showModal = false"
                                            >
                                              ยืนยัน
                                            </button>
                                          </form>

                                          <form
                                            class="form-group"
                                            @submit.prevent="
                                              bookingAnother(
                                                item.room_id,
                                                prod.time_begin,
                                                prod.time_end,
                                                prod.time_id,
                                                'modal-meetingMain' +
                                                  item.room_id +
                                                  prod.time_id
                                              )
                                            "
                                            v-if="
                                              auth.isLibraryStaff === 1 &&
                                              item.floor === 6
                                            "
                                          >
                                            <!-- Teacher -->
                                            <span>
                                              <b-button
                                                variant="outline-primary"
                                              >
                                                สำหรับอาจารย์
                                              </b-button>
                                            </span>
                                            <span
                                              style="
                                                color: red;
                                                font-weight: bold;
                                              "
                                              v-if="
                                                error != '' || error === null
                                              "
                                            >
                                              ERROR : {{ error }}
                                              <br />
                                              <br />
                                            </span>
                                            <b-row>
                                              <b-col cols="6">
                                                <input
                                                  class="form-control input-style"
                                                  placeholder="เบอร์โทรศัพท์"
                                                  maxlength="10"
                                                  v-model="
                                                    input_room_Teacher_phone
                                                  "
                                                />
                                              </b-col>
                                              <b-col cols="6">
                                                <input
                                                  class="form-control input-style"
                                                  placeholder="ชื่อ - นามสกุล"
                                                  v-model="
                                                    input_room_Teacher_name
                                                  "
                                                  autocomplete
                                                />
                                              </b-col>
                                              <!-- this.optionsfac -->
                                              <b-col cols="6">
                                                <b-form-select
                                                  v-model="selectedfac"
                                                  :options="optionsfac"
                                                  class="mb-3 input-style"
                                                  value-field="fac_code"
                                                  text-field="fac_name"
                                                  disabled-field="notEnabled"
                                                  @change="get_branch()"
                                                >
                                                  <!-- Teacher -->

                                                  <template #first>
                                                    <b-form-select-option
                                                      :value="null"
                                                      disabled
                                                      >เลือกคณะ</b-form-select-option
                                                    >
                                                  </template>
                                                </b-form-select>
                                              </b-col>
                                              <b-col cols="6">
                                                <b-form-select
                                                  v-model="selectedbranch"
                                                  :options="optionsbranch"
                                                  class="mb-3 input-style"
                                                  value-field="branch_code"
                                                  text-field="branch_name"
                                                  disabled-field="notEnabled"
                                                >
                                                  <!-- Teacher -->

                                                  <template #first>
                                                    <b-form-select-option
                                                      :value="null"
                                                      disabled
                                                      >เลือกสาขา</b-form-select-option
                                                    >
                                                  </template>
                                                </b-form-select>
                                              </b-col>
                                              <b-col cols="6">
                                                <input
                                                  class="form-control input-style"
                                                  placeholder="อีเมล"
                                                  maxlength=""
                                                  v-model="
                                                    input_room_Teacher_email
                                                  "
                                                  type="email"
                                                />
                                              </b-col>
                                              <b-col cols="6">
                                                <b-form-select
                                                  v-model="selected"
                                                  :options="options"
                                                  class="mb-3 input-style"
                                                  value-field="usefor_id"
                                                  text-field="usefor_name"
                                                  disabled-field="notEnabled"
                                                >
                                                  <!-- Teacher -->

                                                  <template #first>
                                                    <b-form-select-option
                                                      :value="null"
                                                      disabled
                                                      >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                    >
                                                  </template>
                                                </b-form-select>
                                                <input
                                                  type="text"
                                                  class="form-control input-style"
                                                  placeholder="กรอกวัตถุประสงค์"
                                                  v-model="input_another"
                                                  v-if="
                                                    selected === 7 ||
                                                    selected === 13 ||
                                                    selected === 16
                                                  "
                                                />
                                              </b-col>
                                            </b-row>

                                            <!-- :disabled="!isComplete" -->
                                            <button
                                              v-if="
                                                auth.isLibraryStaff === 1 &&
                                                item.floor === 6
                                              "
                                              :disabled="!isCompleteAnothor"
                                              type="submit"
                                              class="btn btn-purple deep-purple btn-block badge-pill"
                                              data-dismiss="modal"
                                              @click="showModal = false"
                                            >
                                              ยืนยัน
                                            </button>
                                          </form>
                                        </div>
                                      </div>
                                    </b-modal>

                                    <b-modal
                                      :hide-footer="true"
                                      :hide-header="true"
                                      centered
                                      size="lg"
                                      :id="
                                        'modal-meetingMain' +
                                        item.room_id +
                                        prod.time_id
                                      "
                                      header-border-variant="white"
                                      class="border-bottom-0"
                                      v-if="!chkbookingroom"
                                    >
                                      <div
                                        class="card-body justify-content-center card-block p-3 text-center text-danger"
                                      >
                                        <h5>
                                          <i
                                            class="fa-solid fa-circle-exclamation"
                                          ></i>
                                          {{ msgbookingroom }}
                                        </h5>
                                      </div>
                                    </b-modal>
                                  </span>
                                </div>
                                <br />

                                <span style="color: gray">
                                  <b-button
                                    pill
                                    variant="outline-primary"
                                    class="b-between"
                                    v-if="!showAcc[index]"
                                    @click="showAccessoriesMore(index)"
                                    size="sm"
                                  >
                                    อุปกรณ์
                                  </b-button>
                                  <b-button
                                    pill
                                    variant="outline-danger"
                                    class="b-between"
                                    v-if="showAcc[index]"
                                    @click="showAccessoriesLess(index)"
                                    size="sm"
                                  >
                                    ปิด
                                  </b-button>
                                  <br />

                                  <!-- End -->
                                </span>
                              </div>
                            </div>

                            <span style="color: gray" v-if="item.room_id === 8">
                              <br />
                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/comstu1.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 2 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/moniterstu1.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> &nbsp;&nbsp;จอแสดงผล </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 3 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/camerastu1.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;กล้องบันทึกภาพวิดีโอ
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 4 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/saramonic.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;ไมค์ไร้สาย saramonic
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 5 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/switcherstu1.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;เครื่อง Switcher ภาพ
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 6 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/mixerstu1.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;เครื่องมิกซ์เสียง
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </span>

                            <span style="color: gray" v-if="item.room_id === 9">
                              <br />
                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/comstu2.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 2 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/imac.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> &nbsp;&nbsp; IMAC </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 3 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/moniterstu2.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> &nbsp;&nbsp;จอแสดงผล </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 4 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/camerastu1.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;กล้องบันทึกภาพวิดีโอ
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 5 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/camerastu1.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp; ไมค์ไร้สาย saramonic
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 6 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/mixerstu2.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp; เครื่องมิกซ์เสียง
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 7 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/camerastu1.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp; เครื่อง Switcher
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 8 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/viesonicpc.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp; เครื่อง Viesonic pc
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </span>
                          </div>
                          <!-- <hr /> -->
                          <!-- v-if="item.status === 0" -->
                        </div>

                        <div></div>
                      </div>
                    </span>
                    <!-- ================================================ End student ================================ -->
                    <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ END MAIN ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
                    <!-- ###################################################### 2 Culums #################################################################  -->
                    <!-- ######################################################  END  2 Culums ########################################################### -->
                  </div>
                </div>
              </div>
            </b-row>
          </span>

          <!-- 2 Culums -->
          <span v-if="status_show">
            <!-- ###################################################### 2 Culums #################################################################  -->
            <br />
            <b-row>
              <div class="col-md-4 text-left">
                <div class="card-columns">
                  <!-- <div class="card card-order-list card-margin shadow border-light">
              <div class="card-body rounded-card"> -->

                  <div class="card-room">
                    <div class="card-myroom">
                      <div
                        class="card card-order-list card-margin border-0 shadow"
                      >
                        <div class="card-body card-body-size">
                          <h5 class="text-center">ห้องที่จอง</h5>
                        </div>
                      </div>

                      <!-- returned -->
                      <span v-for="(std, inx) in history" :key="inx">
                        <div
                          class="card card-order-list card-margin border-0 shadow-lg"
                        >
                          <!-- v-if="std.trans_status !== 'returned'" -->
                          <div class="card-body">
                            <!-- approved -->
                            <span
                              v-if="
                                std.room_id === 8 ||
                                std.room_id === 9 ||
                                std.room_id === 10
                              "
                            >
                              <span
                                class="text-danger"
                                v-if="std.trans_status === 'booked'"
                              >
                                <b>Scan qrcode เพื่อยืนยันการใช้งาน </b>
                              </span>

                              <span
                                class="text-info"
                                v-if="std.trans_status === 'confirmed'"
                              >
                                <b>ยืนยันการจองเรียบร้อย</b>
                              </span>

                              <span
                                class="text-success"
                                v-if="std.trans_status === 'approved'"
                              >
                                <b>อนุมัติการจอง</b>
                              </span>

                              <span
                                class="text-primary"
                                v-if="std.trans_status === 'endofuse'"
                              >
                                <b>เสร็จสิ้น</b>
                              </span>
                              <br />
                            </span>

                            <span> ผู้จอง : {{ auth.std_name }} </span> <br />
                            <span>
                              ห้อง : <b>{{ std.room_name }}</b></span
                            >
                            <br />
                            <span>
                              เวลา : {{ std.time_begin }} -
                              {{ std.time_end }}</span
                            >
                            <br />
                            <span>
                              วันจอง : {{ std.meeting_date | moment }}</span
                            >
                            <br />

                            <span class="" v-if="!readMore[inx]">
                              <span
                                style="color: hotpink; font-size: 14px"
                                class=""
                                v-if="!readMore[inx]"
                                @click="showMore(inx)"
                              >
                                <i class="fas fa-ellipsis-v"></i>
                                เพิ่มเติม
                              </span>
                            </span>
                            <span class="" v-if="readMore[inx]">
                              สมาชิก :
                              <span v-for="(pro, k) of std.students" :key="k">
                                {{ pro.std_name }},
                              </span>
                              <span
                                style="color: hotpink"
                                v-if="readMore[inx]"
                                @click="showLess(inx)"
                              >
                                [ย่อ]
                              </span>
                            </span>
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-8 text-left">
                <div class="card-columns">
                  <div
                    class="card-room"
                    v-for="(item, index) in status_room"
                    :key="index"
                  >
                    <!-- {{  item.freetimes.length}} -->
                    <!-- =============================================== Teacher Anothor Success Layout ================================== -->
                    <!-- แก้ไขเปลี่ยนโชว์ปุ่ม พร้อมอัพเดทสภถานะว่า มีการจองแล้ง Disable button -->
                    <span v-if="!isShowstaff">
                      <!-- v-if="item.room_id == 1 || item.room_id == 2" -->
                      <!-- modal-meeting2culumnTeacher -->
                      <span>
                        <div
                          class="card-input"
                          v-if="
                            item.status === 0 && item.freetimes.length !== 0
                          "
                        >
                          <div
                            class="card card-order-list card-margin border-0 shadow"
                            v-if="item.room_id === 8 || item.room_id === 9"
                          >
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-3 text-left">
                                  <h6>{{ item.room_name }}</h6>
                                  <img
                                    v-if="item.room_id === 8"
                                    src="../../assets/meetingrooms/stu1.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                  <img
                                    v-if="item.room_id === 9"
                                    src="../../assets/meetingrooms/stu2.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                  <!-- meeting  -->
                                </div>

                                <div class="col-md-9 text-left">
                                  <br />
                                  <div class="time-column">
                                    <span
                                      v-if="
                                        item.status === 1 ||
                                        (item.status === 0 &&
                                          item.freetimes.length === 0)
                                      "
                                    >
                                      <b-button
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>

                                      <b-button
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        13:00-16:00
                                      </b-button>
                                    </span>

                                    <span
                                      v-for="(prod, j) of item.freetimes"
                                      :key="j"
                                    >
                                      <b-button
                                        v-if="
                                          item.freetimes.length === 1 &&
                                          item.status === 0 &&
                                          prod.time_begin === '13:00'
                                        "
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>

                                      <b-button
                                        pill
                                        v-if="
                                          prod.time_begin !== '08:30' ||
                                          prod.time_end !== '16:30'
                                        "
                                        variant="outline-pink"
                                        v-b-modal="
                                          'modal-meeting2culumnTeacher' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        class="b-between"
                                        @click="getUsefor(item.room_id)"
                                      >
                                        {{ prod.time_begin }}-{{
                                          prod.time_end
                                        }}
                                      </b-button>
                                      <span
                                        v-for="(timechkuser, iu) in historyall"
                                        :key="iu"
                                      >
                                        <b-button
                                          pill
                                          v-if="
                                            timechkuser.room_id ===
                                              item.room_id &&
                                            timechkuser.time_begin ===
                                              '13:00' &&
                                            timechkuser.time_begin !==
                                              prod.time_begin &&
                                            item.freetimes.length === 1
                                          "
                                          variant="outline-secondary"
                                          disabled
                                          class="b-between"
                                        >
                                          13:00-16:30
                                        </b-button>
                                      </span>

                                      <b-modal
                                        :hide-footer="true"
                                        centered
                                        size="lg"
                                        :id="
                                          'modal-meeting2culumnTeacher' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        header-border-variant="white"
                                        class="border-bottom-0"
                                        v-if="chkbookingroom"
                                      >
                                        <template #modal-title>
                                          <div
                                            class="card card-order-list card-margin shadow border-light"
                                          >
                                            <div class="card-body">
                                              <i
                                                class="fa-solid fa-bookmark"
                                              ></i>
                                              ห้อง {{ item.room_name }} เวลาจอง
                                              {{ prod.time_begin }} -
                                              {{ prod.time_end }}
                                            </div>
                                          </div>
                                        </template>

                                        <div
                                          class="card card-order-list card-margin shadow border-light"
                                        >
                                          <div class="card-body">
                                            <form
                                              class="form-group"
                                              @submit.prevent="
                                                bookingAnother(
                                                  item.room_id,
                                                  prod.time_begin,
                                                  prod.time_end,
                                                  prod.time_id,
                                                  'modal-meeting2culumnTeacher' +
                                                    item.room_id +
                                                    prod.time_id
                                                )
                                              "
                                            >
                                              <p style="color: blue">
                                                *หมายเหตุ :
                                                กรุณาเลือกวัตุประสงค์การใช้งาน
                                              </p>

                                              <b-form-select
                                                v-model="selected"
                                                :options="options"
                                                class="mb-3"
                                                value-field="usefor_id"
                                                text-field="usefor_name"
                                                disabled-field="notEnabled"
                                              >
                                                <template #first>
                                                  <b-form-select-option
                                                    :value="null"
                                                    disabled
                                                    >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                  >
                                                </template>
                                              </b-form-select>
                                              <span
                                                style="
                                                  color: red;
                                                  font-weight: bold;
                                                "
                                                v-if="
                                                  error != '' || error === null
                                                "
                                              >
                                                ERROR : {{ error }}
                                                <br />
                                                <br />
                                              </span>
                                              <input
                                                type="text"
                                                class="form-control input-style"
                                                placeholder="กรอกวัตถุประสงค์"
                                                v-model="input_another"
                                                v-if="
                                                  selected === 7 ||
                                                  selected === 13 ||
                                                  selected === 16
                                                "
                                              />

                                              <button
                                                :disabled="!isCompleteTeach"
                                                type="submit"
                                                class="btn btn-purple deep-purple btn-block badge-pill"
                                                data-dismiss="modal"
                                                @click="showModal = false"
                                              >
                                                ยืนยัน
                                              </button>
                                            </form>
                                          </div>
                                        </div>
                                      </b-modal>

                                      <b-modal
                                        :hide-footer="true"
                                        :hide-header="true"
                                        centered
                                        size="lg"
                                        :id="
                                          'modal-meeting2culumnTeacher' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        header-border-variant="white"
                                        class="border-bottom-0"
                                        v-if="!chkbookingroom"
                                      >
                                        <div
                                          class="card-body justify-content-center card-block p-3 text-center text-danger"
                                        >
                                          <h5>
                                            <i
                                              class="fa-solid fa-circle-exclamation"
                                            ></i>
                                            {{ msgbookingroom }}
                                          </h5>
                                        </div>
                                      </b-modal>
                                    </span>
                                  </div>
                                  <br />

                                  <span
                                    style="color: gray"
                                    v-if="item.room_id === 8"
                                  >
                                    <b-button
                                      pill
                                      variant="outline-primary"
                                      class="b-between"
                                      v-if="!showAcc[index]"
                                      @click="showAccessoriesMore(index)"
                                      size="sm"
                                    >
                                      อุปกรณ์
                                    </b-button>
                                    <b-button
                                      pill
                                      variant="outline-danger"
                                      class="b-between"
                                      v-if="showAcc[index]"
                                      @click="showAccessoriesLess(index)"
                                      size="sm"
                                    >
                                      ปิด
                                    </b-button>
                                    <br />
                                  </span>

                                  <span
                                    style="color: gray"
                                    v-if="item.room_id === 9"
                                  >
                                    <b-button
                                      pill
                                      variant="outline-primary"
                                      class="b-between"
                                      v-if="!showAcc[index]"
                                      @click="showAccessoriesMore(index)"
                                      size="sm"
                                    >
                                      อุปกรณ์
                                    </b-button>
                                    <b-button
                                      pill
                                      variant="outline-danger"
                                      class="b-between"
                                      v-if="showAcc[index]"
                                      @click="showAccessoriesLess(index)"
                                    >
                                      ปิด
                                    </b-button>
                                    <br />
                                  </span>
                                  <span
                                    style="color: gray"
                                    v-if="item.room_id === 10"
                                  >
                                    <b-button
                                      pill
                                      variant="outline-primary"
                                      class="b-between"
                                      v-if="!showAcc[index]"
                                      @click="showAccessoriesMore(index)"
                                      size="sm"
                                    >
                                      อุปกรณ์
                                    </b-button>
                                    <b-button
                                      pill
                                      variant="outline-danger"
                                      class="b-between"
                                      v-if="showAcc[index]"
                                      @click="showAccessoriesLess(index)"
                                    >
                                      ปิด
                                    </b-button>
                                    <br />
                                  </span>
                                </div>
                              </div>

                              <span
                                style="color: gray"
                                v-if="item.room_id === 8"
                              >
                                <br />
                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/comstu1.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 2 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/moniterstu1.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> &nbsp;&nbsp;จอแสดงผล </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 3 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/camerastu1.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;กล้องบันทึกภาพวิดีโอ
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 4 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/saramonic.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;ไมค์ไร้สาย saramonic
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 5 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/switcherstu1.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;เครื่อง Switcher ภาพ
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 6 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/mixerstu1.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;เครื่องมิกซ์เสียง
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                  </div>
                                </span>
                              </span>

                              <span
                                style="color: gray"
                                v-if="item.room_id === 9"
                              >
                                <br />
                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/comstu2.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 2 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/imac.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> &nbsp;&nbsp; IMAC </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 3 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/moniterstu2.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> &nbsp;&nbsp;จอแสดงผล </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 4 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/camerastu1.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;กล้องบันทึกภาพวิดีโอ
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 5 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/camerastu1.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp; ไมค์ไร้สาย saramonic
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 6 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/mixerstu2.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp; เครื่องมิกซ์เสียง
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 7 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/camerastu1.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp; เครื่อง Switcher
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 8 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/viesonicpc.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp; เครื่อง Viesonic pc
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                  </div>
                                </span>
                              </span>
                            </div>
                            <!-- <hr v-if="item.status === 0" /> -->
                          </div>
                        </div>
                      </span>
                    </span>
                    <!-- =============================================== End AnothorSuccess Layout ================================== -->

                    <!-- =============================================== 2 culumn Main Success Layout ================================== -->
                    <span v-if="isShowstaff">
                      <div class="card-input">
                        <!-- v-if="item.status === 0 " -->
                        <!-- && item.freetimes.length !== 0 -->
                        <!-- <div class="card card-order-list card-margin border-0"> -->

                        <div class="card-input">
                          <div
                            class="card card-order-list card-margin border-0 shadow"
                            v-if="item.room_id === 8 || item.room_id === 9"
                          >
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-3 text-left">
                                  <h6>{{ item.room_name }}</h6>
                                  <img
                                    v-if="item.room_id === 8"
                                    src="../../assets/meetingrooms/stu1.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                  <img
                                    v-if="item.room_id === 9"
                                    src="../../assets/meetingrooms/stu2.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                  <!-- meeting  -->
                                </div>

                                <div class="col-md-9 text-left">
                                  <br />
                                  <span class="text-secondary">
                                    **เลือกช่วงเวลาเพื่อจอง
                                    <div class="space"></div>
                                  </span>

                                  <div class="time-column">
                                    <span
                                      v-if="
                                        item.status === 1 ||
                                        (item.status === 0 &&
                                          item.freetimes.length === 0)
                                      "
                                    >
                                      <b-button
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>

                                      <b-button
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        13:00-16:00
                                      </b-button>
                                    </span>
                                    <span
                                      v-for="(prod, j) of item.freetimes"
                                      :key="j"
                                    >
                                      <b-button
                                        v-if="
                                          item.freetimes.length === 1 &&
                                          item.status === 0 &&
                                          prod.time_begin === '13:00'
                                        "
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>

                                      <b-button
                                        pill
                                        v-if="
                                          prod.time_begin !== '08:30' ||
                                          (prod.time_end !== '16:30' &&
                                            item.status === 0)
                                        "
                                        variant="outline-pink"
                                        v-b-modal="
                                          'modal-meeting2culumnMain' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        class="b-between"
                                        @click="getUsefor(item.room_id)"
                                      >
                                        {{ prod.time_begin }}-{{
                                          prod.time_end
                                        }}
                                      </b-button>

                                      <span
                                        v-for="(timechk, i) in history"
                                        :key="i"
                                      >
                                        <b-button
                                          pill
                                          v-if="
                                            timechk.room_id === item.room_id &&
                                            timechk.time_begin === '13:00' &&
                                            timechk.time_begin !==
                                              prod.time_begin &&
                                            item.freetimes.length === 1
                                          "
                                          variant="outline-secondary"
                                          disabled
                                          class="b-between"
                                        >
                                          13:00-16:30
                                        </b-button>
                                      </span>

                                      <b-modal
                                        :hide-footer="true"
                                        centered
                                        size="lg"
                                        :id="
                                          'modal-meeting2culumnMain' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        header-border-variant="white"
                                        class="border-bottom-0"
                                        v-if="chkbookingroom"
                                      >
                                        <template #modal-title>
                                          <div
                                            class="card card-order-list card-margin shadow border-light"
                                          >
                                            <div class="card-body">
                                              <i
                                                class="fa-solid fa-bookmark"
                                              ></i>
                                              ห้อง {{ item.room_name }} เวลาจอง
                                              {{ prod.time_begin }} -
                                              {{ prod.time_end }}
                                            </div>
                                          </div>
                                        </template>
                                        <div
                                          class="card card-order-list card-margin shadow border-light"
                                        >
                                          <div class="card-body">
                                            <form
                                              class="form-group"
                                              @submit.prevent="
                                                booking(
                                                  item.room_id,
                                                  prod.time_begin,
                                                  prod.time_end,
                                                  prod.time_id,
                                                  'modal-meeting2culumnMain' +
                                                    item.room_id +
                                                    prod.time_id
                                                )
                                              "
                                              v-if="
                                                (auth.isLibraryStaff === 1 &&
                                                  item.floor !== 6) ||
                                                auth.isLibraryStaff !== 1
                                              "
                                            >
                                              <b-form-select
                                                v-model="selected"
                                                :options="options"
                                                class="mb-3"
                                                value-field="usefor_id"
                                                text-field="usefor_name"
                                                disabled-field="notEnabled"
                                              >
                                                <template #first>
                                                  <b-form-select-option
                                                    :value="null"
                                                    disabled
                                                    >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                  >
                                                </template>
                                              </b-form-select>
                                              <input
                                                type="text"
                                                class="form-control input-style"
                                                placeholder="กรอกวัตถุประสงค์"
                                                v-model="input_another"
                                                v-if="
                                                  selected === 7 ||
                                                  selected === 13 ||
                                                  selected === 16
                                                "
                                              />
                                              <p style="color: red">
                                                **หมายเหตุ : กรอกรหัสนักศึกษา
                                                {{ item.min_person }}
                                                คนขึ้นไป
                                              </p>
                                              <span
                                                style="color: red"
                                                v-if="
                                                  error != '' || error === null
                                                "
                                              >
                                                **{{ error }}
                                              </span>
                                              <div class="space"></div>
                                              <b-row>
                                                <b-col
                                                  cols="6"
                                                  v-for="(
                                                    stdr, index
                                                  ) in input_stdcode"
                                                  :key="index"
                                                >
                                                  <input
                                                    class="form-control input-style"
                                                    placeholder="กรอกรหัสนักศึกษา"
                                                    maxlength="11"
                                                    v-model="values[index]"
                                                  />
                                                </b-col>
                                              </b-row>

                                              <!-- :disabled="!isComplete" -->

                                              <button
                                                :disabled="!isComplete"
                                                type="submit"
                                                class="btn btn-purple deep-purple btn-block badge-pill"
                                                data-dismiss="modal"
                                                @click="showModal = false"
                                              >
                                                ยืนยัน
                                              </button>
                                            </form>

                                            <!-- Teacher -->

                                            <form
                                              class="form-group"
                                              @submit.prevent="
                                                bookingAnother(
                                                  item.room_id,
                                                  prod.time_begin,
                                                  prod.time_end,
                                                  prod.time_id,
                                                  'modal-meeting2culumnMain' +
                                                    item.room_id +
                                                    prod.time_id
                                                )
                                              "
                                              v-if="
                                                auth.isLibraryStaff === 1 &&
                                                item.floor === 6
                                              "
                                            >
                                              <!-- Teacher -->
                                              <span>
                                                <b-button
                                                  variant="outline-primary"
                                                >
                                                  สำหรับอาจารย์
                                                </b-button>
                                              </span>
                                              <span
                                                style="
                                                  color: red;
                                                  font-weight: bold;
                                                "
                                                v-if="
                                                  error != '' || error === null
                                                "
                                              >
                                                ERROR : {{ error }}
                                                <br />
                                                <br />
                                              </span>
                                              <b-row
                                                v-if="
                                                  auth.isLibraryStaff === 1 &&
                                                  item.floor === 6
                                                "
                                              >
                                                <b-col cols="6">
                                                  <input
                                                    class="form-control input-style"
                                                    placeholder="เบอร์โทรศัพท์"
                                                    maxlength=""
                                                    v-model="
                                                      input_room_Teacher.phone
                                                    "
                                                  />
                                                </b-col>
                                                <b-col cols="6">
                                                  <input
                                                    class="form-control input-style"
                                                    placeholder="ชื่อ - นามสกุล"
                                                    maxlength=""
                                                    v-model="
                                                      input_room_Teacher.name
                                                    "
                                                  />
                                                </b-col>

                                                <b-col cols="6">
                                                  <b-form-select
                                                    v-model="selectedfac"
                                                    :options="optionsfac"
                                                    class="mb-3 input-style"
                                                    value-field="fac_code"
                                                    text-field="fac_name"
                                                    disabled-field="notEnabled"
                                                    @change="get_branch()"
                                                  >
                                                    <!-- Teacher -->

                                                    <template #first>
                                                      <b-form-select-option
                                                        :value="null"
                                                        disabled
                                                        >เลือกคณะ</b-form-select-option
                                                      >
                                                    </template>
                                                  </b-form-select>
                                                </b-col>
                                                <b-col cols="6">
                                                  <b-form-select
                                                    v-model="selectedbranch"
                                                    :options="optionsbranch"
                                                    class="mb-3 input-style"
                                                    value-field="branch_code"
                                                    text-field="branch_name"
                                                    disabled-field="notEnabled"
                                                  >
                                                    <!-- Teacher -->

                                                    <template #first>
                                                      <b-form-select-option
                                                        :value="null"
                                                        disabled
                                                        >เลือกสาขา</b-form-select-option
                                                      >
                                                    </template>
                                                  </b-form-select>
                                                </b-col>
                                                <b-col cols="6">
                                                  <input
                                                    class="form-control input-style"
                                                    placeholder="อีเมล"
                                                    maxlength=""
                                                    v-model="
                                                      input_room_Teacher_email
                                                    "
                                                    type="email"
                                                  />
                                                </b-col>

                                                <b-col cols="6">
                                                  <b-form-select
                                                    v-model="selected"
                                                    :options="options"
                                                    class="mb-3"
                                                    value-field="usefor_id"
                                                    text-field="usefor_name"
                                                    disabled-field="notEnabled"
                                                  >
                                                    <template #first>
                                                      <b-form-select-option
                                                        :value="null"
                                                        disabled
                                                        >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                      >
                                                    </template>
                                                  </b-form-select>

                                                  <input
                                                    type="text"
                                                    class="form-control input-style"
                                                    placeholder="กรอกวัตถุประสงค์"
                                                    v-model="input_another"
                                                    v-if="
                                                      selected === 7 ||
                                                      selected === 13 ||
                                                      selected === 16
                                                    "
                                                  />
                                                </b-col>
                                              </b-row>

                                              <!-- :disabled="!isComplete" -->
                                              <button
                                                v-if="
                                                  auth.isLibraryStaff === 1 &&
                                                  item.floor === 6
                                                "
                                                :disabled="!isCompleteAnothor"
                                                type="submit"
                                                class="btn btn-purple deep-purple btn-block badge-pill"
                                                data-dismiss="modal"
                                                @click="showModal = false"
                                              >
                                                ยืนยัน
                                              </button>
                                            </form>
                                          </div>
                                        </div>
                                      </b-modal>

                                      <b-modal
                                        :hide-footer="true"
                                        :hide-header="true"
                                        centered
                                        size="lg"
                                        :id="
                                          'modal-meeting2culumnMain' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        header-border-variant="white"
                                        class="border-bottom-0"
                                        v-if="!chkbookingroom"
                                      >
                                        <div
                                          class="card-body justify-content-center card-block p-3 text-center text-danger"
                                        >
                                          <h5>
                                            <i
                                              class="fa-solid fa-circle-exclamation"
                                            ></i>

                                            {{ msgbookingroom }}
                                          </h5>
                                        </div>
                                      </b-modal>
                                    </span>
                                  </div>
                                  <br />

                                  <span
                                    style="color: gray"
                                    v-if="item.room_id === 8"
                                  >
                                    <b-button
                                      pill
                                      variant="outline-primary"
                                      class="b-between"
                                      v-if="!showAcc[index]"
                                      @click="showAccessoriesMore(index)"
                                      size="sm"
                                    >
                                      อุปกรณ์
                                    </b-button>
                                    <b-button
                                      pill
                                      variant="outline-danger"
                                      class="b-between"
                                      v-if="showAcc[index]"
                                      @click="showAccessoriesLess(index)"
                                      size="sm"
                                    >
                                      ปิด
                                    </b-button>
                                    <br />
                                  </span>

                                  <span
                                    style="color: gray"
                                    v-if="item.room_id === 9"
                                  >
                                    <b-button
                                      pill
                                      variant="outline-primary"
                                      class="b-between"
                                      v-if="!showAcc[index]"
                                      @click="showAccessoriesMore(index)"
                                      size="sm"
                                    >
                                      อุปกรณ์
                                    </b-button>
                                    <b-button
                                      pill
                                      variant="outline-danger"
                                      class="b-between"
                                      v-if="showAcc[index]"
                                      @click="showAccessoriesLess(index)"
                                    >
                                      ปิด
                                    </b-button>
                                    <br />
                                  </span>
                                </div>
                              </div>

                              <span
                                style="color: gray"
                                v-if="item.room_id === 8"
                              >
                                <br />
                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/comstu1.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 2 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/moniterstu1.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> &nbsp;&nbsp;จอแสดงผล </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 3 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/camerastu1.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;กล้องบันทึกภาพวิดีโอ
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 4 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/saramonic.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;ไมค์ไร้สาย saramonic
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 5 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/switcherstu1.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;เครื่อง Switcher ภาพ
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 6 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/mixerstu1.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;เครื่องมิกซ์เสียง
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                  </div>
                                </span>
                              </span>

                              <span
                                style="color: gray"
                                v-if="item.room_id === 9"
                              >
                                <br />
                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/comstu2.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 2 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/imac.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> &nbsp;&nbsp; IMAC </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 3 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/moniterstu2.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> &nbsp;&nbsp;จอแสดงผล </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 4 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/camerastu1.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;กล้องบันทึกภาพวิดีโอ
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 5 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/camerastu1.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp; ไมค์ไร้สาย saramonic
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 6 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/mixerstu2.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp; เครื่องมิกซ์เสียง
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 7 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/camerastu1.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp; เครื่อง Switcher
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 8 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/viesonicpc.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp; เครื่อง Viesonic pc
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                  </div>
                                </span>
                              </span>
                            </div>

                            <!-- <hr /> -->
                            <!-- </div> -->
                          </div>
                        </div>
                        <div>
                          <!-- <b-button v-b-modal.modal-1>Launch demo modal</b-button> -->
                        </div>
                      </div>
                    </span>

                    <!-- =============================================== End Main Success Layout ================================== -->
                  </div>

                  <!-- </div>
            </div> -->
                </div>
              </div>
            </b-row>

            <!-- ######################################################  END  2 Culums ########################################################### -->
          </span>
        </b-tab>
        <b-tab title="ห้องบันทึกเสียง">
          <!-- Main -->
          <span v-if="!status_show">
            <b-row>
              <div class="container">
                <br />
                <div class="card-columns">
                  <div
                    class="card-room"
                    v-for="(item, index) in status_room"
                    :key="index"
                  >
                    <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  MAIN ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
                    <!-- ================================================ Teacher ==================================== -->
                    <span v-if="!isShowstaff">
                      <!-- <span v-if="item.room_id == 1 || item.room_id == 2"> -->
                      <div class="card-input">
                        <!-- v-if="item.status === 0 && item.freetimes.length !== 0" -->
                        <div
                          class="card card-order-list card-margin border-0 shadow-lg"
                          v-if="item.room_id === 10"
                        >
                          <div class="card-body">
                            <div class="row">
                              <div class="col-md-2 text-left">
                                <h6>{{ item.room_name }}</h6>

                                <img
                                  v-if="item.room_id === 10"
                                  src="../../assets/meetingrooms/rac.jpeg"
                                  alt=""
                                  class="zoom"
                                />
                              </div>

                              <div class="col-md-10 text-left">
                                <br />
                                <span class="text-secondary">
                                  **เลือกช่วงเวลาเพื่อจอง
                                  <div class="space"></div>
                                </span>
                                <div class="time-column">
                                  <span
                                    v-if="
                                      item.status === 1 ||
                                      (item.status === 0 &&
                                        item.freetimes.length === 0)
                                    "
                                  >
                                    <b-button
                                      pill
                                      variant="outline-secondary"
                                      disabled
                                      class="b-between"
                                    >
                                      08:30-12:00
                                    </b-button>

                                    <b-button
                                      pill
                                      variant="outline-secondary"
                                      disabled
                                      class="b-between"
                                    >
                                      13:00-16:00
                                    </b-button>
                                  </span>

                                  <span
                                    v-for="(prod, j) of item.freetimes"
                                    :key="j"
                                  >
                                    <b-button
                                      v-if="
                                        item.freetimes.length === 1 &&
                                        item.status === 0 &&
                                        prod.time_begin === '13:00'
                                      "
                                      pill
                                      variant="outline-secondary"
                                      disabled
                                      class="b-between"
                                    >
                                      08:30-12:00
                                    </b-button>

                                    <b-button
                                      pill
                                      v-if="
                                        prod.time_begin !== '08:30' ||
                                        prod.time_end !== '16:30'
                                      "
                                      variant="outline-pink"
                                      v-b-modal="
                                        'modal-meetingAnother' +
                                        item.room_id +
                                        prod.time_id
                                      "
                                      class="b-between"
                                      @click="getUsefor(item.room_id)"
                                    >
                                      {{ prod.time_begin }}-{{ prod.time_end }}
                                    </b-button>
                                    <span
                                      v-for="(timechkuser, iu) in historyall"
                                      :key="iu"
                                    >
                                      <b-button
                                        pill
                                        v-if="
                                          timechkuser.room_id ===
                                            item.room_id &&
                                          timechkuser.time_begin === '13:00' &&
                                          timechkuser.time_begin !==
                                            prod.time_begin &&
                                          item.freetimes.length === 1
                                        "
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        13:00-16:30
                                      </b-button>
                                    </span>

                                    <b-modal
                                      :hide-footer="true"
                                      centered
                                      size="lg"
                                      :id="
                                        'modal-meetingAnother' +
                                        item.room_id +
                                        prod.time_id
                                      "
                                      header-border-variant="white"
                                      class="border-bottom-0"
                                      v-if="chkbookingroom"
                                    >
                                      <template #modal-title>
                                        <div
                                          class="card card-order-list card-margin shadow border-light"
                                        >
                                          <div class="card-body">
                                            <i class="fa-solid fa-bookmark"></i>
                                            ห้อง {{ item.room_name }} เวลาจอง
                                            {{ prod.time_begin }} -
                                            {{ prod.time_end }}
                                          </div>
                                        </div>
                                      </template>

                                      <div
                                        class="card card-order-list card-margin shadow border-light"
                                      >
                                        <div class="card-body">
                                          <form
                                            class="form-group"
                                            @submit.prevent="
                                              bookingAnother(
                                                item.room_id,
                                                prod.time_begin,
                                                prod.time_end,
                                                prod.time_id,
                                                'modal-meetingAnother' +
                                                  item.room_id +
                                                  prod.time_id
                                              )
                                            "
                                          >
                                            <p style="color: blue">
                                              *หมายเหตุ :
                                              กรุณาเลือกวัตุประสงค์การใช้งาน
                                            </p>

                                            <b-form-select
                                              v-model="selected"
                                              :options="options"
                                              class="mb-3"
                                              value-field="usefor_id"
                                              text-field="usefor_name"
                                              disabled-field="notEnabled"
                                            >
                                              <template #first>
                                                <b-form-select-option
                                                  :value="null"
                                                  disabled
                                                  >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                >
                                              </template>
                                            </b-form-select>
                                            <span
                                              style="
                                                color: red;
                                                font-weight: bold;
                                              "
                                              v-if="
                                                error != '' || error === null
                                              "
                                            >
                                              ERROR : {{ error }}
                                              <br />
                                              <br />
                                            </span>
                                            <input
                                              type="text"
                                              class="form-control input-style"
                                              placeholder="กรอกวัตถุประสงค์"
                                              v-model="input_another"
                                              v-if="
                                                selected === 7 ||
                                                selected === 13 ||
                                                selected === 16
                                              "
                                            />

                                            <!-- :disabled="!isComplete" -->
                                            <button
                                              :disabled="!isCompleteTeach"
                                              type="submit"
                                              class="btn btn-purple deep-purple btn-block badge-pill"
                                              data-dismiss="modal"
                                              @click="showModal = false"
                                            >
                                              ยืนยัน
                                            </button>
                                          </form>
                                        </div>
                                      </div>
                                    </b-modal>

                                    <b-modal
                                      :hide-footer="true"
                                      :hide-header="true"
                                      centered
                                      size="lg"
                                      :id="
                                        'modal-meetingAnother' +
                                        item.room_id +
                                        prod.time_id
                                      "
                                      header-border-variant="white"
                                      class="border-bottom-0"
                                      v-if="!chkbookingroom"
                                    >
                                      <div
                                        class="card-body justify-content-center card-block p-3 text-center text-danger"
                                      >
                                        <h5>
                                          <i
                                            class="fa-solid fa-circle-exclamation"
                                          ></i>
                                          {{ msgbookingroom }}
                                        </h5>
                                      </div>
                                    </b-modal>
                                  </span>
                                </div>

                                <br />

                                <span
                                  style="color: gray"
                                  v-if="item.room_id === 10"
                                >
                                  <b-button
                                    pill
                                    variant="outline-primary"
                                    class="b-between"
                                    v-if="!showAcc[index]"
                                    @click="showAccessoriesMore(index)"
                                    size="sm"
                                  >
                                    อุปกรณ์
                                  </b-button>
                                  <b-button
                                    pill
                                    variant="outline-danger"
                                    class="b-between"
                                    v-if="showAcc[index]"
                                    @click="showAccessoriesLess(index)"
                                    size="sm"
                                  >
                                    ปิด
                                  </b-button>
                                  <br />
                                </span>
                              </div>
                            </div>

                            <span
                              style="color: gray"
                              v-if="item.room_id === 10"
                            >
                              <br />
                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/micrec.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;ชุดไมค์บันทึกเสียง
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 2 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/comrec.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 3 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/headphone.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> &nbsp;&nbsp;ชุดหูฟัง </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </span>
                          </div>
                          <!-- <hr /> -->
                        </div>
                      </div>
                      <!-- </span> -->
                    </span>
                    <!-- ================================================ End Teacher ================================ -->

                    <!-- ================================================ Student  ====================================-->
                    <span v-if="isShowstaff">
                      <div class="card-input">
                        <div
                          class="card card-order-list card-margin border-0 shadow-sm"
                          v-if="item.room_id === 10"
                        >
                          <div class="card-body">
                            <div class="row">
                              <div class="col-md-2 text-left">
                                <h6>{{ item.room_name }}</h6>
                                <!-- end -->
                                <img
                                  v-if="item.room_id === 10"
                                  src="../../assets/meetingrooms/rac.jpeg"
                                  alt=""
                                  class="zoom"
                                />
                              </div>

                              <div class="col-md-10 text-left">
                                <br />
                                <span class="text-secondary">
                                  **เลือกช่วงเวลาเพื่อจอง
                                  <div class="space"></div>
                                </span>
                                <div class="time-column">
                                  <span
                                    v-if="
                                      item.status === 1 ||
                                      (item.status === 0 &&
                                        item.freetimes.length === 0)
                                    "
                                  >
                                    <b-button
                                      pill
                                      variant="outline-secondary"
                                      disabled
                                      class="b-between"
                                    >
                                      08:30-12:00
                                    </b-button>

                                    <b-button
                                      pill
                                      variant="outline-secondary"
                                      disabled
                                      class="b-between"
                                    >
                                      13:00-16:00
                                    </b-button>
                                  </span>
                                  <span
                                    v-for="(prod, j) of item.freetimes"
                                    :key="j"
                                  >
                                    <span v-if="!user">
                                      <b-button
                                        v-if="
                                          item.freetimes.length === 1 &&
                                          item.status === 0 &&
                                          prod.time_begin === '13:00'
                                        "
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>
                                      <b-button
                                        v-if="
                                          item.freetimes.length === 1 &&
                                          item.status === 0 &&
                                          prod.time_begin === '16:30'
                                        "
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        13:00-16:30
                                      </b-button>

                                      <b-button
                                        pill
                                        v-if="
                                          prod.time_begin !== '08:30' ||
                                          prod.time_end !== '16:30'
                                        "
                                        variant="outline-pink"
                                        v-b-modal="
                                          'modal-meetingMain' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        class="b-between"
                                        @click="getUsefor(item.room_id)"
                                      >
                                        {{ prod.time_begin }}-{{
                                          prod.time_end
                                        }}
                                      </b-button>

                                      <span
                                        v-for="(timechkuse, iue) in historyall"
                                        :key="iue"
                                      >
                                        <b-button
                                          pill
                                          v-if="
                                            timechkuse.room_id ===
                                              item.room_id &&
                                            timechkuse.time_begin === '13:00' &&
                                            timechkuse.time_begin !==
                                              prod.time_begin &&
                                            item.freetimes.length === 1
                                          "
                                          variant="outline-secondary"
                                          disabled
                                          class="b-between"
                                        >
                                          13:00-16:30
                                        </b-button>
                                      </span>
                                    </span>

                                    <!-- if user :login  -->
                                    <span v-if="user">
                                      <b-button
                                        v-if="
                                          item.freetimes.length === 1 &&
                                          item.status === 0 &&
                                          prod.time_begin === '13:00'
                                        "
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>

                                      <b-button
                                        pill
                                        v-if="
                                          prod.time_begin !== '08:30' ||
                                          (prod.time_end !== '16:30' &&
                                            item.freetimes.length !== 0)
                                        "
                                        variant="outline-pink"
                                        class="b-between"
                                        href="/login"
                                      >
                                        {{ prod.time_begin }}-{{
                                          prod.time_end
                                        }}
                                      </b-button>

                                      <span
                                        v-for="(timechkuser, iu) in historyall"
                                        :key="iu"
                                      >
                                        <b-button
                                          pill
                                          v-if="
                                            timechkuser.room_id ===
                                              item.room_id &&
                                            timechkuser.time_begin ===
                                              '13:00' &&
                                            timechkuser.time_begin !==
                                              prod.time_begin &&
                                            item.freetimes.length === 1
                                          "
                                          variant="outline-secondary"
                                          disabled
                                          class="b-between"
                                        >
                                          13:00-16:30
                                        </b-button>
                                      </span>
                                    </span>

                                    <b-modal
                                      :hide-footer="true"
                                      v-if="chkbookingroom"
                                      centered
                                      size="lg"
                                      :id="
                                        'modal-meetingMain' +
                                        item.room_id +
                                        prod.time_id
                                      "
                                      header-border-variant="white"
                                      class="border-bottom-0"
                                    >
                                      <template #modal-title>
                                        <div
                                          class="card card-order-list card-margin shadow-sm border-light card-time-title"
                                        >
                                          <div class="card-body">
                                            <i class="fa-solid fa-bookmark"></i>
                                            ห้อง {{ item.room_name }} เวลาจอง
                                            {{ prod.time_begin }} -
                                            {{ prod.time_end }}
                                          </div>
                                        </div>
                                      </template>
                                      <div
                                        class="card card-order-list card-margin shadow-sm border-light card-time-body"
                                      >
                                        <div class="card-body">
                                          <form
                                            class="form-group"
                                            @submit.prevent="
                                              booking(
                                                item.room_id,
                                                prod.time_begin,
                                                prod.time_end,
                                                prod.time_id,
                                                'modal-meetingMain' +
                                                  item.room_id +
                                                  prod.time_id
                                              )
                                            "
                                            v-if="
                                              (auth.isLibraryStaff === 1 &&
                                                item.floor !== 6) ||
                                              auth.isLibraryStaff !== 1
                                            "
                                          >
                                            <b-form-select
                                              v-model="selected"
                                              :options="options"
                                              class="mb-3 input-style"
                                              value-field="usefor_id"
                                              text-field="usefor_name"
                                              disabled-field="notEnabled"
                                            >
                                              <template #first>
                                                <b-form-select-option
                                                  :value="null"
                                                  disabled
                                                  >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                >
                                              </template>
                                            </b-form-select>
                                            <input
                                              type="text"
                                              class="form-control input-style"
                                              placeholder="กรอกวัตถุประสงค์"
                                              v-model="input_another"
                                              v-if="
                                                selected === 7 ||
                                                selected === 13 ||
                                                selected === 16
                                              "
                                            />
                                            <p style="color: red">
                                              **หมายเหตุ : กรอกรหัสนักศึกษา
                                              {{ item.min_person }} คนขึ้นไป
                                            </p>
                                            <span
                                              style="color: red"
                                              v-if="
                                                error != '' || error === null
                                              "
                                            >
                                              **{{ error }}
                                            </span>
                                            <!-- <div class="space"></div> -->

                                            <b-row>
                                              <b-col
                                                cols="6"
                                                v-for="(
                                                  stdr, index
                                                ) in input_stdcode"
                                                :key="index"
                                              >
                                                <input
                                                  class="form-control input-style"
                                                  placeholder="กรอกรหัสนักศึกษา"
                                                  maxlength="11"
                                                  v-model="values[index]"
                                                />
                                              </b-col>
                                            </b-row>

                                            <button
                                              :disabled="!isComplete"
                                              type="submit"
                                              class="btn btn-purple deep-purple btn-block badge-pill"
                                              data-dismiss="modal"
                                              @click="showModal = false"
                                            >
                                              ยืนยัน
                                            </button>
                                          </form>

                                          <form
                                            class="form-group"
                                            @submit.prevent="
                                              bookingAnother(
                                                item.room_id,
                                                prod.time_begin,
                                                prod.time_end,
                                                prod.time_id,
                                                'modal-meetingMain' +
                                                  item.room_id +
                                                  prod.time_id
                                              )
                                            "
                                            v-if="
                                              auth.isLibraryStaff === 1 &&
                                              item.floor === 6
                                            "
                                          >
                                            <!-- Teacher -->
                                            <span>
                                              <b-button
                                                variant="outline-primary"
                                              >
                                                สำหรับอาจารย์
                                              </b-button>
                                            </span>
                                            <span
                                              style="
                                                color: red;
                                                font-weight: bold;
                                              "
                                              v-if="
                                                error != '' || error === null
                                              "
                                            >
                                              ERROR : {{ error }}
                                              <br />
                                              <br />
                                            </span>
                                            <b-row>
                                              <b-col cols="6">
                                                <input
                                                  class="form-control input-style"
                                                  placeholder="เบอร์โทรศัพท์"
                                                  maxlength="10"
                                                  v-model="
                                                    input_room_Teacher_phone
                                                  "
                                                />
                                              </b-col>
                                              <b-col cols="6">
                                                <input
                                                  class="form-control input-style"
                                                  placeholder="ชื่อ - นามสกุล"
                                                  v-model="
                                                    input_room_Teacher_name
                                                  "
                                                  autocomplete
                                                />
                                              </b-col>
                                              <!-- this.optionsfac -->
                                              <b-col cols="6">
                                                <b-form-select
                                                  v-model="selectedfac"
                                                  :options="optionsfac"
                                                  class="mb-3 input-style"
                                                  value-field="fac_code"
                                                  text-field="fac_name"
                                                  disabled-field="notEnabled"
                                                  @change="get_branch()"
                                                >
                                                  <!-- Teacher -->

                                                  <template #first>
                                                    <b-form-select-option
                                                      :value="null"
                                                      disabled
                                                      >เลือกคณะ</b-form-select-option
                                                    >
                                                  </template>
                                                </b-form-select>
                                              </b-col>
                                              <b-col cols="6">
                                                <b-form-select
                                                  v-model="selectedbranch"
                                                  :options="optionsbranch"
                                                  class="mb-3 input-style"
                                                  value-field="branch_code"
                                                  text-field="branch_name"
                                                  disabled-field="notEnabled"
                                                >
                                                  <!-- Teacher -->

                                                  <template #first>
                                                    <b-form-select-option
                                                      :value="null"
                                                      disabled
                                                      >เลือกสาขา</b-form-select-option
                                                    >
                                                  </template>
                                                </b-form-select>
                                              </b-col>
                                              <b-col cols="6">
                                                <input
                                                  class="form-control input-style"
                                                  placeholder="อีเมล"
                                                  maxlength=""
                                                  v-model="
                                                    input_room_Teacher_email
                                                  "
                                                  type="email"
                                                />
                                              </b-col>
                                              <b-col cols="6">
                                                <b-form-select
                                                  v-model="selected"
                                                  :options="options"
                                                  class="mb-3 input-style"
                                                  value-field="usefor_id"
                                                  text-field="usefor_name"
                                                  disabled-field="notEnabled"
                                                >
                                                  <!-- Teacher -->

                                                  <template #first>
                                                    <b-form-select-option
                                                      :value="null"
                                                      disabled
                                                      >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                    >
                                                  </template>
                                                </b-form-select>
                                                <input
                                                  type="text"
                                                  class="form-control input-style"
                                                  placeholder="กรอกวัตถุประสงค์"
                                                  v-model="input_another"
                                                  v-if="
                                                    selected === 7 ||
                                                    selected === 13 ||
                                                    selected === 16
                                                  "
                                                />
                                              </b-col>
                                            </b-row>

                                            <!-- :disabled="!isComplete" -->
                                            <button
                                              v-if="
                                                auth.isLibraryStaff === 1 &&
                                                item.floor === 6
                                              "
                                              :disabled="!isCompleteAnothor"
                                              type="submit"
                                              class="btn btn-purple deep-purple btn-block badge-pill"
                                              data-dismiss="modal"
                                              @click="showModal = false"
                                            >
                                              ยืนยัน
                                            </button>
                                          </form>
                                        </div>
                                      </div>
                                    </b-modal>

                                    <b-modal
                                      :hide-footer="true"
                                      :hide-header="true"
                                      centered
                                      size="lg"
                                      :id="
                                        'modal-meetingMain' +
                                        item.room_id +
                                        prod.time_id
                                      "
                                      header-border-variant="white"
                                      class="border-bottom-0"
                                      v-if="!chkbookingroom"
                                    >
                                      <div
                                        class="card-body justify-content-center card-block p-3 text-center text-danger"
                                      >
                                        <h5>
                                          <i
                                            class="fa-solid fa-circle-exclamation"
                                          ></i>
                                          {{ msgbookingroom }}
                                        </h5>
                                      </div>
                                    </b-modal>
                                  </span>
                                </div>
                                <br />

                                <span style="color: gray">
                                  <b-button
                                    pill
                                    variant="outline-primary"
                                    class="b-between"
                                    v-if="!showAcc[index]"
                                    @click="showAccessoriesMore(index)"
                                    size="sm"
                                  >
                                    อุปกรณ์
                                  </b-button>
                                  <b-button
                                    pill
                                    variant="outline-danger"
                                    class="b-between"
                                    v-if="showAcc[index]"
                                    @click="showAccessoriesLess(index)"
                                    size="sm"
                                  >
                                    ปิด
                                  </b-button>
                                  <br />

                                  <!-- End -->
                                </span>
                              </div>
                            </div>

                            <span
                              style="color: gray"
                              v-if="item.room_id === 10"
                            >
                              <br />
                              <span v-if="showAcc[index]">
                                <div class="card-columns-left-item">
                                  <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/micrec.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;ชุดไมค์บันทึกเสียง
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 2 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/comrec.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span>
                                            &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                          </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                  <!-- 3 -->
                                  <div
                                    class="card card-order-list card-margin border-light shadow"
                                  >
                                    <div class="card-body text-left">
                                      <b-row>
                                        <b-col cols="2">
                                          <img
                                            src="./../../assets/meetingrooms/headphone.jpeg"
                                            alt=""
                                            width="40"
                                            height="auto"
                                          />
                                        </b-col>
                                        <b-col cols="10">
                                          <span> &nbsp;&nbsp;ชุดหูฟัง </span>
                                        </b-col>
                                      </b-row>
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </span>
                          </div>
                          <!-- <hr /> -->
                          <!-- v-if="item.status === 0" -->
                        </div>

                        <div></div>
                      </div>
                    </span>
                    <!-- ================================================ End student ================================ -->
                    <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ END MAIN ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->

                    <!-- ######################################################  2 Culums #################################################################  -->

                    <!-- ######################################################  END  2 Culums ########################################################### -->
                  </div>
                </div>
              </div>
            </b-row>
          </span>

          <!-- 2 Culums -->
          <span v-if="status_show">
            <!-- ###################################################### 2 Culums #################################################################  -->
            <br />
            <b-row>
              <div class="col-md-4 text-left">
                <div class="card-columns">
                  <div class="card-room">
                    <div class="card-myroom">
                      <div
                        class="card card-order-list card-margin border-0 shadow-lg"
                      >
                        <div class="card-body card-body-size">
                          <h5 class="text-center">ห้องที่จอง</h5>
                        </div>
                      </div>

                      <!-- returned -->
                      <span v-for="(std, inx) in history" :key="inx">
                        <div
                          class="card card-order-list card-margin border-0 shadow"
                        >
                          <!-- v-if="std.trans_status !== 'returned'" -->
                          <div class="card-body">
                            <!-- approved -->
                            <span v-if="std.room_id === 10">
                              <span
                                class="text-danger"
                                v-if="std.trans_status === 'booked'"
                              >
                                <b>Scan qrcode เพื่อยืนยันการใช้งาน </b>
                              </span>

                              <span
                                class="text-info"
                                v-if="std.trans_status === 'confirmed'"
                              >
                                <b>ยืนยันการจองเรียบร้อย</b>
                              </span>

                              <span
                                class="text-success"
                                v-if="std.trans_status === 'approved'"
                              >
                                <b>อนุมัติการจอง</b>
                              </span>

                              <span
                                class="text-primary"
                                v-if="std.trans_status === 'endofuse'"
                              >
                                <b>เสร็จสิ้น</b>
                              </span>
                              <br />
                            </span>

                            <span> ผู้จอง : {{ auth.std_name }} </span> <br />
                            <span>
                              ห้อง : <b>{{ std.room_name }}</b></span
                            >
                            <br />
                            <span>
                              เวลา : {{ std.time_begin }} -
                              {{ std.time_end }}</span
                            >
                            <br />
                            <span>
                              วันจอง : {{ std.meeting_date | moment }}</span
                            >
                            <br />

                            <span class="" v-if="!readMore[inx]">
                              <span
                                style="color: hotpink; font-size: 14px"
                                class=""
                                v-if="!readMore[inx]"
                                @click="showMore(inx)"
                              >
                                <i class="fas fa-ellipsis-v"></i>
                                เพิ่มเติม
                              </span>
                            </span>
                            <span class="" v-if="readMore[inx]">
                              สมาชิก :
                              <span v-for="(pro, k) of std.students" :key="k">
                                {{ pro.std_name }},
                              </span>
                              <span
                                style="color: hotpink"
                                v-if="readMore[inx]"
                                @click="showLess(inx)"
                              >
                                [ย่อ]
                              </span>
                            </span>
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-8 text-left">
                <div class="card-columns">
                  <div
                    class="card-room"
                    v-for="(item, index) in status_room"
                    :key="index"
                  >
                    <!-- {{  item.freetimes.length}} -->
                    <!-- =============================================== Teacher Anothor Success Layout ================================== -->
                    <!-- แก้ไขเปลี่ยนโชว์ปุ่ม พร้อมอัพเดทสภถานะว่า มีการจองแล้ง Disable button -->
                    <span v-if="!isShowstaff">
                      <!-- v-if="item.room_id == 1 || item.room_id == 2" -->
                      <!-- modal-meeting2culumnTeacher -->
                      <span>
                        <div
                          class="card-input"
                          v-if="
                            item.status === 0 && item.freetimes.length !== 0
                          "
                        >
                          <div
                            class="card card-order-list card-margin border-0 shadow"
                            v-if="item.room_id === 10"
                          >
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-3 text-left">
                                  <h6>{{ item.room_name }}</h6>

                                  <img
                                    v-if="item.room_id === 10"
                                    src="../../assets/meetingrooms/rac.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                </div>

                                <div class="col-md-9 text-left">
                                  <br />
                                  <div class="time-column">
                                    <span
                                      v-if="
                                        item.status === 1 ||
                                        (item.status === 0 &&
                                          item.freetimes.length === 0)
                                      "
                                    >
                                      <b-button
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>

                                      <b-button
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        13:00-16:00
                                      </b-button>
                                    </span>

                                    <span
                                      v-for="(prod, j) of item.freetimes"
                                      :key="j"
                                    >
                                      <b-button
                                        v-if="
                                          item.freetimes.length === 1 &&
                                          item.status === 0 &&
                                          prod.time_begin === '13:00'
                                        "
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>

                                      <b-button
                                        pill
                                        v-if="
                                          prod.time_begin !== '08:30' ||
                                          prod.time_end !== '16:30'
                                        "
                                        variant="outline-pink"
                                        v-b-modal="
                                          'modal-meeting2culumnTeacher' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        class="b-between"
                                        @click="getUsefor(item.room_id)"
                                      >
                                        {{ prod.time_begin }}-{{
                                          prod.time_end
                                        }}
                                      </b-button>
                                      <span
                                        v-for="(timechkuser, iu) in historyall"
                                        :key="iu"
                                      >
                                        <b-button
                                          pill
                                          v-if="
                                            timechkuser.room_id ===
                                              item.room_id &&
                                            timechkuser.time_begin ===
                                              '13:00' &&
                                            timechkuser.time_begin !==
                                              prod.time_begin &&
                                            item.freetimes.length === 1
                                          "
                                          variant="outline-secondary"
                                          disabled
                                          class="b-between"
                                        >
                                          13:00-16:30
                                        </b-button>
                                      </span>

                                      <b-modal
                                        :hide-footer="true"
                                        centered
                                        size="lg"
                                        :id="
                                          'modal-meeting2culumnTeacher' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        header-border-variant="white"
                                        class="border-bottom-0"
                                        v-if="chkbookingroom"
                                      >
                                        <template #modal-title>
                                          <div
                                            class="card card-order-list card-margin shadow border-light"
                                          >
                                            <div class="card-body">
                                              <i
                                                class="fa-solid fa-bookmark"
                                              ></i>
                                              ห้อง {{ item.room_name }} เวลาจอง
                                              {{ prod.time_begin }} -
                                              {{ prod.time_end }}
                                            </div>
                                          </div>
                                        </template>

                                        <div
                                          class="card card-order-list card-margin shadow border-light"
                                        >
                                          <div class="card-body">
                                            <form
                                              class="form-group"
                                              @submit.prevent="
                                                bookingAnother(
                                                  item.room_id,
                                                  prod.time_begin,
                                                  prod.time_end,
                                                  prod.time_id,
                                                  'modal-meeting2culumnTeacher' +
                                                    item.room_id +
                                                    prod.time_id
                                                )
                                              "
                                            >
                                              <p style="color: blue">
                                                *หมายเหตุ :
                                                กรุณาเลือกวัตุประสงค์การใช้งาน
                                              </p>

                                              <b-form-select
                                                v-model="selected"
                                                :options="options"
                                                class="mb-3"
                                                value-field="usefor_id"
                                                text-field="usefor_name"
                                                disabled-field="notEnabled"
                                              >
                                                <template #first>
                                                  <b-form-select-option
                                                    :value="null"
                                                    disabled
                                                    >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                  >
                                                </template>
                                              </b-form-select>
                                              <span
                                                style="
                                                  color: red;
                                                  font-weight: bold;
                                                "
                                                v-if="
                                                  error != '' || error === null
                                                "
                                              >
                                                ERROR : {{ error }}
                                                <br />
                                                <br />
                                              </span>
                                              <input
                                                type="text"
                                                class="form-control input-style"
                                                placeholder="กรอกวัตถุประสงค์"
                                                v-model="input_another"
                                                v-if="
                                                  selected === 7 ||
                                                  selected === 13 ||
                                                  selected === 16
                                                "
                                              />

                                              <button
                                                :disabled="!isCompleteTeach"
                                                type="submit"
                                                class="btn btn-purple deep-purple btn-block badge-pill"
                                                data-dismiss="modal"
                                                @click="showModal = false"
                                              >
                                                ยืนยัน
                                              </button>
                                            </form>
                                          </div>
                                        </div>
                                      </b-modal>

                                      <b-modal
                                        :hide-footer="true"
                                        :hide-header="true"
                                        centered
                                        size="lg"
                                        :id="
                                          'modal-meeting2culumnTeacher' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        header-border-variant="white"
                                        class="border-bottom-0"
                                        v-if="!chkbookingroom"
                                      >
                                        <div
                                          class="card-body justify-content-center card-block p-3 text-center text-danger"
                                        >
                                          <h5>
                                            <i
                                              class="fa-solid fa-circle-exclamation"
                                            ></i>
                                            {{ msgbookingroom }}
                                          </h5>
                                        </div>
                                      </b-modal>
                                    </span>
                                  </div>
                                  <br />

                                  <span
                                    style="color: gray"
                                    v-if="item.room_id === 10"
                                  >
                                    <b-button
                                      pill
                                      variant="outline-primary"
                                      class="b-between"
                                      v-if="!showAcc[index]"
                                      @click="showAccessoriesMore(index)"
                                      size="sm"
                                    >
                                      อุปกรณ์
                                    </b-button>
                                    <b-button
                                      pill
                                      variant="outline-danger"
                                      class="b-between"
                                      v-if="showAcc[index]"
                                      @click="showAccessoriesLess(index)"
                                    >
                                      ปิด
                                    </b-button>
                                    <br />
                                  </span>
                                </div>
                              </div>

                              <span
                                style="color: gray"
                                v-if="item.room_id === 10"
                              >
                                <br />
                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/micrec.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;ชุดไมค์บันทึกเสียง
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 2 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/comrec.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 3 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/headphone.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> &nbsp;&nbsp;ชุดหูฟัง </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                  </div>
                                </span>
                              </span>
                            </div>
                            <!-- <hr v-if="item.status === 0" /> -->
                          </div>
                        </div>
                      </span>
                    </span>
                    <!-- =============================================== End AnothorSuccess Layout ================================== -->

                    <!-- =============================================== 2 culumn Main Success Layout ================================== -->
                    <span v-if="isShowstaff">
                      <div class="card-input">
                        <!-- v-if="item.status === 0 " -->
                        <!-- && item.freetimes.length !== 0 -->
                        <!-- <div class="card card-order-list card-margin border-0"> -->

                        <div class="card-input">
                          <div
                            class="card card-order-list card-margin border-0 shadow"
                            v-if="item.room_id === 10"
                          >
                            <div class="card-body">
                              <div class="row">
                                <div class="col-md-3 text-left">
                                  <h6>{{ item.room_name }}</h6>

                                  <img
                                    v-if="item.room_id === 10"
                                    src="../../assets/meetingrooms/rac.jpeg"
                                    alt=""
                                    class="zoom"
                                  />
                                </div>

                                <div class="col-md-9 text-left">
                                  <br />
                                  <span class="text-secondary">
                                    **เลือกช่วงเวลาเพื่อจอง
                                    <div class="space"></div>
                                  </span>

                                  <div class="time-column">
                                    <span
                                      v-if="
                                        item.status === 1 ||
                                        (item.status === 0 &&
                                          item.freetimes.length === 0)
                                      "
                                    >
                                      <b-button
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>

                                      <b-button
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        13:00-16:00
                                      </b-button>
                                    </span>
                                    <span
                                      v-for="(prod, j) of item.freetimes"
                                      :key="j"
                                    >
                                      <b-button
                                        v-if="
                                          item.freetimes.length === 1 &&
                                          item.status === 0 &&
                                          prod.time_begin === '13:00'
                                        "
                                        pill
                                        variant="outline-secondary"
                                        disabled
                                        class="b-between"
                                      >
                                        08:30-12:00
                                      </b-button>

                                      <b-button
                                        pill
                                        v-if="
                                          prod.time_begin !== '08:30' ||
                                          (prod.time_end !== '16:30' &&
                                            item.status === 0)
                                        "
                                        variant="outline-pink"
                                        v-b-modal="
                                          'modal-meeting2culumnMain' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        class="b-between"
                                        @click="getUsefor(item.room_id)"
                                      >
                                        {{ prod.time_begin }}-{{
                                          prod.time_end
                                        }}
                                      </b-button>

                                      <span
                                        v-for="(timechk, i) in history"
                                        :key="i"
                                      >
                                        <b-button
                                          pill
                                          v-if="
                                            timechk.room_id === item.room_id &&
                                            timechk.time_begin === '13:00' &&
                                            timechk.time_begin !==
                                              prod.time_begin &&
                                            item.freetimes.length === 1
                                          "
                                          variant="outline-secondary"
                                          disabled
                                          class="b-between"
                                        >
                                          13:00-16:30
                                        </b-button>
                                      </span>

                                      <b-modal
                                        :hide-footer="true"
                                        centered
                                        size="lg"
                                        :id="
                                          'modal-meeting2culumnMain' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        header-border-variant="white"
                                        class="border-bottom-0"
                                        v-if="chkbookingroom"
                                      >
                                        <template #modal-title>
                                          <div
                                            class="card card-order-list card-margin shadow border-light"
                                          >
                                            <div class="card-body">
                                              <i
                                                class="fa-solid fa-bookmark"
                                              ></i>
                                              ห้อง {{ item.room_name }} เวลาจอง
                                              {{ prod.time_begin }} -
                                              {{ prod.time_end }}
                                            </div>
                                          </div>
                                        </template>
                                        <div
                                          class="card card-order-list card-margin shadow border-light"
                                        >
                                          <div class="card-body">
                                            <form
                                              class="form-group"
                                              @submit.prevent="
                                                booking(
                                                  item.room_id,
                                                  prod.time_begin,
                                                  prod.time_end,
                                                  prod.time_id,
                                                  'modal-meeting2culumnMain' +
                                                    item.room_id +
                                                    prod.time_id
                                                )
                                              "
                                              v-if="
                                                (auth.isLibraryStaff === 1 &&
                                                  item.floor !== 6) ||
                                                auth.isLibraryStaff !== 1
                                              "
                                            >
                                              <b-form-select
                                                v-model="selected"
                                                :options="options"
                                                class="mb-3"
                                                value-field="usefor_id"
                                                text-field="usefor_name"
                                                disabled-field="notEnabled"
                                              >
                                                <template #first>
                                                  <b-form-select-option
                                                    :value="null"
                                                    disabled
                                                    >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                  >
                                                </template>
                                              </b-form-select>
                                              <input
                                                type="text"
                                                class="form-control input-style"
                                                placeholder="กรอกวัตถุประสงค์"
                                                v-model="input_another"
                                                v-if="
                                                  selected === 7 ||
                                                  selected === 13 ||
                                                  selected === 16
                                                "
                                              />
                                              <p style="color: red">
                                                **หมายเหตุ : กรอกรหัสนักศึกษา
                                                {{ item.min_person }}
                                                คนขึ้นไป
                                              </p>
                                              <span
                                                style="color: red"
                                                v-if="
                                                  error != '' || error === null
                                                "
                                              >
                                                **{{ error }}
                                              </span>
                                              <div class="space"></div>
                                              <b-row>
                                                <b-col
                                                  cols="6"
                                                  v-for="(
                                                    stdr, index
                                                  ) in input_stdcode"
                                                  :key="index"
                                                >
                                                  <input
                                                    class="form-control input-style"
                                                    placeholder="กรอกรหัสนักศึกษา"
                                                    maxlength="11"
                                                    v-model="values[index]"
                                                  />
                                                </b-col>
                                              </b-row>

                                              <!-- :disabled="!isComplete" -->

                                              <button
                                                :disabled="!isComplete"
                                                type="submit"
                                                class="btn btn-purple deep-purple btn-block badge-pill"
                                                data-dismiss="modal"
                                                @click="showModal = false"
                                              >
                                                ยืนยัน
                                              </button>
                                            </form>

                                            <!-- Teacher -->

                                            <form
                                              class="form-group"
                                              @submit.prevent="
                                                bookingAnother(
                                                  item.room_id,
                                                  prod.time_begin,
                                                  prod.time_end,
                                                  prod.time_id,
                                                  'modal-meeting2culumnMain' +
                                                    item.room_id +
                                                    prod.time_id
                                                )
                                              "
                                              v-if="
                                                auth.isLibraryStaff === 1 &&
                                                item.floor === 6
                                              "
                                            >
                                              <!-- Teacher -->
                                              <span>
                                                <b-button
                                                  variant="outline-primary"
                                                >
                                                  สำหรับอาจารย์
                                                </b-button>
                                              </span>
                                              <span
                                                style="
                                                  color: red;
                                                  font-weight: bold;
                                                "
                                                v-if="
                                                  error != '' || error === null
                                                "
                                              >
                                                ERROR : {{ error }}
                                                <br />
                                                <br />
                                              </span>
                                              <b-row
                                                v-if="
                                                  auth.isLibraryStaff === 1 &&
                                                  item.floor === 6
                                                "
                                              >
                                                <b-col cols="6">
                                                  <input
                                                    class="form-control input-style"
                                                    placeholder="เบอร์โทรศัพท์"
                                                    maxlength=""
                                                    v-model="
                                                      input_room_Teacher.phone
                                                    "
                                                  />
                                                </b-col>
                                                <b-col cols="6">
                                                  <input
                                                    class="form-control input-style"
                                                    placeholder="ชื่อ - นามสกุล"
                                                    maxlength=""
                                                    v-model="
                                                      input_room_Teacher.name
                                                    "
                                                  />
                                                </b-col>

                                                <b-col cols="6">
                                                  <b-form-select
                                                    v-model="selectedfac"
                                                    :options="optionsfac"
                                                    class="mb-3 input-style"
                                                    value-field="fac_code"
                                                    text-field="fac_name"
                                                    disabled-field="notEnabled"
                                                    @change="get_branch()"
                                                  >
                                                    <!-- Teacher -->

                                                    <template #first>
                                                      <b-form-select-option
                                                        :value="null"
                                                        disabled
                                                        >เลือกคณะ</b-form-select-option
                                                      >
                                                    </template>
                                                  </b-form-select>
                                                </b-col>
                                                <b-col cols="6">
                                                  <b-form-select
                                                    v-model="selectedbranch"
                                                    :options="optionsbranch"
                                                    class="mb-3 input-style"
                                                    value-field="branch_code"
                                                    text-field="branch_name"
                                                    disabled-field="notEnabled"
                                                  >
                                                    <!-- Teacher -->

                                                    <template #first>
                                                      <b-form-select-option
                                                        :value="null"
                                                        disabled
                                                        >เลือกสาขา</b-form-select-option
                                                      >
                                                    </template>
                                                  </b-form-select>
                                                </b-col>
                                                <b-col cols="6">
                                                  <input
                                                    class="form-control input-style"
                                                    placeholder="อีเมล"
                                                    maxlength=""
                                                    v-model="
                                                      input_room_Teacher_email
                                                    "
                                                    type="email"
                                                  />
                                                </b-col>

                                                <b-col cols="6">
                                                  <b-form-select
                                                    v-model="selected"
                                                    :options="options"
                                                    class="mb-3"
                                                    value-field="usefor_id"
                                                    text-field="usefor_name"
                                                    disabled-field="notEnabled"
                                                  >
                                                    <template #first>
                                                      <b-form-select-option
                                                        :value="null"
                                                        disabled
                                                        >เลือกวัตถุประสงค์การใช้งาน</b-form-select-option
                                                      >
                                                    </template>
                                                  </b-form-select>

                                                  <input
                                                    type="text"
                                                    class="form-control input-style"
                                                    placeholder="กรอกวัตถุประสงค์"
                                                    v-model="input_another"
                                                    v-if="
                                                      selected === 7 ||
                                                      selected === 13 ||
                                                      selected === 16
                                                    "
                                                  />
                                                </b-col>
                                              </b-row>

                                              <!-- :disabled="!isComplete" -->
                                              <button
                                                v-if="
                                                  auth.isLibraryStaff === 1 &&
                                                  item.floor === 6
                                                "
                                                :disabled="!isCompleteAnothor"
                                                type="submit"
                                                class="btn btn-purple deep-purple btn-block badge-pill"
                                                data-dismiss="modal"
                                                @click="showModal = false"
                                              >
                                                ยืนยัน
                                              </button>
                                            </form>


                                            <!-- =============================== -->
                                          </div>
                                        </div>
                                      </b-modal>

                                      <b-modal
                                        :hide-footer="true"
                                        :hide-header="true"
                                        centered
                                        size="lg"
                                        :id="
                                          'modal-meeting2culumnMain' +
                                          item.room_id +
                                          prod.time_id
                                        "
                                        header-border-variant="white"
                                        class="border-bottom-0"
                                        v-if="!chkbookingroom"
                                      >
                                        <div
                                          class="card-body justify-content-center card-block p-3 text-center text-danger"
                                        >
                                          <h5>
                                            <i
                                              class="fa-solid fa-circle-exclamation"
                                            ></i>

                                            {{ msgbookingroom }}
                                          </h5>
                                        </div>
                                      </b-modal>
                                    </span>
                                  </div>
                                  <br />

                                  <span
                                    style="color: gray"
                                    v-if="item.room_id === 10"
                                  >
                                    <b-button
                                      pill
                                      variant="outline-primary"
                                      class="b-between"
                                      v-if="!showAcc[index]"
                                      @click="showAccessoriesMore(index)"
                                      size="sm"
                                    >
                                      อุปกรณ์
                                    </b-button>
                                    <b-button
                                      pill
                                      variant="outline-danger"
                                      class="b-between"
                                      v-if="showAcc[index]"
                                      @click="showAccessoriesLess(index)"
                                    >
                                      ปิด
                                    </b-button>
                                    <br />
                                  </span>
                                </div>
                              </div>

                              <span
                                style="color: gray"
                                v-if="item.room_id === 10"
                              >
                                <br />
                                <span v-if="showAcc[index]">
                                  <div class="card-columns-left-item">
                                    <!-- <span v-for="(his, ind) in histories" :key="ind"> -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/micrec.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;ชุดไมค์บันทึกเสียง
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 2 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/comrec.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span>
                                              &nbsp;&nbsp;เครื่องคอมพิวเตอร์
                                            </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                    <!-- 3 -->
                                    <div
                                      class="card card-order-list card-margin border-light shadow"
                                    >
                                      <div class="card-body text-left">
                                        <b-row>
                                          <b-col cols="2">
                                            <img
                                              src="./../../assets/meetingrooms/headphone.jpeg"
                                              alt=""
                                              width="40"
                                              height="auto"
                                            />
                                          </b-col>
                                          <b-col cols="10">
                                            <span> &nbsp;&nbsp;ชุดหูฟัง </span>
                                          </b-col>
                                        </b-row>
                                      </div>
                                    </div>
                                  </div>
                                </span>
                              </span>
                            </div>

                            <!-- <hr /> -->
                            <!-- </div> -->
                          </div>
                        </div>
                        <div>
                          <!-- <b-button v-b-modal.modal-1>Launch demo modal</b-button> -->
                        </div>
                      </div>
                    </span>

                    <!-- =============================================== End Main Success Layout ================================== -->
                  </div>

                  <!-- </div>
            </div> -->
                </div>
              </div>
            </b-row>
            <!-- ######################################################  END  2 Culums ########################################################### -->
          </span>
        </b-tab>
      </b-tabs>
    </b-container>
    <!-- <div class="measure">
    <img src="../../assets/loykrathong/5C.png" alt="">
    </div> -->
    <div class="space"></div>

    <Footer />
  </div>
</template>

<script>
// import Navbar from "../layouts/navbar.vue";
import Footer from "../layouts/footer.vue";
import $ from "jquery";
import Navbar from "../layouts/navbar.vue";
import axios from "axios";

import VueHorizontalCalendar from "vue-horizontal-calendar";

import moment from "moment";
// import loginVue from "../auth0/login.vue";
export default {
  components: { Footer, Navbar, VueHorizontalCalendar },
  name: "Meeting",
  data() {
    return {
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      tokenjong: "NDMyMTNDNUYtRkZFNy00NjI1LUIwNTQtMkQ0QTkzOTIyQTM3",
      checked: true,
      auth: [],
      items: [],
      orders: [],
      value: "",
      hideRoom: false,
      slide: 0,
      sliding: null,
      dateTime: new Date(),
      choosedDay2: {
        dateFormat: "",
        year: "",
        month: "",
        date: "",
        day: "",
        timestamp: "",
      },
      showModal: false,
      status_room: [],
      input_stdcode: [{}],
      code: "",
      date: "",
      selected: null,
      selected2: null,
      selected3: null,
      options: [],
      optionsfac: [],
      selectedfac: null,
      optionsbranch: [],
      selectedbranch: null,
      dbroom: [],
      dbroomMax: "",
      dbroomMin: "",
      stdr: [],
      values: {},
      res: [],
      error: "",
      status_show: false,
      input_another: "",
      isShowstaff: false,
      input_room_Teacher: {
        phone: "",
        name: "name",
        fac: "",
        branch: "",
        email: "",
      },
      input_room_Teacher_name: "",
      input_room_Teacher_phone: "",
      input_room_Teacher_fac: "",
      input_room_Teacher_branch: "",
      input_room_Teacher_email: "",
      fac_code: "",
      branch_code: "",
      user: false,
      history: [],
      list: [],
      readMore: {},
      historyall: [],
      showAcc: {},
      chkbookingroom: "",
      chkDate: [],
      msgbookingroom: "",
      // show_input_teacher: false,
    };
  },
  computed: {
    // selected === 7 ||
    //                                           selected === 13 ||
    //                                           selected === 16
    isComplete() {
      var t;
      if (
        this.selected === 7 ||
        this.selected === 13 ||
        (this.selected === 16 && this.selected !== null)
      ) {
        t =
          (this.values[0] &&
            this.values[1] &&
            this.selected &&
            this.input_another) ||
          (this.values[0] &&
            this.values[2] &&
            this.selected &&
            this.input_another);
      } else {
        t =
          (this.values[0] && this.values[1] && this.selected) ||
          (this.values[0] && this.values[2] && this.selected);
      }
      return t;
    },
    isCompleteTeach() {
      var te;
      if (
        this.selected === 7 ||
        this.selected === 13 ||
        (this.selected === 16 && this.selected !== null)
      ) {
        te = this.selected && this.input_another;
      } else {
        te = this.selected;
      }
      return te;
    },
    isCompleteAnothor() {
      var s;
      if (
        this.selected === 7 ||
        this.selected === 13 ||
        (this.selected === 16 && this.selected !== null)
      ) {
        s =
          this.input_room_Teacher_name &&
          this.input_room_Teacher_phone &&
          this.selectedfac &&
          this.selectedbranch &&
          this.input_room_Teacher_email &&
          this.selected &&
          this.input_another;
      } else {
        s =
          this.input_room_Teacher_name &&
          this.input_room_Teacher_phone &&
          this.selectedfac &&
          this.selectedbranch &&
          this.input_room_Teacher_email &&
          this.selected;
      }

      return s;
    },
  },
  mounted() {
    this.getHistoryAll();
    this.getIP();
    // this.get_branch();
    this.get_fac();
    if (localStorage.getItem("auth") != null) {
      this.user = false;
      this.auth = JSON.parse(localStorage.getItem("auth"));
      this.code = this.auth.std_code;

      // console.log(this.input_room_Teacher.name);
      if (this.auth.user_type === "Teacher" || this.auth.isLibraryStaff === 0) {
        this.isShowstaff;
        this.input_room_Teacher_name = this.auth.std_name;
        this.fac_code = this.auth.fac_code;
        this.branch_code = this.auth.branch_code;
        (this.input_room_Teacher_phone = this.code),
          (this.input_room_Teacher_email = "");
        this.input_room_Teacher_fac = this.auth.fac_name;
        this.input_room_Teacher_branch = this.auth.branch_name;
      } else if (this.auth.user_type === "Student") {
        this.isShowstaff = true;
      }

      if (this.auth.isLibraryStaff === 1) {
        this.staff = true;
        this.input_room_Teacher_name = "";
        this.fac_code = "";
        this.branch_code = "";
        (this.input_room_Teacher_phone = ""),
          (this.input_room_Teacher_email = "");
        this.input_room_Teacher_fac = "";
        this.input_room_Teacher_branch = "";
      } else {
        this.staff = false;
      }

      if (localStorage.getItem("orders") != null) {
        this.loadOrder();
      }
    } else {
      this.user = true;
      this.isShowstaff = true;
    }
    this.getorders();
    if (localStorage.getItem("booking") != null) {
      this.loadBooking();
    }

    //
    window.setTimeout(function () {
      $(".alert")
        .fadeTo(500, 0)
        .slideUp(500, function () {
          $(this).remove();
        });
    }, 3000);
    //
    /*! Main */
    (function ($) {
      "use strict";

      var $navbar = $("#nav"),
        y_pos = $navbar.offset().top,
        height = $navbar.height();

      $(document).scroll(function () {
        var scrollTop = $(this).scrollTop();

        if (scrollTop > y_pos + height) {
          $navbar.addClass("fixed-top").animate({
            top: 0,
          });
          $navbar.addClass("shadow mb-5 bg-white rounded");
        } else if (scrollTop <= y_pos) {
          $navbar.removeClass("fixed-top").clearQueue().animate(
            {
              top: "-48px",
            },
            0
          );
          $navbar
            .removeClass("shadow p-3 mb-5 bg-white rounded")
            .clearQueue()
            .animate(
              {
                top: "-48px",
              },
              0
            );
        }
      });
    })($, undefined);
    // this.getHistory();
    setInterval(() => {
      this.getRoom();
      this.getHistory();
    }, 5000);

    $("#deployform").click(function () {
      $(this).addClass("open");
    });

    $(".cancel").click(function (e) {
      $(this).parent().removeClass("open");
      e.stopPropagation();
    });
  },
  filters: {
    moment: function (date) {
      moment.locale("th");
      return moment(date).add(543, "year").format("LL");
    },
  },
  methods: {
    get_branch() {
      const token = this.tokenjong;
      let data = {
        token: token,
        fac_code: this.selectedfac,
      };
      console.log(data);
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/room/get_branch_withfac",
          data,
          {
            headers,
          }
        )
        .then((res) => {
          this.optionsbranch = res.data.branches;
        });
    },
    get_fac() {
      const token = this.tokenjong;
      let data = {
        token: token,
        search_with_fac_code: "",
      };
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      axios
        .post("https://smartlibrary.ubru.ac.th/api/room/get_faculty", data, {
          headers,
        })
        .then((res) => {
          this.optionsfac = res.data.faculties;
        });
    },
    showAccessoriesMore(id) {
      this.$set(this.showAcc, id, true);
    },
    showAccessoriesLess(id) {
      this.$set(this.showAcc, id, false);
    },

    showMore(id) {
      this.$set(this.readMore, id, true);
      // if(id){
      //   this.readMore= true;
      // }
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
    getIP() {
      this.getIPAddress().then((res) => {
        this.ipAddress = res.data.ip;
        localStorage.setItem("IP", this.ipAddress);
      });
    },
    getIPAddress() {
      return axios.get("https://api.ipify.org/?format=json");
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    addFind() {
      this.stdr.push({ value: "" });
      // console.log("v modal ==", this.stdr);
    },
    ctrlShiftkey(e, keyCode) {
      return e.ctrlKey && e.shiftKey && e.keyCode == keyCode.charCodeAt(0);
    },
    getorders() {
      let data = {
        token: this.token,
        std_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };

      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/getorder", data, {
          headers,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.msg.status != 200) {
            alert(res.data.msg.message);
          } else {
            if (res.data.Orders !== null) {
              this.orders = res.data.Orders;
              for (var i in this.orders) {
                if (this.orders[i].order_status === 5) {
                  this.orders.splice(this.orders.indexOf(this.orders[i]), 1);
                }
              }

              localStorage.setItem("orders", JSON.stringify(this.orders));
              this.show = true;
            }
          }
        });
    },
    getUsefor(roomId) {
      this.showModal = true;
      this.selected = null;
      this.error = "";
      this.input_another = "";
      this.res = [];
      this.input_room_Teacher.phone = "";
      this.input_room_Teacher.name = "";
      this.input_room_Teacher.fac = null;
      this.input_room_Teacher.branch = null;
      this.input_room_Teacher.email = "";

      let data = {
        room_id: roomId,
      };
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post("https://smartlibrary.ubru.ac.th/api/step2_getusefor", data, {
          headers,
        })
        .then((res) => {
          this.dbroom = res.data.room;
          this.options = res.data.data;
          this.dbroomMax = res.data.room[0].max_person;
          this.dbroomMin = res.data.room[0].min_person;
          this.input_stdcode = [{}];
          this.values = {};
          for (var i = 1; i < this.dbroomMax; i++) {
            this.input_stdcode.push({ std: "" });
          }
        });
    },
    getRoom() {
      this.list = [];
      if (localStorage.getItem("auth") != null) {
        this.user = false;
        this.auth = JSON.parse(localStorage.getItem("auth"));
        this.code = this.auth.std_code;
        // console.log(this.auth);
        if (this.auth.user_type === "Teacher") {
          this.isShowstaff;
          // console.log("Teacher");
        } else if (
          this.auth.user_type === "Student" ||
          this.auth.isLibraryStaff != 0
        ) {
          this.isShowstaff = true;
          // console.log("Student");
        }

        if (this.auth.isLibraryStaff === 1) {
          this.staff = true;
        } else {
          this.staff = false;
        }

        if (localStorage.getItem("orders") != null) {
          this.loadOrder();
        }
      } else {
        this.user = true;
        this.isShowstaff = true;
        // console.log("anothor");
      }

      let data = {
        select_date: this.choosedDay2.dateFormat,
        test_code: this.code,
      };
      // console.log("datetime ====", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.getHistory();
      // this.$isLoading(true);
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/step1_getroom_status",
          data,
          { headers }
        )
        .then((res) => {
          // console.log(res);
          if (res.data.msg.status != 200) {
            // this.$isLoading(false);
            alert(res.data.msg.message);
          } else {
            // this.$isLoading(false);
            this.status_room = res.data.room_status;
            // console.log(this.status_room);
            this.histories = res.data.histories;
            this.status_room.forEach((item) => {
              if (item.freetimes.length !== 0) {
                this.list.push(item);
              }
              // console.log("chk", item, index);
            });
            // console.log("Room ", this.list);
          }
        });
    },
    getHistory() {
      // console.log(this.choosedDay2);
      // this.dateChange2(this.choosedDay2);
      let data = {
        select_date: this.choosedDay2.dateFormat,
        std_code: this.code,
      };
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post("https://smartlibrary.ubru.ac.th/api/get_history_per_std", data, {
          headers,
        })
        .then((res) => {
          // console.log("res history==", res.data.is_can_i_booking
          // );

          // this.statsut_show =  false;
          if (this.auth.length !== 0) {
            // console.log("code",this.auth);
            if (res.data.msg.status === 200) {
              this.history = res.data.histories;
              // this.chkbookingroom = true;
              this.chkbookingroom = res.data.is_can_i_booking;
              this.msgbookingroom = res.data.is_can_i_booking_msg;
              if (this.history.length === 0) {
                this.status_show = false;
              } else {
                this.status_show = true;
              }
            } else {
              alert(res.data.msg.message);
            }
          } else {
            // console.log("No code");
            this.status_show = false;
          }

          // if (
          //   this.history.trans_status !== "booked" ||
          //   this.history.trans_status !== "endofuse"
          // ) {
          //   // console.log("booked", this.chkbookingroom);
          //   this.status_show = true;
          // }
        });
      // getroom
    },
    loadOrder() {
      this.orders = JSON.parse(localStorage.getItem("orders"));
    },
    loadBooking() {
      this.items = JSON.parse(localStorage.getItem("booking"));
    },

    onContext(ctx) {
      this.context = ctx;
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    dateChange2(day) {
      // console.log("data day To",day);
      // this.chkDate = day;
      // console.log("checkdat",this.checkDate);
      this.list = [];
      if (localStorage.getItem("auth") != null) {
        this.user = false;
        this.auth = JSON.parse(localStorage.getItem("auth"));
        this.code = this.auth.std_code;
        // console.log(this.auth);
        if (this.auth.user_type === "Teacher") {
          this.isShowstaff;
          // console.log("Teacher");
        } else if (
          this.auth.user_type === "Student" ||
          this.auth.isLibraryStaff != 0
        ) {
          this.isShowstaff = true;
          // console.log("Student");
        }

        if (this.auth.isLibraryStaff === 1) {
          this.staff = true;
        } else {
          this.staff = false;
        }

        if (localStorage.getItem("orders") != null) {
          this.loadOrder();
        }
      } else {
        this.user = true;
        this.isShowstaff = true;
        // console.log("anothor");
      }

      this.choosedDay2 = day;
      this.date = this.choosedDay2.dateFormat;
      let data = {
        select_date: this.choosedDay2.dateFormat,
        test_code: this.code,
      };
      // console.log("datetime ====", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.getHistory();
      this.$isLoading(true);
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/step1_getroom_status",
          data,
          { headers }
        )
        .then((res) => {
          // console.log(res);
          if (res.data.msg.status != 200) {
            this.$isLoading(false);
            alert(res.data.msg.message);
          } else {
            this.$isLoading(false);
            this.status_room = res.data.room_status;
            // console.log(this.status_room);
            this.histories = res.data.histories;
            this.status_room.forEach((item) => {
              if (item.freetimes.length !== 0) {
                this.list.push(item);
              }
              // console.log("chk", item, index);
            });
            // console.log("Room ", this.list);
          }
        });
    },
    booking(room_id, time_begin, time_end, time_id, id) {
      // console.log(" another ==", this.input_another);
      this.list = [];

      let ip = localStorage.getItem("IP");

      for (var key of Object.keys(this.values)) {
        this.res.push(this.values[key]);
      }

      let data = {
        select_date: this.choosedDay2.dateFormat,
        room_id: room_id,
        time_id: time_id,
        time_begin: time_begin,
        time_end: time_end,
        usefor_id: this.selected,
        usefor_title: this.input_another,
        std_code: this.res,
        public_ip: ip,
        whois_std_code: this.code,
        isteacher: false,
      };
      // console.log("Booking",data,id);
      // console.log("Booking ===", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/step3_confirm", data, {
          headers,
        })
        .then((res) => {
          // console.log(" booking ==", res.data.room_status);
          if (res.data.msg.status === 200) {
            this.$isLoading(false);
            this.status_room = res.data.room_status;
            if (this.auth.length !== 0) {
              this.status_show = true;
            } else {
              this.status_show = false;
            }

            this.getHistory();
            // this.histories = res.data.histories;
            this.$bvModal.hide(id);
            this.status_room.forEach((item) => {
              if (item.freetimes.length !== 0) {
                this.list.push(item);
              }
              // console.log("chk", item, index);
            });
            //  router.push('/meetingRoom');
            // console.log("true Booking ");
          } else {
            this.$isLoading(false);
            this.error = res.data.msg.message;
            this.res = [];
          }

          // console.log(res.data);
        });
    },
    bookingAnother(room_id, time_begin, time_end, time_id, id) {
      this.list = [];
      let data;
      let ip = localStorage.getItem("IP");

      for (var key of Object.keys(this.values)) {
        this.res.push(this.values[key]);
      }
      if (this.auth.isLibraryStaff === 1) {
        data = {
          select_date: this.choosedDay2.dateFormat,
          room_id: room_id,
          time_id: time_id,
          time_begin: time_begin,
          time_end: time_end,
          usefor_id: this.selected,
          usefor_title: this.input_another,
          std_code: this.res,
          public_ip: ip,
          whois_std_code: this.code,
          teach_name: this.input_room_Teacher_name,
          teach_tel: this.input_room_Teacher_phone,
          teach_email: this.input_room_Teacher_email,
          fac_code: this.selectedfac,
          branch_code: this.selectedbranch,
          isteacher: true,
        };
      } else {
        data = {
          select_date: this.choosedDay2.dateFormat,
          room_id: room_id,
          time_id: time_id,
          time_begin: time_begin,
          time_end: time_end,
          usefor_id: this.selected,
          usefor_title: this.input_another,
          std_code: this.res,
          public_ip: ip,
          whois_std_code: this.code,
          teach_name: this.input_room_Teacher_name,
          teach_tel: this.input_room_Teacher_phone,
          teach_email: this.input_room_Teacher_email,
          fac_code: this.fac_code,
          branch_code: this.branch_code,
          isteacher: true,
        };
      }

      // console.log("Booking",data);
      // console.log("Booking Anthor===", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/step3_confirm", data, {
          headers,
        })
        .then((res) => {
          if (res.data.msg.status === 200) {
            this.$isLoading(false);
            this.status_room = res.data.room_status;
            if (this.auth.length !== 0) {
              this.status_show = true;
            } else {
              this.status_show = false;
            }
            // this.status_show = true;
            this.getHistory();
            this.histories = res.data.histories;
            this.$bvModal.hide(id);
            this.status_room.forEach((item) => {
              if (item.freetimes.length !== 0) {
                this.list.push(item);
              }
              // console.log("chk", item, index);
            });
            //  router.push('/meetingRoom');
            // console.log("true Booking ");
          } else {
            this.$isLoading(false);
            this.error = res.data.msg.message;
            this.res = [];
          }
        });

      // console.log(this.input_room_Teacher);
      // this.$bvModal.hide(id);
    },
    getHistoryAll() {
      let data = {
        select_date: this.choosedDay2.dateFormat,
        test_code: this.code,
      };
      // console.log("get story data ==", data);
      const token = this.tokenjong;
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      axios
        .post("https://smartlibrary.ubru.ac.th/api/get_history_all", data, {
          headers,
        })
        .then((res) => {
          // console.log("res historyAll==", res);
          if (this.auth.length !== 0) {
            if (res.data.msg.status === 200) {
              this.historyall = res.data.histories;
              if (this.history.length === 0) {
                this.status_show = false;
              } else {
                this.status_show = true;
              }
            } else {
              alert(res.data.msg.message);
            }
          } else {
            this.status_show = false;
          }
        });
    },
    // showInputTeacher() {
    //   this.show_input_teacher = true;
    // },
    // closeInputTeacher() {
    //   this.show_input_teacher = false;
    // },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@100;200&display=swap");

.tab-title-class {
  color: #ff0000 !important;
}
.nav-item a {
  color: #ffffff;
}
/* ======== */
.card-body-size {
  padding: 13px;
}
.card-body-size h5 {
  margin-top: 4px;
}
.card-time-body {
  border-radius: 20px;
}
.card-time-title {
  border-radius: 40px;
}
.on-line {
  width: 6%;
  height: auto;
}
.select-menu {
  max-width: 300px;
  margin: 50px auto;
}
.select-menu option {
  display: flex;
  height: 55px;
  background: #fff;
  padding: 20px;
  font-size: 18px;
  font-weight: 400;
  border-radius: 8px;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}
.select-menu option {
  position: absolute;
  width: 300px;
  overflow-y: auto;
  max-height: 295px;
  padding: 10px;
  margin-top: 10px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  animation-name: fadeInDown;
  -webkit-animation-name: fadeInDown;
  animation-duration: 0.35s;
  animation-fill-mode: both;
  -webkit-animation-duration: 0.35s;
  -webkit-animation-fill-mode: both;
}
.select-menu option {
  display: flex;
  height: 55px;
  cursor: pointer;
  padding: 0 16px;
  border-radius: 8px;
  align-items: center;
  background: #fff;
}
.select-menu option :hover {
  background: #f2f2f2;
}
.select-menu option i {
  font-size: 25px;
  margin-right: 12px;
}
.select-menu option .option-text {
  font-size: 18px;
  color: #333;
}
.select-btn i {
  font-size: 25px;
  transition: 0.3s;
}

.select-menu.active .select-btn i {
  transform: rotate(-180deg);
}
.select-menu.active .options {
  display: block;
  opacity: 0;
  z-index: 10;
  animation-name: fadeInUp;
  -webkit-animation-name: fadeInUp;
  animation-duration: 0.4s;
  animation-fill-mode: both;
  -webkit-animation-duration: 0.4s;
  -webkit-animation-fill-mode: both;
}
@keyframes fadeInUp {
  from {
    transform: translate3d(0, 30px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes fadeInDown {
  from {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  to {
    transform: translate3d(0, 20px, 0);
    opacity: 0;
  }
}

.card-content-more {
  position: relative;
}

.btn-floating {
  position: absolute;
  /* width: 46px;
  height: 40px;
  background: rgb(120, 90, 227);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 12px; */
  margin-bottom: -20px;
  right: 20px;
  top: 110px;
  /* top: -100px; */
  font-size: 20px;
  color: rgb(79, 159, 0);
  z-index: 666;
}
.text-time {
  display: flex;
  justify-content: center;
}
/* meeting room */

.horizontal-calendar {
  border-top: 0px !important;
  border: 0px;
}
.b-between {
  margin-right: 5px !important;
  margin-bottom: 5px;
}

.card .card_image {
  width: inherit;
  height: inherit;
  border-radius: 20px;
}

.card .card_image img {
  width: inherit;
  height: inherit;
  border-radius: 20px;
  object-fit: cover;
}
.space {
  height: 30px;
}
/* card */

.neworder-content {
  position: relative;
  right: 170px;
}

.card-content-more {
  position: relative;
  /*color: rgb(238, 33, 119);*/
  color: rgb(255, 95, 45);
}

.fa-purple {
  color: rgb(109, 7, 172);
}
.card-title {
  text-align: left;
  /* text-align: justify; */
  bottom: 10px;
}
.card-text {
  text-align: left;
  line-height: 23px;
  /* bottom: 5px; */
}

.form-group input {
  margin-bottom: 20px;
}
.form-group button {
  margin-bottom: 20px;
}
#button {
  border-radius: 30px;
}

.input-style {
  border-radius: 30px;
  background-color: #ffffff;
  border-color: #cecece;
  color: #000000;
}

.neworder-content {
  position: relative;
  right: 170px;
}
input::placeholder {
  color: rgb(204, 13, 13);
  /* font-size:18px; */
}

/* #ec376a */
.btn-purple {
  color: #fff;
  border-color: #000000;
  background-color: #000000;
}

.btn-purple:hover {
  color: #fff;
  border-color: #f7618c;
  background-color: #ce2b59;
}
.btn-purple:focus,
.btn-purple.focus {
  color: #fff;
  border-color: #f7618c;
  background-color: #ce2b59;
  box-shadow: 0 0 0 0.2rem rgba(180, 72, 112, 0.5);
}
.btn-purple.disabled,
.btn-purple:disabled {
  color: #fff;
  border-color: #000000;
  background-color: #000000;
}
.btn-purple:not(:disabled):not(.disabled):active,
.btn-purple:not(:disabled):not(.disabled).active,
.show > .btn-purple.dropdown-toggle {
  color: #fff;
  border-color: #000000;
  background-color: #f7618c;
}
.btn-purple:not(:disabled):not(.disabled):active:focus,
.btn-purple:not(:disabled):not(.disabled).active:focus,
.show > .btn-purple.dropdown-toggle:focus {
  /*rgba(180, 72, 112, 0.5);*/
  box-shadow: 0 0 0 0.2rem rgba(255, 109, 65, 0.468);
}

/*  */

.btn-outline-pink {
  /*#ed3d6f*/
  color: rgb(255, 95, 45);
  border-color: rgb(255, 95, 45);
}
.btn-outline-pink:hover {
  color: #fff;
  border-color: rgb(255, 95, 45);
  background-color: rgb(255, 95, 45);
}
.btn-outline-pink:focus,
.btn-outline-pink.focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 109, 65, 0.468);
}
.btn-outline-pink.disabled,
.btn-outline-pink:disabled {
  color: #000000;
  background-color: transparent;
}
.btn-outline-pink:not(:disabled):not(.disabled):active,
.btn-outline-pink:not(:disabled):not(.disabled).active,
.show > .btn-outline-pink.dropdown-toggle {
  color: #fff;
  border-color: #000000;
  background-color: #000000;
}
.btn-outline-pink:not(:disabled):not(.disabled):active:focus,
.btn-outline-pink:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-pink.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 109, 65, 0.468);
}
/* switch */

.ui-custom-select .current-value {
  background: #fff;
  padding: 14px 20px;
  border: 2px solid #eeeded;
  box-shadow: 0 4px 14px rgba(218, 221, 218, 0.4);
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;
  position: relative;
}

.ui-custom-select .current-value .arrow {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transition: all 0.3s;
}
.ui-custom-select .current-value .arrow .reverse {
  transform: rotate(-135deg);
}
.ui-custom-select .current-value .values {
  position: absolute;
  bottom: -25px;
  left: 0;
  right: 0;
  display: none;
  list-style: none;
  background: #fff;
  box-shadow: 0 4px 14px rgba(218, 221, 218, 0.4);
  border: 2px solid #eeeded;
  border-radius: 8px;
  padding: 8px 0;
  transform: translate(0, 100%);
}
.ui-custom-select .current-value .values .open {
  display: block;
}

.ui-custom-select .current-value .values .value {
  padding: 10px 25px;
  cursor: pointer;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.custom-select {
  border-radius: 1.1em !important;
  color: #1100ff;
  font-weight: bold;
}
.option {
  background: #000000 !important;
}
.modal-content {
  border-radius: 1rem !important ;
}

.card-columns .card {
  border-radius: 30px;
}
.calendar-list .card {
  border-radius: 20px;
}
/* card */
@media (min-width: 768px) {
  .card-columns {
    column-count: 1;
  }
  .card-room {
    column-count: 1;
  }
  .card-colum-me {
    column-count: 1;
  }
  .time-column {
    column-count: 2;
  }
  h6 {
    margin-top: 10px;
  }
  .card-columns-left-item {
    column-count: 1;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .card-columns {
    column-count: 1;
  }
  .card-room {
    column-count: 1;
  }
  .card-colum-me {
    column-count: 1;
  }
  .time-column {
    column-count: 2;
  }
  h6 {
    margin-top: 10px;
  }

  .on-line {
    width: 6%;
    height: auto;
  }
  .card-columns-left-item {
    column-count: 1;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .card-columns {
    column-count: 1;
  }
  .card-room {
    column-count: 1;
  }
  .card-colum-me {
    column-count: 1;
  }
  .time-column {
    column-count: 2;
  }
  h6 {
    margin-top: 10px;
  }
  .on-line {
    /* width: 8%; */
    height: auto;
  }
  .card-columns-left-item {
    column-count: 2;
  }
}

@media (max-width: 667px) {
  .on-line {
    width: 11%;
    height: auto;
  }
  .card-columns-left-item {
    column-count: 1;
  }
}

.zoom {
  padding: 25px;
  /* background-color: green; */
  transition: transform 0.2s;
  width: 160px;
  height: auto;
  margin: 0 auto;
  margin-left: -20px;
}

.zoom:hover {
  -ms-transform: scale(1.5); /* IE 9 */
  -webkit-transform: scale(1.5); /* Safari 3-8 */
  transform: scale(1.5);
}
.text-space {
  height: 50px;
}
.hidden {
  display: none;
}

.sticky-button {
  position: fixed;
  /* background-color: #d32562;; */
  background-color: rgb(255, 95, 45);
  bottom: 20px;
  right: 20px;
  border-radius: 50px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  z-index: 20;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55px;
  height: 55px;
  -webkit-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}

.sticky-button svg {
  margin: auto;
  fill: #fff;
  width: 35px;
  height: 35px;
}

.sticky-button a,
.sticky-button label {
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 55px;
  height: 55px;
  -webkit-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}

.sticky-button label svg.close-icon {
  display: none;
}

.sticky-chat {
  position: fixed;
  bottom: 70px;
  right: 20px;
  width: 320px;
  -webkit-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  z-index: 21;
  opacity: 0;
  visibility: hidden;
}

.sticky-chat a {
  text-decoration: none;
  font-family: "Roboto", sans-serif;
  color: #505050;
}

.sticky-chat svg {
  width: 35px;
  height: 35px;
}

.sticky-chat .chat-content {
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.25);
  overflow: hidden;
  font-family: "Kanit", sans-serif;
  font-weight: 400;
}

.sticky-chat .chat-header {
  position: relative;
  display: flex;
  align-items: center;
  padding: 15px 20px;
  background-color: rgb(255, 95, 45);
  overflow: hidden;
  font-family: "Kanit", sans-serif;
}

.sticky-chat .chat-header:after {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 80px;
  height: 75px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 70px 0 5px 0;
}

.sticky-chat .chat-header svg {
  width: 35px;
  height: 35px;
  flex: 0 0 auto;
  fill: #fff;
}

.sticky-chat .chat-header .title {
  padding-left: 15px;
  font-size: 14px;
  font-weight: bold;
  font-family: "Kanit", sans-serif;
  color: #fff;
}

.sticky-chat .chat-header .title span {
  font-size: 11px;
  font-weight: 400;
  display: block;
  line-height: 1.58em;
  margin: 0;
  color: #f4f4f4;
}

.sticky-chat .chat-text {
  display: flex;
  flex-wrap: wrap;
  margin: 10px 20px;
  font-size: 18px;
  font-family: "Kanit", sans-serif;
}

.sticky-chat .chat-text span {
  display: inline-block;
  margin-right: auto;
  padding: 10px;
  background-color: #f0f5fb;
  border-radius: 15px 15px 15px;
}

/* .sticky-chat .chat-text span:after {
  font-family: "Font Awesome 6 Free";
  content: "";
  display: inline-block;
  margin-left: 10px;
  font-size: 12px;
  color: #989b9f;
} */

.sticky-chat .chat-text span.typing {
  margin: 15px 0 0 auto;
  padding: 10px;
  border-radius: 15px 0px 15px 15px;
}

.sticky-chat .chat-text span.typing:after {
  display: none;
}

.sticky-chat .chat-text span.typing svg {
  height: 13px;
  fill: #505050;
  /* color:#d3256271; */
}

.sticky-chat .chat-button {
  display: flex;
  align-items: center;
  margin-top: 15px;
  padding: 12px 20px;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.25);
  overflow: hidden;
  font-size: 12px;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
}

.sticky-chat .chat-button svg {
  width: 20px;
  height: 20px;
  fill: #505050;
  margin-left: auto;
  transform: rotate(40deg);
  -webkit-transform: rotate(40deg);
}

.chat-menu:checked + .sticky-button label {
  -webkit-transform: rotate(360deg);
  transform: rotate(360deg);
}

.chat-menu:checked + .sticky-button label svg.chat-icon {
  display: none;
}

.chat-menu:checked + .sticky-button label svg.close-icon {
  display: table-cell;
}

.chat-menu:checked + .sticky-button + .sticky-chat {
  bottom: 90px;
  opacity: 1;
  visibility: visible;
}

/* loykhathong */
.loykrathong-triangle-line-left {
  background: red;
  border-top: 2px solid #b2b76f;
  width: 100%;
  position: relative;
  transform: rotateZ(0deg);
  z-index: 999;
  top: 0px;
}
.measure {
  position: relative;
  z-index: 999;
  width: 100%;
}
.measure img {
  position: absolute;
  transform: rotateZ(0deg);
  /* top:-200px; */
  margin-top: -470px;
  right: 40px;
}

/* color triangle */

.green {
  position: absolute;
  top: 0px;
  left: 0;
  width: 40px;
  height: 80px;
  border-left: solid 20px transparent;
  border-right: solid 20px transparent;
  border-top: solid 30px rgb(18, 131, 1);
  transform-origin: 50% 0;
}

.green-baby {
  position: absolute;
  top: 0px;
  left: 0;
  width: 40px;
  height: 80px;
  border-left: solid 20px transparent;
  border-right: solid 20px transparent;
  border-top: solid 30px rgb(88, 255, 58);
  transform-origin: 50% 0;
}
.yellow {
  position: absolute;
  top: 0px;
  left: 0;
  width: 40px;
  height: 80px;
  border-left: solid 20px transparent;
  border-right: solid 20px transparent;
  border-top: solid 30px rgb(246, 255, 0);
  transform-origin: 50% 0;
}
.dark-blue {
  position: absolute;
  top: 0px;
  left: 0;
  width: 40px;
  height: 80px;
  border-left: solid 20px transparent;
  border-right: solid 20px transparent;
  border-top: solid 30px rgb(4, 0, 240);
  transform-origin: 50% 0;
}

.orange {
  position: absolute;
  top: 0px;
  left: 0;
  width: 40px;
  height: 80px;
  border-left: solid 20px transparent;
  border-right: solid 20px transparent;
  border-top: solid 30px rgb(255, 111, 0);
  transform-origin: 50% 0;
}

.red {
  position: absolute;
  top: 0px;
  left: 0;
  width: 40px;
  height: 80px;
  border-left: solid 20px transparent;
  border-right: solid 20px transparent;
  border-top: solid 30px rgb(255, 0, 0);
  transform-origin: 50% 0;
}

.sky-blue {
  position: absolute;
  top: 0px;
  left: 0;
  width: 40px;
  height: 80px;
  border-left: solid 20px transparent;
  border-right: solid 20px transparent;
  border-top: solid 30px rgb(0, 229, 255);
  transform-origin: 50% 0;
}

.purple {
  position: absolute;
  top: 0px;
  left: 0;
  width: 40px;
  height: 80px;
  border-left: solid 20px transparent;
  border-right: solid 20px transparent;
  border-top: solid 30px rgb(153, 0, 255);
  transform-origin: 50% 0;
}
.green:nth-child(1) {
  /* animation: swing 0.8s ease-in-out forwards infinite; */
}

.orange:nth-child(2) {
  left: 90px;
  /* animation: swing 0.8s ease-in-out forwards infinite; */
}

.purple:nth-child(3) {
  left: 200px;
}

.dark-blue:nth-child(4) {
  left: 340px;
  /* animation: swing 0.8s ease-in-out forwards infinite; */
}
.red:nth-child(5) {
  left: 490px;
  /* animation: swing 0.8s ease-in-out forwards infinite; */
}

.sky-blue:nth-child(6) {
  left: 650px;
  /* animation: swing 0.8s ease-in-out forwards infinite; */
}

.green:nth-child(7) {
  left: 790px;
  /* animation: swing 0.8s ease-in-out forwards infinite; */
}
.dark-blue:nth-child(8) {
  left: 950px;
  /* animation: swing 0.8s ease-in-out forwards infinite; */
}

.yellow:nth-child(9) {
  left: 1100px;
  /* animation: swing 0.8s ease-in-out forwards infinite; */
}

.orange:nth-child(10) {
  left: 1250px;
  /* animation: swing 0.8s ease-in-out forwards infinite; */
}
.purple:nth-child(11) {
  left: 1400px;
}

.red:nth-child(12) {
  left: 1530px;
}

.green-baby:nth-child(13) {
  left: 1640px;
}

.sky-blue:nth-child(14) {
  left: 1760px;
  /* animation: swing 0.8s ease-in-out forwards infinite; */
}
/* swing */
@keyframes swing {
  0% {
    transform: rotate(10deg);
  }
  50% {
    transform: rotate(-5deg);
  }
  100% {
    transform: rotate(10deg);
  }
}

@keyframes fly {
  0% {
    transform: translateX(-100vw);
  }
  100% {
    transform: translateX(100vw);
  }
}

@keyframes smoke {
  0% {
    transform: translateX(100vw);
  }
  100% {
    transform: translateX(-100vw);
  }
}

/* end */
/* test */
</style>
